import { AfterViewInit, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

import { PatientNotesDialogComponent } from "../core/patient-notes-dialog/patient-notes-dialog.component";
import { catchError, map, switchMap, take, takeUntil } from "rxjs/operators";
import { PatientRegistrationService } from "../regservices/Spatient-registration.service";
import { DatePipe } from "@angular/common";
import { mandatoryFields } from "../regproperties/field-mandatory-properties";
import { opdNavigation } from "../regproperties/opd-navigation-properties";
import { OPD_API_URL } from "../regproperties/opd-url-properties";

import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
import { forkJoin, Observable, of, ReplaySubject, Subject } from "rxjs";
import { Subscription } from "rxjs/internal/Subscription";
import { removeSpaces } from "../regservices/helper.service"; 
import { MyKadData } from "../regmodels/MmyKadData";
import { PatientSearchModel } from "../regmodels/MpatientSearchModel";
import { GeneralUrlService } from "../regservices/SgeneralUrl.service";
import { mandatoryFieldsService } from "../regservices/SmandatoryFields.service";
import { MasterUrlService } from "../regservices/SmasterUrl.service";
import { patientGetDataservice } from "../regservices/SpatientGetData.service";
import { SearchHeaderService } from "../regservices/SsearchHeader.service";
import { CameraDialogComponent } from "../regshared/camera-dialog/camera-dialog.component";
import { RegsuccessDialogComponent } from "../regshared/regsuccess-dialog/regsuccess-dialog.component";
import { UploadfileComponent } from "../regshared/uploadfile/uploadfile.component";
import {
  OPD_REPORT_NAME,
  OPD_REPORT_TYPE,
} from "../regproperties/opd-report-properties";
import { PatientAppointmentDialogComponent } from "./patient-appointment-dialog/patient-appointment-dialog.component";
import { saveAs } from "file-saver";
import { BirthPlaceList } from "../regproperties/birth-place";
import { ManditoryKayEnum, MasterKeys, MasterMenus } from "../constants/configuration-modules.constants";
import { CriticalHealth, Identification, qmsPatientDetails, secondIdType } from "../regmodels/MpatientRegistration";
import { PatientLableService } from "../regservices/patient-lable.service";
import { EncounterSlipService } from "../regservices/encounter-slip.service";
import { PdpaFormService } from "../regservices/pdpa-form.service";
import { DocumentUploadEnum, dupicatePatient, Langauge, MasterSubMenus } from "../enums/configuration-modules.enum";
import { ViewDocumentComponent } from "../regshared/view-document/view-document.component";
import { MatTabChangeEvent, MatTabGroup } from "@angular/material/tabs";
import { CopDecimalCalculateService } from "../services/cop-decimal-calculate.service";
import { STATICCODESERVICE } from "../constants/static-code-service";
import { statisGlApprovalType } from "../update-sponsor/encounter-status.enum";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { MASTERSSERVICES } from "../constants/master-service";
import { PatientEncounterPayer, PatientNextOfKin, PatientRegistration } from "../services/RegistationModel";
import { SigninModalComponent } from "../authentication/signin-modal/signin-modal.component";
import { APPLICATIONSERVICE } from "../constants/application-service";
import { MICROSERVICES } from "../constants/web-services";
import { ConfirmDialogComponent } from "../core/confirm-dialog/confirm-dialog.component";
import { ConfirmDynamicDialogComponent } from "../core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
import { InfoDialogComponent } from "../core/info-dialog/info-dialog.component";
import { MultiLanguageService } from "../core/multi-language/multi-language.service";
import { ApplicationConfigService } from "../services/application-config.service";
import { AuthService } from "../services/auth.service";
import { EnvoirnmentService } from "../services/envoirnment.service";
import { FileUploadService } from "../services/file-upload.service";
import { AppBaseService } from "../services/http.service";
import { PatientService } from "../services/patient.service";
import { ReportService } from "../services/report.service";
import { SearchService } from "../services/search.service";
import { UtilsService } from "../services/utils.service";
import { OPD_CONST } from "../regproperties/opd-static-properties";
import { EncounterAppointmnetComponent } from "../regshared/encounter-appointmnet/encounter-appointmnet.component";
import { thEnConverterService } from "../services/thEnConverterService";
import { baseObject } from "../update-sponsor/sponsorinterfaces/IerRegistration";
import { CookieService } from "ngx-cookie-service";
import { ShortcutService } from "../services/shortcut.service";
import { DuplicatePatientService } from "../regservices/SduplicatePatient.service";
import { AesEncryptionService } from "../services/aes-encryption.service";
import { CARD_READER_TYPE } from "../constants/card-reader-constants";
import { CardReaderService } from "../services/card-reader.service";
import { CriticalHeilthInfoComponent } from "../regshared/critical-heilth-info/critical-heilth-info.component";
import { ConfirmRemarksComponent } from "../update-sponsor/confirm-remarks/confirm-remarks.component";

@Component({
  selector: "app-patient-registration",
  templateUrl: "./patient-registration.component.html",
  styleUrls: ["./patient-registration.component.scss"],
  providers: [DatePipe],
})
export class PatientRegistrationComponent implements OnInit, OnDestroy,AfterViewInit {
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  formRegistration: FormGroup;
  selectedOption = [];

  formEncounter: FormGroup;

  formNextOfKin: FormGroup;

  formHealthTourist: FormGroup;
  otherDetail: FormGroup;

  //Registration Fields
  primaryIdList: any[] = [];
  secondaryIdList: any[] = [];
  secondaryIdFilteredList: any[] = [];
  prefixList: any[] = [];
  genderList: any[] = [];
  raceList: any[] = [];
  religionList: any[] = [];
  relationList: any[] = [];
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  subDistrictPrimaryList: any[] = [];
  countrySecondaryList: any[] = [];
  stateSecondaryList: any[] = [];
  citySecondaryList: any[] = [];
  isDisabled: boolean = false;
  healthTouristList: any[] = [];
  healthTouristDetailsDTO: any[] = [];
  countryEmploymentList: any[] = [];
  stateEmploymentList: any[] = [];
  cityEmploymentList: any[] = [];
  kinData: any[] = [];
  raceMasterSearch:FormControl=new FormControl();
  raceFilterList:any[]=[];
  subDistrictSecondaryList: any[] = [];
  employerList: any[] = [];
  primaryIdSearch: FormControl = new FormControl();
  secondaryIdSearch: FormControl = new FormControl();
  reportResonMrdSearch: FormControl = new FormControl();  
  countrySearch: FormControl = new FormControl();
  pendingOrderCount: any = 0;
  showBadge:boolean=false;
  //Encounte Fields
  healthPackageList: any[] = [];
  multiLangDoctorList: any[] = [];
  doctorFilteredList: any[] = [];
  payerList: any[] = [];
  payerTypeList: any[] = [];
  docTypeList: any[] = [];
  docTypeFilteredList: any[] = [];
  payerTypeFilteredList: any;
  tariffList: any[] = [];
  associatedCompanyList: any[] = [];
  glTypeList: any[] = [];
  nokList: any[] = [];
  departmentList:any[]=[];
  departmentFilterList:any[]=[];
  dipartmentSearch: FormControl = new FormControl()
  doctorSearch: FormControl = new FormControl();
  docTypeSearch: FormControl = new FormControl();
  payerTypeSearch: FormControl = new FormControl();
  payerSearch: FormControl = new FormControl();
  tariffSearch: FormControl = new FormControl();
  contractCodeSearch: FormControl = new FormControl();
  associatedCompanySearch: FormControl = new FormControl();
  //**Declaration variables */
  masterAPI: any = MASTERSSERVICES;
  mandatoryField: any = { ...mandatoryFields };
  showField: any = { ...mandatoryFields };
  patientImage: string = "";
  patientForm: boolean = false;
  isDepartment: boolean = true;
  isVip: boolean=false;
  guarantor: string = "";
  nationalityWiseRace: any[] = [];
  hidePatientSearch = false;
  patientInfoDisplay: string = "";
  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDate();
  minDate = moment().add(-200, 'year').toDate();
  today: Date = new Date();
  maxDate = new Date(this.year, this.month, this.day);
  maxExpiry = new Date(this.year + 20, this.month, this.day);
  isOtherDetailsShow: boolean = false;
  private subscriptionList = new Subscription();
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  search: PatientSearchModel = new PatientSearchModel();
  mandatorykeys: mandatoryFieldsService = new mandatoryFieldsService();
  searchCriteria: any = null;
  patientList: any[] = [];
  previousEncounterList: any[] = [];
  fileUploadList: any[] = [];
  fileUploadRegList: any[] = [];
  fileType: string = "";
  refreshTime: string = "";
  healthPackage: any = [];
  reportReasonList: any = [];
  reportReasonFilterdList: any = ([] = []);
  primaryIdRegex: string = OPD_CONST.primaryIdRegix;
  secondaryIdeRegex: string = OPD_CONST.primaryIdRegix;
  faxRegex: string = OPD_CONST.faxRegex;
  remark: string = '';
  tempPatientRef: {
    system: string;
    code: String;
    display: string;
  } = {
    system: "",
    code: "",
    display: "",
  };
  patientAge: {
    years: string;
    months: string;
    days: string;
  } = {
    years: "",
    months: "",
    days: "",
  };

  appointmentReference: {
    appointmentId: string;
    tempPatientId: string;
    trnNumber: string;
    doctorCode: string;
    departmentCode: string;
    appointmentDate?:string;
    healthPackage: any;
    bookingType: string;
    appointmentNo?:string;
  } = {
    appointmentId: "",
    tempPatientId: "",
    trnNumber: "",
    doctorCode: "",
    departmentCode: "",
    healthPackage: [],
    bookingType: "",
  };

  displayedColumnsEncounters: string[] = OPD_CONST.displayColumnEncounters;
  dataSourceEncounters = new MatTableDataSource<any>([]);

  displayedColumnsPayers: string[] = OPD_CONST.displayColumnPayersReg;
  dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>([]);

  displayedColumnsNOKs: string[] = OPD_CONST.displayColumnNok;
  dataSourceNextOfKin = new MatTableDataSource<PatientNextOfKin>([]);

  healthTouristColumns = OPD_CONST.healthTouristColumns;
  healthTouristSource = new MatTableDataSource();

  fileUploadColumns = OPD_CONST.fileUploadColumns;
  fileSource = new MatTableDataSource();
  displayColumnsPendingOrders: string[] = OPD_CONST.displayColumnsPendingOrders;
  groupedItems: any = [];
  isSelected: boolean = false;
  fileSourceReg = new MatTableDataSource();
  formData: FormData = new FormData();
  selectedPatient: any = null;
  patientId: string = "";
  encounterid: string = "";
  visitno: string = "";
  patientTRN: string = "";
  username: any;
  userId: any;
  usermasterid: any;
  userRightList: any = [];
  isPatientEditRights: boolean = false;
  selected: string;
  isDeceased: boolean = false;
  isRadioactiveImplant: boolean = false;

  isPrimaryId: boolean = false;
  CountryCode: any = null;
  StateCode: any = null;
  CityCode: any = null;

  secondaryCountryCode: any = null;
  secondaryStateCode: any = null;
  secondaryDistrictCode: any = null;

  employmentCountryCode: any = null;
  employmentStateCode: any = null;

  nokCountryCode: any = null;
  nokStateCode: any = null;
  nokCityCode: any = null;
  autoSecondarySubDistrictCode: string = "";

  internalNotesList: any[] = [];
  previousInternalNotes: any[] = [];
  internotesEncounterid: any;

  payeeInfoList: {};
  payeeInfoResult: any[] = [];
  payeePrevInfoResult: any[] = [];

  contractList: any[] = [];
  selectedContact: any;

  isRegistered: boolean = false;
  isSameAddress: boolean = false;
  isexpiryDate: boolean = false;
  isSeondaryExpiryDate: boolean = false;

  countryValue: any = null;
  stateValue: any = null;
  cityValue: any = null;
  districtValue: any = null;
  postCodeValue: any = null;
  countryCodeValue: any = null;
  getCountryValue: any = null;
  getStateValue: any = null;
  getCityValue: any = null;
  getDistrictValue: any = null;

  genderValue: any = null;
  identifierTypeValue: any = null;
  titleValue: any = null;
  patientCategory: any = null;
  religionValue: any = null;
  raceValue: any = null;

  countrySecondaryValue: any = null;
  stateSecondaryValue: any = null;
  citySecondaryValue: any = null;
  districtSeoncdaryValue: any = null;

  countryEmploymentValue: any = null;
  stateEmploymentValue: any = null;
  cityEmploymentValue: any = null;

  primaryIdentifierListModified: boolean = false;
  secondaryIdentifierListModified: boolean = false;
  patientNotesUpdated: boolean = false;
  referralTypeCode: any = null;
  documentTypelist: any[] = [];
  docFileType: any;
  encounterTypeValue: any = null;
  departmentValue: any = null;
  doctorValue: any = null;
  doctorValueappointment: any = null;

  isAdmissionRequest: boolean = false;
  isAppointmentHsc: boolean = false;
  admissionReqload: any;
  isBothAddressSame: boolean = false;
  @ViewChild(MatTable) table: MatTable<any>;
  unitName: string;
  unitCode: string;
  resdata: any;
  appointmentData: any = null;
  mrdDepartment: any;

  medicalReport: boolean = false;
  employer: boolean = false;
  payerFilteredList: any;
  tariffFilteredList: any;
  contractCodeList: any;
  associatedCompanyCodeList: any;
  docList: any;
  primaryIdFilteredList: any[];
  reportTypeMrd: null;
  reportResonMrd: null;
  secondaryExpirydate: any;
  admissionStatus: boolean;
  identificationTypeList: any[];
  isToken: boolean = false;
  isUpdateRequired: boolean = false;
  isAddeassByPostCode: boolean = false;
  isGetAddress: boolean = false;
  tokenNoValue: string = "";
  isPatientType: string = "";
  isPatientCategory: boolean = false;
  existingPayerList: any;
  imageUrl: string;
  MasterStaffCode: string;
  MasterStudentCode: string;
  defaultGender: {
    id: number;
    code: string;
    desc: string;
  };
  isNOKRequired:boolean=false;
  isBackAllow:boolean=false;
  isStaffActive:boolean=false;
  isEncounterAllow:boolean=false;
  isNationDependant:boolean =false;
  isFirstPayerPriority:boolean;
  mobileNoMin:number=8;
  mobileNoMax:number=14;
  isDefaultDeposit:boolean = false;
  isClinicReqired: boolean;
  isGetClinicElement:boolean;
  orgCode: string='';
  PatientData: any=[];
  isPatientRequired:boolean=false;
  defaultCountry:string='';
  defaultNationality:string='';
  docListRegistration: any[]=[];
  docListEncounter: any[]=[];
  contractValue: any=[];
  pdpaForm: boolean = false;
  defaultDeposit: string = "";
  showDefaultDeposit: boolean = true;
  reasonCode: object;
  selectedPrimaryId: string;
  output: string;
  isPrimaryNoEditable: boolean=false;
  isFromAppointment: boolean=false;
  language:string="";
  consultationChargesDuringvisit: string = "";
  consultationCharge: baseObject;
  autoBillScreenRedirection: string = "";
  userAutho: any;
  genderCode: any = [];
  isOtherReferral: boolean = false;
  othersReferral:string="";
  primaryIdNewValue :string;
  valuelist: any;
  primaryIdCode: any;
  tariffCompanyList: any;
  defaultNewTariff: any;
  isDisableTariff: boolean = false;
  defaultTariff: any;
  ispatientNameLtwo:boolean=false;
  isFullName:boolean=false;
  showAllIdentificationTypes: boolean = false;
  isCompany: boolean = false;
  isContract: boolean = false;
  isNewBorn: boolean=false;
  babyOfPrefixCode: string="";
  maxIdentificationLength:number=25;
  minIdentificationLength:number=0;
 
  displayedColumns: string[] = OPD_CONST.identificationTable;
  identificationList = new MatTableDataSource<Identification>([]);
  @ViewChild(MatTable) tableidentification!: MatTable<Identification>;
  selectedPatientIdentificationList:Identification[]=[];
  public triggerAddPatient$ = new Subject<void>();
  private shortcutSub!: Subscription;
  uhId: string = "";
  isFromAnotherunit: boolean = false;
  private duplicateCheckCalled: { [key: string]: boolean } = {
    identificationNo: false,
    dateOfBirth: false,
    mobileNumber: false
  };
  isEditNok: boolean=false;
  nokId: string = "";
  nokIid:number;
  primaryIdFilteredListNok: any[] = [];
  primaryIdListNOK: any[] = [];
  primaryIdSearchNok: FormControl = new FormControl();
  titleDefaultValue: string = "";
  relationDefaultValue: string = "";
  countryDefaultValue: string = "";
  stateDefaultValue: string = "";
  cityDefaultValue: string = "";
  isUnitWisePatientSearch: boolean=false;
  isFromAnotherScreen: boolean = false;
  isAiImageSearch: boolean= false;
  tokenValue:string="";
  qmsPatientDetails:qmsPatientDetails;
  isAllowToDecease: boolean = false;
  cardReaderStatus: boolean = false;
  enableCardReaderBtn: boolean = false;
  areaDefaultValue : string="";
  nokAreaCode: baseObject;
  rePrintSlip: boolean = false;
  orgName: string='';
  emergencyPatientPayload: any;
  isEmergency: boolean = false;
  quickRegPayload:any;
  isFromQuickReg:boolean=false;
  displayedColumnsCriticalHeailthInactive: string[] = OPD_CONST.displayedColumnsCriticalHeailthInactive;
  displayedColumnsCriticalHeailthActive: string[] = OPD_CONST.displayedColumnsCriticalHeailthActive;
  dataSourceCriticalHeailthInactive = new MatTableDataSource<CriticalHealth>([]);
  dataSourceCriticalHeailthActive = new MatTableDataSource<CriticalHealth>([]);
  criticalHealthList: CriticalHealth[] = [];
  showCriticalHealthTab: boolean = false;
  showRegistrationDocumentUpload: boolean = false;
  IsHealthTourist: boolean = false;
  isKinGuarantorRequired: boolean=false;
  isNeedTranslator: boolean =true
  isForeignerExpiryMandatory: boolean= false;
  isDepartmentWiseCabin: boolean= false;
  isSUHCOrg = false;
  departmentCabinList: any[] = [];
  clinicSearchCtrl: FormControl = new FormControl();
filteredCabinList: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  showPatientPrefix: boolean = false;
  constructor(
    private sfileUploadService: FileUploadService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private searchService: SearchService,
    private appBaseService: AppBaseService,
    public translate: TranslateService,
    public authService: AuthService,
    private patientService: PatientService,
    public applicationConfig: ApplicationConfigService,
    private ngZone: NgZone,
    private patientRegService: PatientRegistrationService,
    private langService: MultiLanguageService,
    public masterApiService: MasterUrlService,
    public searchHead: SearchHeaderService,
    public generalApiService: GeneralUrlService,
    public patientDataService: patientGetDataservice,
    private router: Router,
    private datepipe: DatePipe,
    private utilsService: UtilsService,
    private reportService: ReportService,
    private applicationConfigService: ApplicationConfigService,
    private env: EnvoirnmentService,
    private patientLableService:PatientLableService,
    private encounterSlipService:EncounterSlipService,
    private pdpaFormService:PdpaFormService,
    private inputValidation:CopDecimalCalculateService,
    private http: HttpClientModule,
    private httpClient: HttpClient,
    private enThConvertService:thEnConverterService,
    public cookieService: CookieService,
    private cdr: ChangeDetectorRef,
    private shortcutService: ShortcutService,
    private dupicatePatientService: DuplicatePatientService,
    private encryptionService:AesEncryptionService,
    public cardReaderService: CardReaderService
  ) {
    this.getPrimaryIdList();     
    this.getUnitData();
  }

  /**
   *Loading method
   *
   * @memberof PatientRegistrationComponent
   */
  ngOnInit() {
    this.getCabinForDepartment("")
    this.shortcutSub = this.shortcutService.triggerAddPatient$.subscribe(() => {
      this.resetRegisterationForm();
    });
    this.addEmptyIdentificationEntry("P");
    this.language=localStorage.getItem("lan");
    this.formRegistration = this.formBuilder.group({
      tinNo: [""],
      id: [""],
      active:[false],
      isVip: [false],
      isNewborn: [false],
      isInactive:[false],
      isdobNotKnown: [false],
      mrn: [""],
      primaryId: [""],
      primaryNumber: [null, [removeSpaces]],
      expiryDate: [""],
      issuedCountryPrimary: [""],
      secondaryId: [""],
      secondaryNumber: [null, [removeSpaces]],
      issuedCountrySecondary: [""],
      faculty: [""],
      fullName: [null, [removeSpaces]],
      firstName: [null, [removeSpaces]],
      middleName: [null, [removeSpaces]],
      lastName:[null, [removeSpaces]],
      firstNameTh: [null, [removeSpaces]],
      middleNameTh: [null, [removeSpaces]],
      lastNameTh:[null, [removeSpaces]],
      dateOfBirth: [""],
      realdob: [false],
      prefix: [""],
      gender: ['', [Validators.required]],
      race: [""],
      nation: [""],
      patientCategory: [""],
      martial: [""],
      occupation: [""],
      preferredLanguage: [""],
      bloodGroup: [""],
      religion: [""],
      isDeceased: [false],
      isRadioactiveImplant: [false],
      sourceType: [""],
      patientNotes: [null, [removeSpaces]],
      addressPrimary: [null, [removeSpaces]],
      countryPrimary: [""],
      statePrimary: [""],
      cityPrimary: [""],
      subDistrictPrimary: [""],
      homeContact: [""],
      personalFax: [""],
      education: [""],
      birthplace: [""],
      workFax: [""],
      motherName: [""],
      ethnic: [""],
      mobileNumber: [""],
      addressSecondary: [null, [removeSpaces]],
      countrySecondary: [""],
      stateSecondary: [""],
      citySecondary: [""],
      subDistrictSecondary: [""],
      workContact: [""],
      contactRelation: [""],
      pincodePrimary: ["", [Validators.pattern(/^-?([0-9]\d*)?$/)]],
      pincodeSecondary: ["", [Validators.pattern(/^-?([0-9]\d*)?$/)]],
      emailId: [
        "",
        Validators.pattern("^([a-zA-Z0-9_.+\\-*]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+|[a-zA-Z0-9*]+)$")
      ],
      birthTime: [""],
      countryCodemobile: [""],
      secondaryExpirydate: [""],
      employmentStatus: [""],
      employerName: [""],
      employerNameOthers: [""],
      employmentNo: [""],
      workingFrom: [""],
      employmentContactNo: [""],
      employmentAddress: [null, [removeSpaces]],
      employmentCountry: [""],
      employmentState: [""],
      employmentCity: [""],
      employmentPostCode: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      aliasName: [""],
      vipRemarks: [""],
      needTranslator: [false],
      translatorLanguage: [null, [removeSpaces]]
    });

    this.formEncounter = this.formBuilder.group({
      visitToDepartment: [""],
      encounterType: ["", Validators.required],
      department: ["", Validators.required],
      doctor: ["", Validators.required],
      clinic: [""],
      appointmentSlots: [""],
      cashCounter: [""],
      remarks: [null, [removeSpaces]],
      tokenNo: [""],
      queueNumber: [""],
      newVisitConsultationCharge: [""],
      referralType: [""],
      referral: [""],
      patientCategory: [""],
      practiceNotes: [null, [removeSpaces]],
      visittype: [""],
      referralRemarks: [null, [removeSpaces]],
      reportRemarks: [null, [removeSpaces]],
      healthPackage: [this.selectedOption, false],
      reportRemarkMrd: [""],
      reportTypeMrd: [""],
      reportResonMrd: [""],
    });
  
    this.formNextOfKin = this.formBuilder.group({
      prefix: [""],
      name: ["", Validators.required],
      identificationType: [""],
      identificationNumber: [""],
      relation: [""],
      phoneNumber: [""],
      isGuarantor: [""],
      address: [""],
      country: [""],
      state: [""],
      city: [""],
      area: [""],
      district: [""],
      postcode: [""],
    });
  
    this.otherDetail = this.formBuilder.group({
      isPregnant: [false],
      isLactating: [false],
      lmpDate: [""]
    });
    this.formHealthTourist = this.formBuilder.group({
      code: [""],
      identificationType: ["", Validators.required],
      identificationNumber: ["", Validators.required],
      agentName: ["", Validators.required],
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],
      contactNo: ["", Validators.required],
      emailId: [
        "",
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]+$"),
      ],
      address: [""],
      country: [""],
      state: [""],
      city: [""],
      postcode: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    });
    this.getGenderMaster();
    this.imageUrl = this.env.apiUrl;
    this.reasonCode = OPD_CONST.reasonCode;
    this.fillDropDownLists();
    this.onChanges();
    this.initSearchFilter();
    this.checkRequestHasAdmission();
    this.checkEmergencyRegistration();
    this.checkRequestHasAdmissionForm();
    // this.getOrgAppConfigList();
    // this.getAppConfigList();
    // this.getOrgMrdAppConfigList();
    this.getScreenConfigurations();    
    this.initMyKadByConfig();
    this.getUserInfo();
    this.getRace();
    this.qmsPatientDetails = {} as qmsPatientDetails;
  }

  /**
   *mat table update
   *
   * @type {MatTable<any>}
   * @memberof PatientRegistrationComponent
   */
  ngAfterViewInit() {
    if (this.table)
      this.subscriptionList.add(
        this.ngZone.onMicrotaskEmpty
          .pipe(take(3))
          .subscribe(() => this.table.updateStickyColumnStyles())
      );
    const quickRegData = localStorage.getItem("QuickReg");

    if (quickRegData) {
      const patient = JSON.parse(quickRegData);
      this.isFromAnotherScreen = patient?.isFromQuickReg;
      this.getpatientbyId(patient.mrn);
      localStorage.removeItem("QuickReg");
    }
  }

  /**
   *get user info details
   *
   * @memberof PatientRegistrationComponent
   */
  getUserInfo() {
    this.authService.getUserInfo().then((value: any) => {
      this.username = value.userName;
      this.userId = value.userId;
      this.usermasterid = value.user_code;
      this.userAutho = value.autho;
      this.userRightList = value.userSpecialRightList;
      if (this.userRightList && this.userRightList.length > 0) {
        this.userRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splRightPatient)
            this.isPatientEditRights = true;
          if( element.specialRightCode == OPD_CONST.splRightDecease)
            this.isAllowToDecease = true;
        });
      }
    });
  }

  /**
   * To get unit data
   * @memberof PatientRegistrationComponent
   */
  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      this.unitName = value.unitDescription;
      this.orgCode=value.orgCode;
      if(this.orgCode === "SUHC"){
       this.IsHealthTourist = true;
       this.isSUHCOrg = true;
      }
      this.orgName=value.orgDescription;
      this.getAppConfigList();
      this.getOrgAppConfigList();
    });
  }

  /**
   *Destroy method
   *
   * @memberof PatientRegistrationComponent
   */
  ngOnDestroy() {
    this.cardReaderService.destroy();
    this.searchService.setSearch([]);
    this.subscriptionList.unsubscribe();
    this.shortcutSub.unsubscribe();
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  initMyKadByConfig() {
    this.getMyKadMasters();
    this.enableCardReaderBtn = this.env.cardReaderType === CARD_READER_TYPE.TRICUBES_SDK;
    // this.cardReaderService.setFormActive(this.patientForm);
    this.cardReaderService.initialize(this.env.cardReaderType);
    this.cardReaderService.cardData$
      .pipe(takeUntil(this._onDestroy))
      .subscribe((myKadData: MyKadData) => this.loadMyKadData(myKadData));
  }

  /** Delegate for the "Read Card" button (TRICUBES_SDK mode only). */
  checkStatus() {
    this.cardReaderService.triggerRead();
  }

  /**
   *
   *
   * @param {*} event
   * @memberof PatientRegistrationComponent
   */
  loadMyKadData(myKadData: MyKadData) {
    if (myKadData.Name) {
      const GenderCode = this.patientRegService.getCodeBySystemCode(
        this.genderList,
        myKadData.Gender ? myKadData.Gender : ""
      );

      const RaceCode = this.patientRegService.getCodeBySystemCode(
        this.raceList,
        myKadData.Race ? myKadData.Race : ""
      );

      const ReligionCode = this.patientRegService.getCodeBySystemCode(
        this.religionList,
        myKadData.Religion ? myKadData.Religion : ""
      );

      const PrefixCode = this.patientRegService.getCodeBySystemCode(
        this.prefixList,
        myKadData.PrefixTh ? myKadData.PrefixTh : ""
      );

      // Derive the country of card origin from the card type
      const countryStaticCode =
        (myKadData.CardType === STATICCODESERVICE.IDENTIFICATION_TYPE_MYKAD ||
        myKadData.CardType === STATICCODESERVICE.IDENTIFICATION_TYPE_MYKID)
          ? STATICCODESERVICE.COUNTRY_MALAYSIA
          : STATICCODESERVICE.COUNTRY_THAILAND;

      const CountryCode = this.patientRegService.getCodeByStaticCode(
        this.countryPrimaryList,
        countryStaticCode
      );

      const dob = moment(myKadData.BirthDate, ["DD/MM/YYYY", "DD/MM/YYYY hh:mm:ss aa"])
        .format("YYYY-MM-DD");

      // Thai card provides separate first/last names; MyKad uses a single full-name field
      const firstName = myKadData.FirstNameEn || myKadData.Name;
      const lastName = myKadData.LastNameEn || "";

      this.genderValue = GenderCode;
      this.raceValue = RaceCode;
      this.religionValue = ReligionCode;
      this.titleValue = PrefixCode;
      this.countryValue = CountryCode;

      if (this.countryValue != this.defaultCountry) {
        this.formRegistration.patchValue({ countryPrimary: CountryCode });
      }

      this.getStatePrimaryList(this.countryValue, true);

      this.formRegistration.patchValue({
        id: "",
        mrn: "",
        prefix: PrefixCode,
        firstName: firstName,
        lastName: lastName,
        firstNameTh: myKadData.FirstNameTh || "",
        lastNameTh: myKadData.LastNameTh || "",
        fullName: myKadData.Name,
        primaryId: "",
        expiryDate: myKadData.ExpiryDate
          ? new Date(moment(myKadData.ExpiryDate, "DD/MM/YYYY").toDate())
          : "",
        primaryNumber: myKadData.ICNo,
        birthplace: myKadData.BirthPlace,
        dateOfBirth: new Date(dob),
        gender: GenderCode,
        race: RaceCode,
        religion: ReligionCode,
        addressPrimary: [myKadData.Address1, myKadData.Address2, myKadData.Address3].filter(Boolean).join(" "),
        cityPrimary: "",
        statePrimary: "",
        subDistrictPrimary: "",
        pincodePrimary: myKadData.Postcode,
        issuedCountryPrimary: CountryCode
      });

      if (myKadData?.State) {
        setTimeout(() => {
          const StateCode = this.patientRegService.getCodeBySystemCode(
            this.statePrimaryList,
            myKadData.State ? myKadData.State : ""
          );

          this.stateValue = StateCode;
          this.formRegistration.patchValue({ statePrimary: StateCode });

          const State = this.patientRegService.getObjByCode(
            this.statePrimaryList,
            StateCode
          );
          this.getCityPrimaryList(State);

          setTimeout(() => {
            const CityCode = this.patientRegService.getCodeBySystemCode(
              this.cityPrimaryList,
              myKadData.City ? myKadData.City : ""
            );

            this.cityValue = CityCode;
            this.formRegistration.patchValue({ cityPrimary: CityCode });

            const City = this.patientRegService.getObjByCode(
              this.cityPrimaryList,
              CityCode
            );
            this.getSubDistrictPrimaryList(City);

            setTimeout(() => {
              const SubDistrictCode = this.patientRegService.getCodeBySystemCode(
                this.subDistrictPrimaryList,
                myKadData.SubDistrict ? myKadData.SubDistrict : ""
              );

              this.districtValue = SubDistrictCode;
              this.formRegistration.patchValue({ 
                subDistrictPrimary: SubDistrictCode,
                pincodePrimary: this.postCodeValue 
              });
            }, 1500);
          }, 1500);
        }, 1500);
      }

      if (myKadData?.PhotoBase64) this.patientImage = "data:image/jpeg;base64," + myKadData.PhotoBase64;
      else this.patientImage = "";

      this.primaryNumberOnKeyUp(myKadData?.ICNo, 0, false);
      this.formRegistration.updateValueAndValidity();
      this.checkDuplicatePatient('identificationNo', this.identificationList.data[0]);
    }
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getMyKadMasters() {
    this.getIdentificationTypeMaster();
    this.getGenderMaster();
    this.getRaceMaster();
    this.getReligionMaster();
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getGenderMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_GENDER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.genderList = data;
      });
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getReligionMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_RELIGION,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.religionList = data;
      });
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getRaceMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_RACE,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.raceList = data;
      });
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getIdentificationTypeMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.identificationTypeList = data;
      });
  }

  /**
   *Check reques appoinment
   *
   * @memberof PatientRegistrationComponent
   */
  checkRequestHasAppointment() {
    if (localStorage.getItem(OPD_CONST.appoinmentRef.aptData)) {
      let appointment: any = JSON.parse(
        localStorage.getItem(OPD_CONST.appoinmentRef.aptData)
      );
      this.isFromAppointment=true;
      if (appointment && appointment.type == OPD_CONST.appoinmentRef.temp) {
        this.patientForm = true;
        this.appointmentReference.appointmentId = appointment.id;
        this.appointmentReference.appointmentNo = appointment.appointmentNo;
        this.appointmentReference.tempPatientId = appointment.patientid;
        this.appointmentReference.healthPackage = appointment.healthPackage;
        this.getTemporaryPatient(appointment.mrn);
        this.appointmentReference.departmentCode = appointment.departmentCode;
        this.appointmentReference.doctorCode = appointment.doctorCode;
        this.appointmentReference.bookingType = appointment.bookingtype;

        this.formEncounter.patchValue({
          doctor: this.appointmentReference.doctorCode
            ? this.appointmentReference.doctorCode
            : "",
        });
      } else if (
        appointment &&
        appointment.type == OPD_CONST.appoinmentRef.reg
      ) {
        this.appointmentReference.doctorCode = appointment.doctorCode;
        this.appointmentReference.departmentCode = appointment.departmentCode;
        this.appointmentReference.appointmentNo = appointment.appointmentNo;
        this.appointmentReference.appointmentId = appointment.id;
        this.appointmentReference.healthPackage = appointment.healthPackage;
        this.appointmentReference.bookingType = appointment.bookingtype;
        this.getpatientbyId(appointment.mrn);
      }
      setTimeout(() => {
        this.departmentValue=this.departmentList.find(e=>e.code===appointment.departmentCode)
      }, 1000);
      this.doctorValueappointment=this.appointmentReference.doctorCode;
      this.tokenNoValue=appointment.token;
      this.formEncounter.patchValue({
        tokenNo: this.tokenNoValue,
      });
      this.formEncounter.get('tokenNo')?.disable();
      if (this.appointmentReference.doctorCode) {
        this.getDoctorList(this.appointmentReference.departmentCode, true);
      }

      if (
        appointment &&
        appointment.bookingtype == OPD_CONST.aptref.apttypeDeptCode
      )
        this.formEncounter.patchValue({
          visitToDepartment: true,
        });
      if (
        appointment &&
        appointment.departmentCode == OPD_CONST.aptref.apttTypeHscDesc
      ) {
        this.formEncounter.patchValue({
          visitToDepartment: true,
        });
        this.isAppointmentHsc = true;
        let healhPackageConrol = this.formEncounter.controls["healthPackage"];
        healhPackageConrol.setValidators([Validators.required]);
        var packagelist = [];

        this.appointmentReference.healthPackage.forEach((element) => {
          packagelist.push(element.code);
        });
        this.selectedOption = packagelist;
        this.formEncounter.patchValue({
          healthPackage: this.selectedOption,
        });
      }
      localStorage.removeItem(OPD_CONST.appoinmentRef.aptData);
    }
  }

  /**
   *admission check
   *
   * @memberof PatientRegistrationComponent
   */
  checkRequestHasAdmission() {
    if (localStorage.getItem(OPD_CONST.admissionFormRequest)) {
      this.isAdmissionRequest = true;
      this.admissionReqload = JSON.parse(
        localStorage.getItem(OPD_CONST.admissionFormRequest)
      );
      localStorage.removeItem(OPD_CONST.admissionFormRequest);
      setTimeout(() => {
        this.getTemporaryPatient(this.admissionReqload.mrn);
      }, 100);
    }
     if (localStorage.getItem(OPD_CONST.emergencyForm)) {
       this.isEmergency = true;
      this.emergencyPatientPayload = JSON.parse(
        localStorage.getItem(OPD_CONST.emergencyForm)
      );
      localStorage.removeItem(OPD_CONST.emergencyForm);
       if(this.emergencyPatientPayload.length>1)
      {
        this.patientForm = !this.patientForm;
        this.getpatientbyId(this.emergencyPatientPayload[0].mrn)
      }
      else{
        this.resetRegisterationForm();
      }
     }
     if (localStorage.getItem(OPD_CONST.quickRegistration)) {
       this.isFromQuickReg = true;
      this.quickRegPayload = JSON.parse(
        localStorage.getItem(OPD_CONST.quickRegistration)
      );
      localStorage.removeItem(OPD_CONST.quickRegistration);
       if(this.quickRegPayload.length>1)
      {
        this.patientForm = !this.patientForm;
        this.getpatientbyId(this.quickRegPayload[0].mrn)
      }
      else{
        this.resetRegisterationForm();
      }
     }
  }

  checkEmergencyRegistration(){
    if (localStorage.getItem(OPD_CONST.appoinmentRef.erData)) {
      let emergency: any = JSON.parse(
        localStorage.getItem(OPD_CONST.appoinmentRef.erData)
      );
       setTimeout(() => {
        this.patientForm = true;
        this.getpatientbyId(emergency.mrn)
      }, 100);
      localStorage.removeItem(OPD_CONST.appoinmentRef.erData)
  }
 }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  checkRequestHasAdmissionForm() {
    if (localStorage.getItem(OPD_CONST.admissionForm)) {
      this.isAdmissionRequest = true;
      this.admissionReqload = JSON.parse(
        localStorage.getItem(OPD_CONST.admissionForm)
      );
      localStorage.removeItem(OPD_CONST.admissionForm);
      if(this.admissionReqload.length>1)
      {
        this.patientForm = !this.patientForm;
        this.getpatientbyId(this.admissionReqload[0].mrn)
      }
      else if(this.admissionReqload.isEditPatient)
      {
        this.patientForm = !this.patientForm;
        this.getpatientbyId(this.admissionReqload.mrn)
      }
      else{
        this.resetRegisterationForm();
      }
      this.isFromAnotherScreen = this.admissionReqload.isFromAnotherScreen?this.admissionReqload.isFromAnotherScreen:false;
      for (var i in this.formRegistration.controls) {
        this.formRegistration.controls[i].markAsTouched();
      }
      setTimeout(() => {
        this.checkValidEmployee();
      }, 1000);
    }
  }

  /**
   *temporary patient details
   *
   * @param {string} trnNumber
   * @memberof PatientRegistrationComponent
   */
  getTemporaryPatient(trnNumber: string) {
    this.patientTRN = trnNumber;
    this.patientForm = true;
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_TEMP_PATIENT_SEARCH + trnNumber
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res) {
          this.patientInfoDisplay = "";
          var dobFormatted = "";
          var patientAge = undefined;
          this.tempPatientRef.code = res.trn;
          this.tempPatientRef.system = res.id;
          this.tempPatientRef.display = res.patientName;
          if (res.dob) {
            dobFormatted = this.datepipe.transform(res.dob, "dd/MM/yyyy");
            let dobDate = new Date(res.dob);
            patientAge = this.utilsService.getAge(dobDate);
            patientAge =
              patientAge > 1
                ? "(" + patientAge + " Years)"
                : "(" + patientAge + " Year)";
          }
          this.patientInfoDisplay =
            res.trn +
            " / " + (res.prefixList ? res.prefixList[0].display + " " : "") +
            res.patientName +
            " / " +
            (res.genderList ? res.genderList[0].display : "Unknown") +
            " / " +
            (res.dob ? dobFormatted + " " + patientAge : "");
          this.selectedPatient = {};
          const identificationType = res.primaryIdentificationType?.[0];
           if (res.primaryIdentificationType.length > 0) {
            this.identificationList=new MatTableDataSource<Identification>([]);
             const idTypeCode = this.getObjByCode(this.primaryIdFilteredList, identificationType?.code) ||
               this.getObjByCode(this.secondaryIdFilteredList, identificationType?.code);
              const type = idTypeCode.isPrimaryId ? 'P' : 'S';

            const data = {
              identifierUUID: res.identifierUUID || '',
              type: type,
              idType: idTypeCode.code,
              idNumber: res.idNumber?res.idNumber:"",
              expDate: res.idExpiry || '',
              primaryIdRegex: OPD_CONST.primaryIdRegix,
              isExpiryRequired:false,
              issuingCountry: res.issuingCountryCode || '',
              isCopied:false,
              isIdNumberValid:res.idNumber.length>0?true:false,
              isCountryRequired:false
            };
          this.identificationList.data.push(data);
          const newIndex = this.identificationList.data.length - 1;
          this.primaryIdentificationOnChange(idTypeCode, false, newIndex);
        
        } else {
          this.addEmptyIdentificationEntry("P");
        }
          (this.identifierTypeValue = res.primaryIdentificationType
            ? res.primaryIdentificationType[0].code
            : ""),
            (this.titleValue = res.prefixList ? res.prefixList[0].code : "");
            if (this.genderList && this.genderList.length > 0) {
              this.defaultGender = this.genderList.find((i) => i.code ==  res.genderList[0].code);
            }
            (this.countryCodeValue = res.countryCode
              ? res.countryCode.code
              : ""),
            (this.countryValue =
              res.extendedAddress && res.extendedAddress.countryList
                ? res.extendedAddress.countryList[0].code
                : ""),
            (this.stateValue =
              res.extendedAddress && res.extendedAddress.stateList
                ? res.extendedAddress.stateList[0].code
                : null),
            (this.cityValue =
              res.extendedAddress && res.extendedAddress.cityList
                ? res.extendedAddress.cityList[0].code
                : null),
            (this.districtValue =
              res.extendedAddress && res.extendedAddress.areaList
                ? res.extendedAddress.areaList[0].code
                : null),
              (this.selectedPatient.patientCategory =
                res.patientCategoryList && res.patientCategoryList.length > 0
                  ? res.patientCategoryList[0].code
                  : ""),
            this.getStatePrimaryList(this.countryValue, true);
            if(!this.patientImage) this.patientImage = res.photo ? res.photo.url : "";
          this.formRegistration.patchValue({
            prefix: res.prefixList ? res.prefixList[0].code : "",
            emailId: res.email,
            fullName: res.fullName ? res.fullName : (res.patientName ? res.patientName : ""),
            firstName: res.firstName ? res.firstName : (res.patientName ? res.patientName : ""),
            middleName:res.middleName,
            lastName:res.lastName,
            firstNameTh:res.mfirstName? res.mfirstName : (res.patientName ? res.patientName : ""),
            middleNameTh:res.middleName?res.middleName:"",
            lastNameTh : res.mlastName?res.mlastName:"",
            dateOfBirth: res.dob,
            mobileNumber: res.mobileNo,
            homeContact: this.formatContactNumber(res.homeNo),
            workContact: this.formatContactNumber(res.officeNo),
            primaryNumber: res.idNumber,
            primaryId: res.primaryIdentificationType
              ? res.primaryIdentificationType[0].code
              : "",
            expiryDate: res.idExpiry ? new Date(res.idExpiry) : "",
            addressPrimary: res.extendedAddress
              ? res.extendedAddress.addressLine
              : "",
            countryPrimary:
              res.extendedAddress && res.extendedAddress.countryList
                ? res.extendedAddress.countryList[0].code
                : "",
            statePrimary:
              res.extendedAddress && res.extendedAddress.stateList
                ? res.extendedAddress.stateList[0].code
                : "",
            cityPrimary:
              res.extendedAddress && res.extendedAddress.cityList
                ? res.extendedAddress.cityList[0].code
                : "",
            subDistrictPrimary:
              res.extendedAddress && res.extendedAddress.areaList
                ? res.extendedAddress.areaList[0].code
                : "",
            pincodePrimary: res.extendedAddress
              ? res.extendedAddress.postCode
              : "",
            patientCategory: res.patientCategoryList ? res.patientCategoryList[0].code : "",
            needTranslator: res.needTranslator ? res.needTranslator : false,
            translatorLanguage : res.translatorLanguage ? res.translatorLanguage : ""
          });
        }
      });
  }

  /**
   *get documents using MRN
   *
   * @param {*} mrn
   * @memberof PatientRegistrationComponent
   */
  getDocuments(mrn: string) {
    this.fileUploadRegList = [];
    let payload={
      mrn:mrn,
      offset: 0,
      limit: 10,
      screenCode:DocumentUploadEnum.REG_SCREEN
    }
    this.appBaseService.setResourceURL(MICROSERVICES.DOC_SERVICE);
    this.appBaseService
      .postResource(APPLICATIONSERVICE.GET_DOCUMENT,payload)
      .subscribe((res) => {
        if (res.payload) {
          res.payload.fileResponse.forEach((element) => {
            let docType = this.documentTypelist.find((data) => {
              return data.desc == element.docVersion?element.docVersion:'';
            });
          
            let docListValue = this.docListRegistration.find((data) => {
              return data.desc == element.documentType;
            });
            this.fileUploadRegList.push({
              doctype:docListValue?docListValue.code:'',
              mrn: element.mrn,
              fileType: element.fileFormat,
              fileName: element.fileName,
              id: element.id,
              fileDescription: element.documentName,
              docFileType: docType?docType.code:'',
              isUploaded: true,
            });
          });
        }
        this.fileSourceReg = new MatTableDataSource(this.fileUploadRegList);
      });
  }

  /**
   *File upload from reg
   *
   * @param {*} isFromReg
   * @memberof PatientRegistrationComponent
   */
  fileUploadDialog(isFromReg) {
    if (!isFromReg && !this.selectedPatient) {
      this.snackBar.open( this.langService.get("Please select a patient first."),
      this.langService.get("dialogs.info"), {
        duration: 3000,
      });
      return; // Prevent the dialog from opening
    }
    const dialogRef = this.dialog.open(UploadfileComponent, {
      height: "auto",
      width: "300px",
      data: { mrn: "", encounter: "" },
    });
    let list = [];
    const screenCode = isFromReg ? DocumentUploadEnum.REG_SCREEN : DocumentUploadEnum.ENCOUNTER_SCREEN;
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((res) => {
        res.forEach((element) => {
          list.push({
            fileName: element.name,
            files: element.files,
            fileType: "",
            fileDescription:  element.name,
            docFileType:DocumentUploadEnum.FINAL,
            isUploaded: false,
            screenCode:screenCode,
            doctype:isFromReg?DocumentUploadEnum.PATIENT:""
          });
        });

        if (isFromReg) {
          if (this.fileUploadRegList.length > 0) {
            let listres = this.fileUploadRegList.concat(list);
            this.fileUploadRegList = listres;
            this.fileSourceReg = new MatTableDataSource(this.fileUploadRegList);
          } else {
            this.fileUploadRegList = list;
            this.fileSourceReg = new MatTableDataSource(this.fileUploadRegList);
          }
        } else {
          let listres = this.fileUploadList.concat(list);
          this.fileUploadList = listres;
          this.fileSource = new MatTableDataSource(this.fileUploadList);
        }
      })
    );
  }

  /**
   *update File List
   *
   * @param {*} fileType
   * @param {*} res
   * @param {*} isfromReg
   * @memberof PatientRegistrationComponent
   */
  upadteFileList(docFileType, res, isfromReg) {
    if (isfromReg)
      this.fileUploadRegList.find(
        (item) => item.fileName == res.fileName
      ).filetypevalue = docFileType;
    else
      this.fileUploadList.find(
        (item) => item.fileName == res.fileName
      ).filetypevalue = docFileType;
  }

  /**
   *
   *
   * @param {*} filedesc
   * @param {*} res
   * @param {*} isfromReg
   * @memberof PatientRegistrationComponent
   */
  updateFiledesc(filedesc, res, isfromReg) {
    if (isfromReg)
      this.fileUploadRegList.find(
        (item) => item.fileName == res.fileName
      ).description = filedesc;
    else
      this.fileUploadList.find(
        (item) => item.fileName == res.fileName
      ).description = filedesc;
  }

  /**
   *File save method
   *
   * @param {*} mrn
   * @param {*} visitNo
   * @param {*} isFromReg
   * @memberof PatientRegistrationComponent
   */
  fileSave(mrn, visitNo, isFromReg) {
    let list = [];
    list = isFromReg ? this.fileUploadRegList : this.fileUploadList;
    if (!isFromReg) {
      this.sfileUploadService.getFileUpload(
        list,
        mrn,
        visitNo,
        "ADMINISTRATIVE",
        "VISIT"
      );
    } else {
      this.sfileUploadService.getFileUpload(
        list,
        mrn,
        visitNo,
        "PATIENT",
        "MRN"
      );
    }
  }

  /**
   *
   *
   * @param {*} patient
   * @memberof PatientRegistrationComponent
   */
  getPendingOrders(patient) {
    let payload = {
      limit: 10,
      offset: 0,
      mrn: patient ? patient.mrn : "",
    };
    
    this.appBaseService.setResourceURL(OPD_API_URL.LAB_SERVICE);
    this.appBaseService
      .postResource( OPD_API_URL.LAB_PENDING_ORDERS,payload)
      .subscribe((res:any)=>{
        this.groupedItems = res.pendingFutureOrderList.reduce((prev, current) => {
          if (!prev[current.groupMaster.desc]) {
            prev[current.groupMaster.desc] = [];
          }
          prev[current.groupMaster.desc].push(current);
          return prev;
        }, {})
        this.showBadge=true;
        this.pendingOrderCount= res.pendingFutureOrderList.length;
      });
  }

  /**
   *
   *
   * @param {object} obj
   * @return {*}  {string[]}
   * @memberof PatientRegistrationComponent
   */
  objectKeys(obj: object): string[] {
    return Object.keys(obj);
  }

  /**
   *
   *
   * @param {*} category
   * @param {*} element
   * @memberof PatientRegistrationComponent
   */
  selectPending(category,element) {
    let list = this.groupedItems[category];
    if(element.checked) {
    list.forEach(element => {
        element.isSelected=true;
      });
    } else {
      list.forEach(element => {
        element.isSelected=false;
      });
    }
  }
  
  /**
   * Confirmation popup for delete file
   *
   * @param {*} element
   * @param {*} isfromReg
   * @memberof PatientRegistrationComponent
   */
  confirmDelete(element, isfromReg) {
    const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "deleteConfirm" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result != undefined && result.confirm && result.confirm == "yes") {
          this.removeFile(element, isfromReg);
        }
      })
    );
  }

  /**
   *remove File
   *
   * @param {*} element
   * @param {*} isfromReg
   * @memberof PatientRegistrationComponent
   */
  removeFile(element, isfromReg) {
    if (isfromReg) {
      const index: number = this.fileSourceReg.data.indexOf(element);

      if (index != -1) {
        if (!element.isUploaded) {
          this.fileUploadRegList.splice(index, 1);
          this.fileSourceReg = new MatTableDataSource(this.fileUploadRegList);
        } else {
          this.appBaseService.setResourceURL(OPD_API_URL.DOC_SERVICE);
          this.appBaseService
            .deleteResource(OPD_API_URL.REMOVE_UPLODED_FILE +element.id)
            .pipe(takeUntil(this._onDestroy))
            .subscribe((response: any) => {
              if (response.statusCode=="200") {
                this.snackBar.open(
                  this.langService.get("EncounterPage.fileDeletedSucces"),
                  this.langService.get("CommonAppoinment.success"),
                  {
                    duration: 1000,
                  }
                );
                this.fileUploadRegList.splice(index, 1);
                this.fileSourceReg = new MatTableDataSource(
                  this.fileUploadRegList
                );
              }
            });
        }
      }
    } else {
      const index: number = this.fileSource.data.indexOf(element);

      if (index != -1) {
        this.fileUploadList.splice(index, 1);
        this.fileSource = new MatTableDataSource(this.fileUploadList);
      }
    }
  }

  /**
   * To download a file
   *
   * @param element
   */
  downloadFile(element) {
    this.appBaseService.setResourceURL(OPD_API_URL.DOC_SERVICE);
    this.appBaseService
      .getMIMETypeResource(OPD_API_URL.OPD_DOWNLOAD_FILE + element.id)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        var b = new Blob([res], { type: res.type });
        saveAs(b, element.fileName);
      });
  }

  /**
   *patient search
   *
   * @memberof PatientRegistrationComponent
   */
  public initSearchFilter() {
    let url = !this.patientForm
      ? OPD_API_URL.M_PAT_REG_SEARCH
      : OPD_API_URL.M_PAT_REG_TYPE_SEARCH;
    this.subscriptionList.add(
      this.searchHead.getTypeSearch(url).subscribe((data: any) => {
        this.searchHead.updateSearchHeader(data);
      })
    );

    this.subscriptionList.add(
      this.searchService.getResult.subscribe((result) => {
        let keysArray = Object.keys(result);
        let hasValue = false;
        
        for (let i = 0; i < keysArray.length; i++) {
          let key = keysArray[i];
          let value = result[keysArray[i]];
          if (
            key !== 'unitCode' && 
            value !== "" && value !== null && value !== undefined && value !== false && 
            value.endDate !== null && value.startDate !== null &&
            value !== "Staff" && value !== "Student" && value !== "Patient" 
          ) {
            hasValue = true;
            break; 
          }
        }
        
        if (hasValue) {
          this.searchCriteria = this.searchHead.SetPatientSearch(result);
          this.isPatientType = result.userType;
          this.patientList = null;
          this.refreshTime = new Date().toString();
          this.hidePatientSearch = false;
        } else {
           this.snackBar.open("Warning", "Please select at least one search parameter to proceed with the data search.", {
            duration: 3000,
          });
        }
      })
    );
    let quickSearch = this.searchService.getElasticSearch.subscribe(
      (quickSearch) => {
        let result = { mrn: quickSearch };
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      }
    );
    this.subscriptionList.add(quickSearch);
    
  }

  /**
   *select patient Data
   *
   * @param {*} patient
   * @memberof PatientRegistrationComponent
   */
  patientOnSelect(patient) {
    this.isFromAppointment=false;
    this.clearAllPatientEncounter();
    this.getPatientStatus(patient);
    this.checkPatientLastVisit(patient);
    this.getPendingOrders(patient);
  }

  /**
   *
   *
   * @param {*} patient
   * @memberof PatientRegistrationComponent
   */
  getPatientStatus(patient) {
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.PATIENT_STATUS_FILTER + patient.id)
      .subscribe((res) => {
        this.admissionStatus = res.isAdmitted;
        if (res.isAdmitted == true) {
          // this.patientForm=true;
          // this.isBackAllow=true;
          this.isEncounterAllow=true;
          if (res.validationMsg) {
            this.snackBar.open( this.langService.get("adt.Selectedpatient"),
            this.langService.get("dialogs.info"), {
              duration: 3000,
            });
            this.getPatientData(patient);
          }
            if (this.isPatientEditRights) this.isRegistered = false;
            else this.isRegistered = true;
        }  else {
          this.isEncounterAllow=false;
          this.isBackAllow=false;
          this.getPatientData(patient);
            if (this.isPatientEditRights) this.isRegistered = false;
            else this.isRegistered = true;
        }
      });
  }

  /**
   *
   *
   * @param {*} patientMrn
   * @memberof PatientRegistrationComponent
   */
  getOustandAmount(patientMrn) {
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_Outstanding_Bill + patientMrn
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res) {
          this.resdata = res;
          this.getPreviousEncounters(patientMrn);
        } else this.getPreviousEncounters(patientMrn);
      });
  }

  /**
   *check patient last visit occurred over 3 months ago
   *
   * @param {*} patient
   * @memberof PatientRegistrationComponent
   */ 
   checkPatientLastVisit(patient){
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.CHECK_PATIENT_LAST_VISIT + patient.mrn)
      .subscribe((res) => {
        if(res.message!=null){
          this.snackBar.open(res.message,"Validation",{duration:3000})
        }
      });

      if(patient.expiryDate ){
        const existingDate = new Date(patient.expiryDate);
        const currentDate = new Date();
        if (existingDate < currentDate) {
        this.snackBar.open(
          this.langService.get("RegistrationPage.expiryDateValidationMessage"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 4000,
          });
          this.patientForm=true;
          this.isBackAllow=true;
          setTimeout(() => {
            for (var i in this.formRegistration.controls) {
              this.formRegistration.controls[i].markAsTouched();
            }
          }, 3000);
        }
      }
      if(this.isStaffActive){
        if(!patient.isStaffActive && patient.secondaryIdType && patient.isStaffActive!=undefined){
        this.snackBar.open(
          this.langService.get("RegistrationPage.activeStaffValidationMessage"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 4000,
          });
          this.patientForm=true;
          this.isBackAllow=true;
          this.isEncounterAllow=true;
          setTimeout(() => {
            this.checkValidEmployee();
          }, 1000); 
      }
      else{
        setTimeout(() => {
          this.checkValidEmployee();
        }, 1000); 
      }
      
    }
  }

  /**
   *get previous encounters data
   *
   * @param {*} patientMrn
   * @memberof PatientRegistrationComponent
   */
   getAppointmentCheck(patientMrn){
    this.generalApiService
    .getTypeApi(
      OPD_API_URL.OPD_SERVICE,
      OPD_API_URL.GET_APPOINTMENT_CHECK + patientMrn
    )
    .pipe(takeUntil(this._onDestroy))
    .subscribe((res: any) => {
      let slotDate = res.payload && res.payload.response && res.payload.response[0] && res.payload.response[0].appointmentDetails 
      ? this.patientService.epochToDateConverter(res.payload.response[0].appointmentDetails) 
      : null;
    this.formEncounter.patchValue({
      appointmentSlots: this.datepipe.transform(slotDate, "dd-MM-yyyy hh:mm aa"),
    });
   if(res.payload && !this.isFromAppointment){     
      const dialogRef = this.dialog.open(EncounterAppointmnetComponent, {
         width: "990px",
      height: "230px",
      data: res,
     });
     this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(result.appointmentType.code == OPD_CONST.aptref.apttypeDeptCode){
        this.formEncounter.patchValue({
          visitToDepartment: true,
        });
        this.appointmentReference.appointmentNo = result.appointmentNo;
        this.appointmentReference.appointmentId = result.appointmentId;
        this.appointmentReference.departmentCode = result.speciality ? result.speciality.code :"";
        this.appointmentReference.appointmentDate = result.appointmentDetails;
        this.appointmentReference.doctorCode = result.doctor ? result.doctor.code:"";
        this.appointmentReference.bookingType = result.appointmentType.code;
        if(result.speciality){
        this.departmentValue=this.departmentList.find(e=>e.code===result.speciality.code);
        this.formEncounter.controls["department"].markAsTouched();
        this.getDoctorList(result.speciality.code, true);
        }   
        (this.doctorValueappointment = result.doctor
           ? result.doctor.code
          : ""),
        this.formEncounter.controls["doctor"].markAsTouched();
       }else if(result.appointmentType.code == OPD_CONST.aptref.apttTypeHscCode){
        this.formEncounter.patchValue({
          visitToDepartment: true,
        });
        this.isAppointmentHsc = true;
        // let healhPackageConrol = this.formEncounter.controls.healthPackage;
        // healhPackageConrol.setValidators([Validators.required]);
        // var packagelist = [];
        if(result.packageList){
        // let health = this.healthPackageList.find(i => i.code == result.packageList.code)
        // this.isAppointmentHsc = true;
        let healhPackageConrol = this.formEncounter.controls["healthPackage"];
        healhPackageConrol.setValidators([Validators.required]);
        var packagelist = [];
        this.appointmentReference.healthPackage = result.packageList;
        this.appointmentReference.healthPackage.forEach((element) => {
          packagelist.push(element.code);
        });
        this.selectedOption = packagelist;
        this.formEncounter.patchValue({
          healthPackage: this.selectedOption,
        });
        // this.appointmentReference.healthPackage = result.packageList ? result.packageList.code :"";
        // this.formEncounter.patchValue({
        //   healthPackage: health.code,
        // }); 
        // this.formEncounter.controls.healthPackage.setValue(health.code);
      }
      this.formEncounter.controls["healthPackage"].markAsTouched();
        this.appointmentReference.appointmentNo = result.appointmentNo;
        this.appointmentReference.appointmentId = result.appointmentId;
        this.appointmentReference.departmentCode = result.speciality ? result.speciality.code :"";
        this.appointmentReference.appointmentDate = result.appointmentDetails;
        this.appointmentReference.doctorCode = result.doctor ? result.doctor.code:"";
        this.appointmentReference.bookingType = result.appointmentType.code;
        if(result.speciality){
        this.departmentValue=this.departmentList.find(e=>e.code===result.speciality.code);
        this.formEncounter.controls["department"].markAsTouched();
        this.getDoctorList(result.speciality.code, true);
        }   
        (this.doctorValueappointment = result.doctor
           ? result.doctor.code
          : ""),
          this.tokenNoValue=result.token;
          this.formEncounter.patchValue({
            tokenNo: this.tokenNoValue,
          });
        this.formEncounter.controls["doctor"].markAsTouched();
       }else{
        this.formEncounter.patchValue({
        visitToDepartment: false,
        });
        this.appointmentReference.appointmentNo = result.appointmentNo;
        this.appointmentReference.appointmentId = result.appointmentId;
        this.appointmentReference.departmentCode = result.speciality ? result.speciality.code :"";
        this.appointmentReference.appointmentDate = result.appointmentDetails;
        this.appointmentReference.doctorCode = result.doctor ? result.doctor.code:"";
        this.appointmentReference.bookingType = result.appointmentType.code;
        if(result.speciality){
         this.departmentValue=this.departmentList.find(e=>e.code===result.speciality.code);
         this.formEncounter.controls["department"].markAsTouched();
         this.getDoctorList(result.speciality.code, true);
          }
        (this.doctorValueappointment = result.doctor
             ? result.doctor.code
            : ""),
         this.formEncounter.controls["doctor"].markAsTouched();
         }
        // this.savePatient();
      }
      })
      );
    }
    })
   }
  getPreviousEncounters(patientMrn) {
    let list = [];
    //this.formEncounter.reset();
    let reqPayload = patientMrn + OPD_API_URL.OPD_PREVIOUS_ENCOUNTERS;
    if (this.isPatientCategory) {
      this.formEncounter.get("patientCategory").disable();
    } else {
      this.formEncounter.get("patientCategory").enable();
    }
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_ENCOUNTER_LIST + reqPayload
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        res.totalRecords>0 ? this.pdpaForm = true : this.pdpaForm = false
        if (res && res.totalRecords > 0) {
          res.response.forEach((element, index) => {
            var utcSeconds = element.createdDate;
            var encounterDate = new Date(0);
            this.previousInternalNotes = element.internalNoteList;
            this.internotesEncounterid = element.id;
            // this.patientImage = element.patient
            //   ? element.patient[0].photo
            //     ? element.patient[0].photo[0].url
            //     : ""
            //   : "";
            const OutAmt = this.resdata.filter(
              (data) => data.encounterNumber == element.encounterNumber
            );

            list.push({
              EncounterId: element.id,
              VisitDate:  utcSeconds
              ? (this.language == Langauge.TH
                ? this.enThConvertService.convertToThaiDate(utcSeconds) :  this.datepipe.transform(utcSeconds*1000, "dd/MM/yyy hh:mm aa")): null,
              VisitNumber: element.encounterNumber,
              visitType:
              element.visitType && element.visitType.display
              ? element.visitType.display
              : "",
              payer: element.payer ? element.payer : "",
              Department: element.department ? element.department.display : "",
              DoctorName: element.doctor ? element.doctor.display : "",
              OutstandingAmount:
                OutAmt.length == 0 ? 0 : OutAmt[0].outstandingAmt,
              BillNumber: "",
              BillAmount: element.billAmount ? element.billAmount : "0.00",
            });
           const today = new Date();
            const visitDate = utcSeconds ? new Date(utcSeconds * 1000) : null;
            if (
              visitDate &&
              visitDate.getDate() === today.getDate() &&
              visitDate.getMonth() === today.getMonth() &&
              visitDate.getFullYear() === today.getFullYear()
            ) {
              this.checkVisitforToken(element);
            }
          });
        }
        this.previousEncounterList = list;
        if (list.length > 0) {
          var id = this.previousEncounterList.reduce(
            (a, { OutstandingAmount }) =>
              Number(OutstandingAmount) > a ? Number(OutstandingAmount) : a,
            -1
          );
          if (Number(id) > 0 && id != null) {
            const dialogRef = this.dialog.open(InfoDialogComponent, {
              width: "30%",
              data: {
                display: "Outstanding Info",

                info:
                  this.langService.get("RegistrationPage.patienthas") +
                  " " +
                  Number(id).toFixed(2) +
                  " " +
                  this.langService.get("RegistrationPage.outstandingAmtMsg"),
              },
            });
          }
          this.dataSourceEncounters = new MatTableDataSource<any>(list);
        }
        if (this.previousEncounterList.length == 0) {
          this.getTariffList(0, true);
        } else {
          this.getTariffList(0, false);
        }
      });
  }
checkVisitforToken(element){
  const isToday = new Date(element.createdDate * 1000).toDateString() === new Date().toDateString();
  if(isToday){
    this.tokenNoValue=element.encounterToken;
    this.formEncounter.controls['tokenNo'].disable();
  }else{
    this.tokenNoValue="";
    this.formEncounter.controls['tokenNo'].enable();
  }
}
  /**
   *setlanguage list
   *
   * @param {*} value
   * @return {*}
   * @memberof PatientRegistrationComponent
   */
  setObjectListDesc(value) {
    var res;
    this.selected = localStorage.getItem("lan").toUpperCase();
    value.forEach((element) => {
      if (element.system == this.selected) {
        res = element.display;
      }
    });
    return res;
  }

  /**
   *
   *
   * @param {*} value
   * @return {*} 
   * @memberof PatientRegistrationComponent
   */
  setObjectListCode(value) {
    var res;
    this.selected = localStorage.getItem("lan").toUpperCase();
    value.forEach((element) => {
      if (element.system == this.selected) {
        res = element.code;
      }
    });
    return res;
  }

  /**
   *Validate Registration
   *
   * @return {*}  {boolean}
   * @memberof PatientRegistrationComponent
   */
   validateRegistration(): boolean {
    if (this.isDeceased) {
      return this.formRegistration.valid;

    }
    for (const controlName in this.formRegistration.controls) {
      const control = this.formRegistration.controls[controlName];
      control.markAsTouched();
    }
    if (!this.formRegistration.valid) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleasefillallmandatory"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }

      );
      return false;
    }
    const mobileNumberControl = this.formRegistration.controls["mobileNumber"];
    if (!mobileNumberControl.valid) {
      mobileNumberControl.markAsTouched();
  
      if (!mobileNumberControl.disabled) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.addDependend"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 1000,
          }
        );        
      return false;
      }
    } 
     if (this.mandatoryField.identificationType || this.mandatoryField.identificationNo) {
       for (const element of this.identificationList.data) {
         if (element.type === "P" && (!element.idType || !element.idNumber.replace(/-/g, '') || !element.isIdNumberValid) ||
           (element.isExpiryRequired && !element.expDate) ||
           (element.isCountryRequired && !element.issuingCountry)) {
           this.snackBar.open("Please check Primary Identification Details", "Validation", { duration: 2000 });
           return false;
         }else if(element.type!=="P" && this.identificationList.data.length==1){
          this.snackBar.open("Please Add Primary Identification Details", "Validation", { duration: 2000 });
          return false;
         }
       }
     }
    if (this.mandatoryField.secIdentificationType || this.mandatoryField.secIdentificationNo) {
      for (const element of this.identificationList.data) {
        if (element.type === "S" && (!element.idType || !element.idNumber.replace(/-/g, '') || !element.isIdNumberValid)||
           (element.isExpiryRequired && !element.expDate) ||
           (element.isCountryRequired && !element.issuingCountry)) {
          this.snackBar.open("Please check Secondary Identification Details", "Validation", { duration: 2000 });
          return false; 
        }
      }
    }
    return true;
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  openRegisterConfirmDialog(): void {
    setTimeout(() => {
    if (this.validateRegistration()) {
      if(this.formRegistration.controls["isVip"].value) {
        if(this.patientId && this.isVip !==this.formRegistration.controls["isVip"].value) {
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "15%",
          data: { displayText: "conformVipMessage"},
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result && result.confirm == "yes") {
              this.openRegisterConfirmationDialog();
            }
          })
        );
      }else if(!this.patientId){
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "15%",
          data: { displayText: "conformVipMessage"},
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result && result.confirm == "yes") {
              this.openRegisterConfirmationDialog();
            }
          })
        );
      }else{
        this.openRegisterConfirmationDialog();
      }
      } else {
        this.openRegisterConfirmationDialog();
      } 
    }      
    }, 50);
 }

 /**
  *
  *
  * @memberof PatientRegistrationComponent
  */
 openRegisterConfirmationDialog(): void {
    const dialogRef = this.dialog.open(RegsuccessDialogComponent, {
      width: "20%",
      data: {},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.workflow == "yes") {
          this.savePatient();
        }
      })
    );
  }

  /**
   *save encounter confirm window
   *
   * @memberof PatientRegistrationComponent
   */
  openEncounterConfirmDialog(): void {
    // if (this.selectedOption.length > 0 && this.validateEncounter()) {
    //   this.validatePackage();
    // } else
     if (this.validateEncounter()) {
      // if (
      //   (this.formEncounter.controls.tokenNo.value && this.isToken == true) ||
      //   !this.formEncounter.controls.tokenNo.value
      // ) {
        const dialogRef = this.dialog.open(RegsuccessDialogComponent, {
          width: "20%",
          data: {},
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result && result.workflow == "yes") {
              this.saveEncounter();
            }
          })
        );
      // }
    }
  }

  /**
   *Save Patient Method
   *
   * @memberof PatientRegistrationComponent
   */
  savePatient() {
    if (this.validateRegistration()) {
      this.patientRegService.addHealthTouristDetails(this.healthTouristList,this.identificationTypeList);
      let patient: PatientRegistration =
        this.patientRegService.getRegistrationFormValues(
          this,
          this.formRegistration
        );
      
      let requestObject = this.patientRegService.setSavePayload(this, patient);
      if (this.isPatientType == "Staff" || this.isPatientType == "Student")
        patient.id = "";
      if (!patient.id ||this.isFromAnotherunit) {
        this.generalApiService
          .postTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.S_PATIENT_REG,
            requestObject
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((response: any) => {
            if(response){
            this.isFromAnotherunit=false;
            let resMrn = response.identifier
              ? response.identifier[0].value
              : "";
            this.formRegistration.patchValue({
              id: response.id,
              mrn: resMrn,
            });
            if(this.patientImage)
            {
              this.aiImageSave(resMrn);
            }
            if (this.fileSourceReg.data.length > 0 && resMrn) {
              this.fileSave(resMrn, "", true);
            }
            if (this.isAdmissionRequest) {
              this.admissionReqload.id=response.id;
              this.admissionReqload.mrn=resMrn;
              localStorage.setItem(
                OPD_CONST.admissionFormRequest,
                JSON.stringify(this.admissionReqload)
              );
              if (this.admissionReqload?.visitType == "DC") {
                this.router.navigate([opdNavigation.DayCare_NAVIGATE]);
              } else {
                this.router.navigate([opdNavigation.ADT_NAVIGATE]);
              }
            }
            this.patientSaveOnSuccess(resMrn, response.id);
          }
          });
      } else {
        if (this.isUpdateRequired) {
          const dialogRef = this.dialog.open(SigninModalComponent, {
            height: "auto",
            width: "auto",
            data: { message: "Do you want to Save?" },
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result == true) {
              this.updatePatient();
            }
          });
        } else {
          this.updatePatient();
        }
      }
    }
  }

  aiImageSave(mrn:string) {
    const base64Data = this.patientImage.replace("data:image/jpeg;base64,", '');
    let requestObject={
      mrn: mrn,
      base64_image: base64Data
    }
    this.generalApiService
    .postTypeApi(
      OPD_API_URL.AI_SERVICE,
      OPD_API_URL.SAVE_AI_IMAGE,
      requestObject
    )
    .pipe(takeUntil(this._onDestroy))
    .subscribe((response: any) => {
    
    })
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  updatePatient() {
    let patient: PatientRegistration =
      this.patientRegService.getRegistrationFormValues(
        this,
        this.formRegistration
      );
    let requestObject = this.patientRegService.setSavePayload(this, patient);

    this.generalApiService.putTypeApi(
      OPD_API_URL.OPD_SERVICE,
      OPD_API_URL.NEW_PATIENT_UPDATE +
      "mrn=&uhId=" + (this.uhId ? this.uhId : '') +
      "&id=" + (this.uhId=="" ? patient.id : ''),
      requestObject
    ).pipe(takeUntil(this._onDestroy))
      .subscribe((response: any) => {
        if(response){
       let unitWiseResponse = response.find((item: any) => item.unitCode === this.unitCode);
        let resMrn = unitWiseResponse.identifier ? unitWiseResponse.identifier[0].value : "";
        this.formRegistration.patchValue({
          id: unitWiseResponse.id,
          mrn: unitWiseResponse.mrnno,
        });
        if (this.fileSourceReg.data.length > 0 && resMrn) {
          this.fileSave(resMrn, "", true);
        }
        if (this.isAdmissionRequest) {
          this.admissionReqload.mrn = resMrn;
          localStorage.setItem(
            OPD_CONST.admissionFormRequest,
            JSON.stringify(this.admissionReqload)
          );
          if (this.admissionReqload?.visitType == "DC") {
            this.router.navigate([opdNavigation.DayCare_NAVIGATE]);
          } else {
            this.router.navigate([opdNavigation.ADT_NAVIGATE]);
          }
        }
        if(this.isEmergency){
          localStorage.setItem(
            OPD_CONST.emergencyForm,
            JSON.stringify(this.emergencyPatientPayload[0].mrn)
          );
          this.router.navigate([opdNavigation.EMERGENCY_REG_FORM])
        }
         if(this.isFromQuickReg){
          localStorage.setItem(
            OPD_CONST.quickRegistration,
            JSON.stringify(this.quickRegPayload[0].mrn)
          );
          this.router.navigate([opdNavigation.QUICK_REG_FORM])
        }
        this.patientSaveOnSuccess(resMrn, unitWiseResponse.id);
      }
      });
  }

  /**
   *get list data details by code
   *
   * @param {any[]} list
   * @param {string} code
   * @return {*}  {string}
   * @memberof PatientRegistrationComponent
   */
  getObjByCode(list: any[], code: string) {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }

  /**
   *redirect encounter page
   *
   * @memberof PatientRegistrationComponent
   */
  transactionIncompleteDilog() {
    if(this.isAdmissionRequest) {
      if(this.selectedPatient)
      this.admissionReqload.mrn = this.selectedPatient.mrn;
      localStorage.setItem(
        OPD_CONST.admissionFormRequest,
        JSON.stringify(this.admissionReqload)
      );
       if (this.admissionReqload?.visitType == "DC") {
          this.router.navigate([opdNavigation.DayCare_Request_NAVIGATE]);
        } else {
          this.router.navigate([opdNavigation.ADT_Request_NAVIGATE]);
        }
    } else if(this.isEmergency){
       localStorage.setItem(
            OPD_CONST.emergencyForm,
            JSON.stringify(this.emergencyPatientPayload[0].mrn)
          );
          this.router.navigate([opdNavigation.EMERGENCY_REG_FORM])
    } else if (this.isFromQuickReg) {
      localStorage.setItem(
        OPD_CONST.quickRegistration,
        JSON.stringify(this.quickRegPayload[0].mrn)
      );
      this.router.navigate([opdNavigation.QUICK_REG_FORM])
    }
    else {
      this.patientForm = false;
      this.cardReaderStatus = false;
      this.initSearchFilter();
    }
  }

  /**
   *after patient save call method
   *
   * @param {*} patientId
   * @memberof PatientRegistrationComponent
   */
  patientSaveOnSuccess(patientId, id) {
    this.admissionReqload="";
    this.patientTRN = "";
    this.isSameAddress = false;
    this.getpatientbyId(patientId);
    this.patientForm = false;
    this.patientId = patientId;
    this.tempPatientRef.code = "";
    this.tempPatientRef.display = "";
    this.tempPatientRef.system = "";
    this.emergencyPatientPayload="";
    if(this.isPatientRequired){
    let reqPayload = {
      transactionId: id,
      type: OPD_REPORT_TYPE.pdf,
      reportName: OPD_REPORT_NAME.patient_Card,
      isReports: false,
    };
    localStorage.setItem(OPD_CONST.patientLablePayload, JSON.stringify(reqPayload));
    window.open(opdNavigation.REPORT_NAVIGATE + "2");
  }
  // if(this.rePrintSlip){
  //    let reqPayload = {
  //     transactionId: id,
  //     type: OPD_REPORT_TYPE.pdf,
  //     reportName: OPD_REPORT_NAME.PatientRegistrationForm,
  //     isReports: false,
  //   };
  //   localStorage.setItem(OPD_CONST.patientLablePayload, JSON.stringify(reqPayload));
  //   window.open(opdNavigation.REPORT_NAVIGATE+"2");
  // }
    if (this.isSUHCOrg) {
      // this.patientLableService.generateReports(id, OPD_REPORT_NAME.patient_Label);
      this.pdpaFormService.generateReports(id, OPD_REPORT_NAME.pdpaForm_new);
      // if (this.rePrintSlip) {
      //   let reqPayload = {
      //     transactionId: id,
      //     type: OPD_REPORT_TYPE.pdf,
      //     reportName: OPD_REPORT_NAME.PatientRegistrationForm,
      //     isReports: false,
      //   };
      //   localStorage.setItem(OPD_REPORT_NAME.PatientRegistrationForm, JSON.stringify(reqPayload));
      //   window.open(opdNavigation.REPORT_NAVIGATE + "4");
      // }
    }

    this.isAdmissionRequest = false;
    localStorage.removeItem(OPD_CONST.appoinmentRef.aptData);
    this.appointmentReference.doctorCode = "";
    this.appointmentReference.departmentCode = "";
    this.snackBar.open(
      this.langService.get("EncounterPage.patientSaved"),
      this.langService.get("CommonAppoinment.success"),
      {
        duration: 1000,
      }
    );
  }

  /**
   *getpatient search by id
   *
   * @param {*} patientId
   * @memberof PatientRegistrationComponent
   */
  getpatientbyId(patientId,idNumber?) {
    let reqPayload =
      "identificationId="+(idNumber?idNumber:"")+"&name=&mrn=" +
      (patientId?patientId:"") +
      "&gender=&unitCode=&city=&identificationType=&frDate=&toDate=&id=&mobile=&birthDate=&offset=&size=&pincode=&country=&state=";
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_PATIENT_SEARCH + reqPayload
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any[]) => {
        if(res && res.length > 0){
        let pateintData = this.patientDataService.displayList(res);
        this.getPatientData(pateintData[0]);
        this.getPatientStatus(pateintData[0]);
        } else if (idNumber) {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "30%",
            data: {
              display: "Info",
              info: "Patient record not found for the scanned token. Do you want to proceed with registration?"
            },
          });
          this.subscriptionList.add(
            dialogRef.afterClosed().subscribe((result) => {
              if (
                result != undefined &&
                result.confirm &&
                result.confirm == "yes"
              ) {
                this.clearAllPatientEncounter();
                this.tokenValue=this.qmsPatientDetails.tokenNo;
                this.tokenNoValue=this.qmsPatientDetails.tokenNo;
                 this.patientForm = true;
                 this.genderValue=this.genderList.find(i=>i.desc==this.qmsPatientDetails.gender).code;
                this.formRegistration.patchValue({
                  id: "",
                  mrn: this.qmsPatientDetails.mrn,
                  firstName:this.qmsPatientDetails.name,
                  fullName:this.qmsPatientDetails.name,
                  primaryNumber:this.qmsPatientDetails.icNo,
                  mobileNumber:this.qmsPatientDetails.mobileNo,
                });
                if(this.qmsPatientDetails.icNo){
                  let idType = this.primaryIdList.find(i => i.desc == this.qmsPatientDetails.identificationType);
                  this.identificationList.data[0].idType=idType.code;
                  this.identificationList.data[0].idNumber=this.qmsPatientDetails.icNo;
                  this.primaryIdentificationOnChange(idType,false,0);
                }
               }
            }))
        }
      });
  }

  /**
   *validate doctor
   *
   * @memberof PatientRegistrationComponent
   */
  validationOnDoctor() {
    let departmentCode = this.formEncounter.controls["department"].value;
    let doctorCode = this.formEncounter.controls["doctor"].value;
    if(this.consultationChargesDuringvisit == "true" && this.formEncounter.value.encounterType.isConsultation && departmentCode){
      this.getConsultationCharges(departmentCode,doctorCode);
    }
    if (this.patientId && departmentCode) {
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_DUPLICATE_ENCOUNTER +
            departmentCode.code +
            "&doctorCode=" +
            doctorCode +
            "&patientId=" +
            this.patientId
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((response: any) => {
          if (response) {
            this.snackBar.open(
              this.langService.get("CommonAppoinment.warning"),
              this.langService.get("CommonAppoinment.duplicateEncouter") + "",
              {
                duration: 1000,
              }
            );
          }
        });
    }
  }

  /**
   *validate encounter
   *
   * @return {*}  {boolean}
   * @memberof PatientRegistrationComponent
   */
  validateEncounter(): boolean {
    let valid = true;
    let payersList = this.dataSourcePayers.data;
    if (this.selectedPatient == null) {
      valid = false;
      this.snackBar.open(
        this.langService.get("EncounterPage.pleaseSelectPatient"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }

    if (payersList.length > 0) {
      payersList.forEach((element) => {
        if (element.payerCode == "" || element.payerCode == undefined) {
          valid = false;
          this.snackBar.open(
            this.langService.get("EncounterPage.pleaseselectreferrconpamy"),
            this.langService.get("CommonAppoinment.validation"),
            {
              duration: 1000,
            }
          );
        }
      });
    }
    if (payersList.length > 0) {
      payersList.forEach((element) => {
        if (element.tariffCode == "" || element.tariffCode == undefined) {
          valid = false;
          this.snackBar.open(
            this.langService.get("CommonAppoinment.PleaseSelectTariff"),
            this.langService.get("CommonAppoinment.validation"),
            {
              duration: 1000,
            }
          );
        }
      });
    }

    if (valid) {
      for (var i in this.formEncounter.controls) {
        this.formEncounter.controls[i].markAsTouched();
      }
      valid = this.formEncounter.valid;

      if (!valid) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.pleasefillallmandatory"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 1000,
          }
        );
      }
    } 
    if (this.kinData.length == 0 && this.isNOKRequired) {
      valid = false;
      this.snackBar.open(
        this.langService.get("Please Add  Next of Kin (Dependent) Details"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
  // let isGuarantorMissing = this.kinData
  // .some(e => e.active === true && e.isGuarantor === false);
  
    // if (isGuarantorMissing && this.isNOKRequired) {
    //   valid = false;
    //   this.snackBar.open(
    //     this.langService.get("Please select at least one preasent guarantor."),
    //     this.langService.get("CommonAppoinment.validation"),
    //     {
    //       duration: 1000,
    //     }
    //   );
    if(this.isKinGuarantorRequired){
    const guarantorCount = this.kinData.filter(item => item.isGuarantor).length;
      if(guarantorCount < 1) {
        valid = false;
        this.snackBar.open(
          this.langService.get("CommonAppoinment.PleaseSelectGuarenter"),
          this.langService.get("CommonAppoinment.validation"),
          { duration: 2000 }
        );
    }
    }
    if(this.fileUploadList && this.fileUploadList.length > 0){
      let doctType=this.fileUploadList.find((i) => i.doctype =='' ||i.doctype ==undefined);
      if(doctType){
        valid=false;
        this.snackBar.open("Warning", "Please select the Document Type", {
          duration: 2000,
        });
      }
    }
    return valid;
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  validatePackage() {
    if (this.selectedOption.length > 0) {
      let tariiffDetails = this.dataSourcePayers.data.find(
        (s) => s.priority == 1
      );
      let tariffId = this.tariffList.find(
        (x) => x.code == tariiffDetails.tariffCode
      );
      let packageList = [];
      if (this.selectedOption.length > 0) {
        for (let i = 0; i < this.selectedOption.length; i++) {
          let value = this.healthPackageList.find(
            (s) => s.code == this.selectedOption[i]
          );
          packageList.push(value.id);
        }
      }
      let requestObject = {
        tariffId: tariffId.id,
        packageList: packageList.length > 0 ? packageList : [],
      };
      this.generalApiService
        .postTypeApi(
          OPD_API_URL.MASTER_SERVICE,
          OPD_API_URL.M_PACKAGEVALIDATION,
          requestObject
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((response: any) => {
          if (response.desc) {
            this.snackBar.open(
              response.desc,
              this.langService.get("CommonAppoinment.validation"),
              {
                duration: 1000,
              }
            );
          } else {
            const dialogRef = this.dialog.open(RegsuccessDialogComponent, {
              width: "20%",
              data: {},
            });
            this.subscriptionList.add(
              dialogRef.afterClosed().subscribe((result) => {
                if (result && result.workflow == "yes") {
                  this.saveEncounter();
                }
              })
            );
          }
        });
    }
  }

  /**
   *Save encounter
   *
   * @memberof PatientRegistrationComponent
   */
  saveEncounter() {
    let encounter = this.patientRegService.getEncounterFormValues(
      this,
      this.formEncounter
    );
    encounter.defaultDeposit = this.defaultDeposit;
    encounter.consultationChargeId = this.consultationCharge?.id ? this.consultationCharge.id : 0;
    encounter.consultationChargeType = this.consultationCharge?.consultationChargeType ? this.consultationCharge.consultationChargeType : ""
    let dataSourcePayers = this.patientRegService.getEncounterPayerFormValues(
      this,
      this.dataSourcePayers
    );
    let otherDetails = this.patientRegService.getOtherDetailsValues(
      this,
      this.otherDetail
    );
    let requestObject = this.patientRegService.setEncounterSave(
      this,
      encounter,
      otherDetails,
      dataSourcePayers,
      //this.kinData
      this.dataSourceNextOfKin.data
    );
    this.generalApiService
      .postTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.S_PATIENT_ENCOUNTER,
        requestObject
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe(async (response: any) => {
        if (response && response.id) {
          this.snackBar.open(
            this.langService.get("EncounterPage.encounterHeader") +
              " " +
              response.identifier[0].value +
              " " +
              this.langService.get("EncounterPage.savedSuccess") +
              " ",
            this.langService.get("CommonAppoinment.success"),
            {
              duration: 1000,
            }
          );
          this.encounterid = response.id;
          this.visitno = response.identifier[0].value;
          this.previousInternalNotes = [];
          this.internalNotesList = [];
          this.appointmentData = null;
          if (this.fileSource.data.length > 0) {
            this.fileSave(this.selectedPatient.mrn, this.visitno, false);
          }
          if(this.autoBillScreenRedirection == "true"){
            //redirction to billing popup give and it will redirect to op bill screen with mrn and visit 
            this.goToBilling();
          }
          if(this.defaultDeposit){
          const payload = {
            transactionId: response.id,
            type: OPD_REPORT_TYPE.pdf,
            reportName: OPD_REPORT_NAME.default_deposit_slip, 
            isReports: false,
          };
          localStorage.setItem(
            OPD_CONST.reportPayload2,
            JSON.stringify(payload)
          );
          window.open(opdNavigation.REPORT_NAVIGATE );
        }
          //   let reqPayload = {
          //     transactionId: this.encounterid,
          //     type: OPD_REPORT_TYPE.pdf,
          //     reportName: OPD_REPORT_NAME.encounter_Slip,
          //     isReports: false,
          //   };
          //   localStorage.setItem(
          //     OPD_CONST.reportPayload,
          //     JSON.stringify(reqPayload)
          //   );
          // await setLocalStorageItem( OPD_CONST.reportPayload,  reqPayload);
          //   window.open(opdNavigation.REPORT_NAVIGATE);
          //   let reqPayload1 = {
          //     transactionId: this.encounterid,
          //     type: OPD_REPORT_TYPE.pdf,
          //     reportName: OPD_REPORT_NAME.pdpaForm_new,
          //     isReports: false,
          //   };
          //  // localStorage.setItem("reportPayload2", JSON.stringify(reqPayload1));
          //   await setLocalStorageItem("reportPayload2",  reqPayload1);
          //   window.open(opdNavigation.REPORT_NAVIGATE);
          //   setTimeout(() => {
          //     let reqPayload2 = {
          //       transactionId: this.encounterid,
          //       type: OPD_REPORT_TYPE.pdf,
          //       reportName: OPD_REPORT_NAME.patient_Label,
          //       isReports: false,
          //     };
          //     localStorage.setItem("reportPayload3", JSON.stringify(reqPayload2));
          //    // await setLocalStorageItem("reportPayload3", reqPayload2);
          //     window.open(opdNavigation.REPORT_NAVIGATE);
          //   }, 1500);
          // let reportList = [
          //   {
          //     id: "1",
          //     code: OPD_REPORT_NAME.patient_Label,
          //     desc: "reportPayload",
          //   },
          //   {
          //     id: "2",
          //     code: OPD_REPORT_NAME.pdpaForm_new,
          //     desc: "reportPayload2",
          //   },
          //   {
          //     id: "3",
          //     code: OPD_REPORT_NAME.encounter_Slip,
          //     desc: "reportPayload3",
          //   },
          // ];

          // let promises = reportList.map(async (element) => {
          //   let reqPayload = {
          //     transactionId: this.encounterid,
          //     type: OPD_REPORT_TYPE.pdf,
          //     reportName: element.code,
          //     isReports: false,
          //   };
          //   await Promise.all(promises);
          //   await setLocalStorageItem(element.desc, reqPayload);

          // window.open(opdNavigation.REPORT_NAVIGATE);
          // });
          // generateReports(reportList, this.encounterid);
          if (this.isSUHCOrg) {
            this.encounterSlipService.generateReports(this.encounterid,OPD_REPORT_NAME.encounter_Slip);
            this.patientLableService.generateReports(this.encounterid,OPD_REPORT_NAME.patient_Label);
          } else {
          if (!this.pdpaForm) {
            this.patientLableService.generateReports(this.encounterid,OPD_REPORT_NAME.patient_Label);
            this.pdpaFormService.generateReports(this.encounterid,OPD_REPORT_NAME.pdpaForm_new);
            this.encounterSlipService.generateReports(this.encounterid,OPD_REPORT_NAME.encounter_Slip);
          }else{
          this.patientLableService.generateReports(this.encounterid,OPD_REPORT_NAME.patient_Label);
          this.encounterSlipService.generateReports(this.encounterid,OPD_REPORT_NAME.encounter_Slip);
          }
        }
          if (this.rePrintSlip) {
            let reqPayload = {
              transactionId: response.id,
              type: OPD_REPORT_TYPE.pdf,
              reportName: OPD_REPORT_NAME.PatientRegistrationForm,
              isReports: false,
            };
            localStorage.setItem(OPD_REPORT_NAME.PatientRegistrationForm, JSON.stringify(reqPayload));
            window.open(opdNavigation.REPORT_NAVIGATE + "4");
          }
          this.clearAllPatientEncounter();
        } else {
          this.getPayerTypeList();
          // this.getPayerList();
        }
      });
  }

  goToBilling(){
    const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "15%",
      data: { displayText: "Do you want to proceed with billing?"},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          if (this.PatientData.mrn) {
            this.cookieService.set("IsLoggedin", "true", 1, "/");
            this.cookieService.set("MRN", this.PatientData.mrn, 1, "/");
            this.cookieService.set("accessToken", btoa(this.userAutho), 1, "/");
            this.cookieService.set("USER_NAME", btoa(this.username), 1, "/");
            window.open(this.env.medcareUrl + "/billing/#/billing/bill/opbill");
          }
        }
      })
    );
  }

  /**
   *
   *
   * @param {string} encounterId
   * @param {string} reportname
   * @memberof PatientRegistrationComponent
   */
  printReport(encounterId: string, reportname: string) {
    let reqPayload = {
      transactionId: encounterId,
      type: OPD_REPORT_TYPE.pdf,
      reportName: reportname,
      isReports: false,
    };
    localStorage.setItem(OPD_CONST.reportPayload, JSON.stringify(reqPayload));
    window.open(opdNavigation.REPORT_NAVIGATE);
  }

  /**
   *add appointment method
   *
   * @memberof PatientRegistrationComponent
   */
  addAppointment() {
    this.doctorValueappointment = null;
    var data = {
      department: this.formEncounter.controls["department"].value
        ? this.formEncounter.controls["department"].value
        : "",
      doctor: this.formEncounter.controls["doctor"].value
        ? this.formEncounter.controls["doctor"].value
        : "",
      isDepartment: this.formEncounter.controls["visitToDepartment"].value
        ? this.formEncounter.controls["visitToDepartment"].value
        : false,
      isFromEcnounter: true,
    };
    localStorage.setItem(
      OPD_CONST.appoinmentRef.appointmentEncounter,
      JSON.stringify(data)
    );
    const dialogRef = this.dialog.open(PatientAppointmentDialogComponent, {
      height: "600px",
      width: "1100px",
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        let res = result;
        if (result) {
          if (res.appointmentType == OPD_CONST.aptref.apttypeDeptCode) {
            this.formEncounter.patchValue({
              visitToDepartment: true,
            });
            this.formEncounter.controls["department"].markAsTouched();
            this.departmentFilterList=this.departmentList;
            this.departmentValue=this.departmentList.find(e=>e.code===result.department);
          } else {
            this.formEncounter.patchValue({
              visitToDepartment: false,
            });
            this.departmentFilterList=this.departmentList;
            this.departmentValue=this.departmentList.find(e=>e.code===result.department);
            this.formEncounter.controls["department"].markAsTouched();
            this.getDoctorList(result.department, true);
            (this.doctorValueappointment = result.doctor
              ? result.doctor.code
              : ""),
              this.formEncounter.controls["doctor"].markAsTouched();
          }
          var slotTime = this.datepipe.transform(
            res.fromTime,
            "dd-MM-yyyy hh:mm aa"
          );
          this.formEncounter.patchValue({
            appointmentSlots: res.fromTime ? slotTime : "",
          });
          var dateValue = this.datepipe.transform(res.fromTime, "yyyy-MM-dd");
          this.appointmentData = {
            slotId: res.slotId,
            fromTime: res.fromTime,
            toTime: res.toTime,
            date: dateValue,
          };
        }
      })
    );
  }

  /**
   *add internal notes
   *
   * @memberof PatientRegistrationComponent
   */
  addInternalNotes() {
    if (!this.previousInternalNotes) {
      this.previousInternalNotes = [];
    }
    const dialogRef = this.dialog.open(PatientNotesDialogComponent, {
      height: "350px",
      width: "1000px",
      data: {
        listNotes: this.previousInternalNotes,
        name: "Encounter",
        encounterId: this.internotesEncounterid,
        isPrint:false
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        let res = result;
        this.internalNotesList = res;
      })
    );
  }
 
  /**
   *set mandatory fields
   *
   * @memberof PatientRegistrationComponent
   */
  getScreenConfigurations() {
    this.subscriptionList.add(
      this.applicationConfig
        .getScreenConfiguration("OPD", MasterSubMenus.Registration)
        .subscribe((config: any) => {
          if (config) {
            this.mandatorykeys.setMandatoryFormValues(config, this.mandatoryField, this.showField);
          }
          const clinicElement = config.find(element => element.key == ManditoryKayEnum.clinic);
          if (clinicElement) {
            this.isGetClinicElement = clinicElement.systemMandatory;
            this.isClinicReqired = clinicElement.systemMandatory;
          }
        })
    );
  }
  formatDOBInput(event: any) {
    const input = event.target.value;
    if (/^\d{8}$/.test(input)) {
      this.formRegistration.controls["dateOfBirth"].setValue(moment(input, 'DDMMYYYY').toDate());
    }
  }
  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getAppConfigList() {
    let mrdConfig: any;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource( "appConfiguration/findConfigByModule?unitCode="+this.unitCode+
        "&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
      if (res) {
        mrdConfig = res.keys;
        mrdConfig.forEach((element) => {
          if (element.key == MasterKeys.consultationChargesDuringvisit){
            if (element.valueList.length > 0) {
              this.consultationChargesDuringvisit = element.valueList[0]?.code;
            }
          }
          if (element.key == MasterKeys.autoBillScreenRedirection){
            if (element.valueList.length > 0) {
              this.autoBillScreenRedirection = element.valueList[0]?.code;
            }
          }
          if (element.key == MasterKeys.patientCategoryTariffRequired) {
            this.isPatientCategory =
              element.valueList[0].code == "true" ? true : false;
          }
          if (element.key == MasterKeys.updateAuthRequired) {
            this.isUpdateRequired =
              element.valueList[0].code == "true" ? true : false;
          }
          if (element.key == MasterKeys.NextOfKinRequired){
            if (element.valueList.length > 0) {
              this.isNOKRequired = element.valueList[0].code=="true"?true:false;
            }
          }
          if (element.key == MasterKeys.staffActiveFlag){
            if (element.valueList.length > 0) {
              this.isStaffActive = element.valueList[0].code=="true"?true:false;
            }
          }
          if (element.key == MasterKeys.patientCardRequired){
            if (element.valueList.length > 0) {
              this.isPatientRequired = element.valueList[0].code=="true"?true:false;
            }
          }
          if (element.key == MasterKeys.defaultNationality){
            if (element.valueList.length > 0) {
              this.defaultNationality = element.valueList[0]?.code;
            }
          }
          if (element.key == MasterKeys.defaultCountry){
            if (element.valueList.length > 0) {
              this.defaultCountry = element.valueList[0]?.code;
              this.getStatePrimaryList(this.defaultCountry ,true);
              this.getCountryCode(element.valueList[0]?.code,false);
            }
          }
          
         
        });
      }
    });
  }

  getConsultationCharges(departmentCode,doctorCode){
    let payload ={
      mrn: this.PatientData.mrn ,
      specialityCode: departmentCode ? departmentCode.code : "",
      doctorCode: doctorCode ? doctorCode : "",
      unitCode: this.unitCode,
      orgCode: this.orgCode,
      createdBy: this.username
    }
    this.appBaseService.setResourceURL(OPD_API_URL.BILLING_SERVICE);
    this.appBaseService
      .postResource(MASTERSSERVICES.GET_CONSULTATION_CHARGES,payload)
      .subscribe((res) => {
        this.consultationCharge = res;
        this.formEncounter.patchValue({
          newVisitConsultationCharge: res.desc,
        });
      });
  } 
  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getOrgAppConfigList() {
    let appConfig: any;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res) {
          appConfig = res.keys;
          appConfig.forEach((element) => {
            if (element.key == MasterMenus.MRD) {
              if (element.valueList.length > 0) {
              this.mrdDepartment = element.valueList[0].code;
              }
            }
            if (element.key == MasterKeys.primaryIdentification){
              if (element.valueList?.length > 0) {
                this.valuelist = element.valueList;
              let primaryIdValue=this.formRegistration.controls["primaryId"].value;
              if (element?.valueList?.length > 0 && element.valueList[0]?.code ) {
              if(!primaryIdValue && this.selectedPatient==null){
              let value = this.primaryIdFilteredList.find(i=>i.code == element.valueList[0]?.code)
              this.primaryIdNewValue =  value?.code;   
              this.cdr.detectChanges();
              this.mandatoryField.identificationType=true;
              this.mandatoryField.identificationNo=true;
              this.identificationList.data[0].idType=value?.code;
              this.primaryIdentificationOnChange(value,false,0)
              }
            }
            }
            }
            if (element.key == MasterKeys.StaffPatientCategory){
              if (element.valueList.length > 0) {
               this.MasterStaffCode = element.valueList[0].code;
              }
            }
            if (element.key == MasterKeys.StudentPatientCategory){
              if (element.valueList.length > 0) {
                this.MasterStudentCode = element.valueList[0].code;
              }
            }
            if (element.key == MasterKeys.isRaceDependentRequired){
              if (element.valueList.length > 0) {
                this.isNationDependant = element.valueList[0].code=="true"?true:false;
                // this.isNationDependant === false ? this.getRace() : null;
              }
            }
            if (element.key == MasterKeys.firstPayerPriorityRequired){
              if (element.valueList.length > 0) {
                this.isFirstPayerPriority = element.valueList[0].code=="true"?true:false;
              }
            }
            if (element.key == MasterKeys.isDefaultDepositRequired){
              if (element.valueList.length > 0) {
                this.isDefaultDeposit = element.valueList[0].code=="true"?true:false;
              }
            }
            if(element.key == MasterKeys.searchByPostCode) {
              if (element.valueList.length > 0) {
                this.isGetAddress = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.patientNameLtwo) {
              if (element.valueList.length > 0) {
                this.ispatientNameLtwo = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.fullName) {
              if (element.valueList.length > 0) {
                this.isFullName = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.babyOfPrefix) {
              if (element.valueList.length > 0) {
                this.babyOfPrefixCode = element.valueList[0]?.code;
              }
            }
             if(element.key == MasterKeys.isUnitWisePatientSearch) {
              if (element.valueList.length > 0) {
                this.isUnitWisePatientSearch = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.isAiImageSearch) {
              if (element.valueList.length > 0) {
                this.isAiImageSearch = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.SEPERATE_IDENTIFICATION_TYPE_BASED_ON_PRIMARY_FOR_SRIPHAT) {
              if (element.valueList.length > 0) {
                this.showAllIdentificationTypes = element.valueList[0].code == "true";
                this.updateIdentificationLists();
              }
            }
             if(element.key == MasterKeys.rePrintPatientCard) {
              if (element.valueList.length > 0) {
                this.rePrintSlip = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.show_critical_health_tab) {
              if (element.valueList.length > 0) {
                this.showCriticalHealthTab = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.show_Registration_Document_Upload) {
              if (element.valueList.length > 0) {
                this.showRegistrationDocumentUpload = (element.valueList[0].code=="true") ? true : false;
                console.log("showRegistrationDocumentUpload", this.showRegistrationDocumentUpload);
              }
            }
            if(element.key == MasterKeys.IS_KIN_GUARANTOR_REQ) {
              if (element.valueList.length > 0) {
                this.isKinGuarantorRequired = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.IS_NEED_TRANSLATOR){
                   if (element.valueList.length > 0) {
                    this.isNeedTranslator = (element.valueList[0].code == "true") ? true : false;
                  }
                }
            if (element.key == MasterKeys.Is_Foreign_Patient_Expiry_Date_Required) {
              if (element.valueList.length > 0) {
                this.isForeignerExpiryMandatory = (element.valueList[0].code == "true") ? true : false;
              }
            }
             if (element.key == MasterKeys.Is_Department_wise_cabin) {
              if (element.valueList.length > 0) {
                this.isDepartmentWiseCabin = (element.valueList[0].code == "true") ? true : false;
              }
            }
            if (element.key == MasterKeys.SHOW_PATIENT_PREFIX) {
              if (element.valueList.length > 0) {
                this.showPatientPrefix = (element.valueList[0].code == "true") ? true : false;
              }
            }
          });
          this.updateNameValidators();
        }
      });
  }

  getDoctorReqOnEncounterType(event){
    let doctorControl = this.formEncounter.controls["doctor"];
    // this.formEncounter.controls["doctor"].setValue("");
    if (event.isDoctorReq !== undefined) {
    if (event.isDoctorReq) {
      if (!this.isDepartment) {
        doctorControl.setValidators([Validators.required]);
      }
      
    } else {
      doctorControl.clearValidators();
      this.isDepartment = false;
    }
  }
    doctorControl.updateValueAndValidity();
  }
  /**
   *confirm clear window
   *
   * @memberof PatientRegistrationComponent
   */
  confirmClearPatientEncounter() {
    const dialogRefConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { confirm: "no" },
    });
    this.subscriptionList.add(
      dialogRefConfirm.afterClosed().subscribe((result) => {
        if (result.confirm == "yes") {
          this.clearAllPatientEncounter();
        }
      })
    );
  }

  /**
   *race master
   *
   * @memberof PatientRegistrationComponent
   */
  getRace() {
    this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
    this.appBaseService
      .getResource(MASTERSSERVICES.RACE_MASTER,true)
      .subscribe((res) => {
        this.nationalityWiseRace = res;
        this.raceFilterList = res;
        if(this.raceValue) {
        this.formRegistration.patchValue({
        race: this.raceValue
      });
    }
      });
  }

  /**
   *clear all the patient data
   *
   * @memberof PatientRegistrationComponent
   */
  clearAllPatientEncounter() {
    this.isOtherReferral = false; 
    this.othersReferral = '';
    this.isAppointmentHsc = false;
    this.raceMasterSearch=null;
    this.showBadge=false;
    localStorage.removeItem(OPD_CONST.appoinmentRef.aptData);
    localStorage.removeItem(OPD_CONST.admissionFormRequest);
    this.genderValue = null;
    this.identifierTypeValue = null;
    this.primaryIdSearch = null;
    this.countryCodeValue = null;
    this.titleValue = null;
    this.countryValue = null;
    this.appointmentReference.doctorCode = "";
    this.appointmentReference.departmentCode = "";
    this.appointmentReference.appointmentId = "";
    this.appointmentReference.appointmentNo = "";
    this.appointmentReference.tempPatientId = "";
    this.appointmentReference.healthPackage = "";
    this.previousInternalNotes = [];
    this.internalNotesList = [];
    this.appointmentData = null;
    this.isAdmissionRequest = false;
    this.patientId = "";
    this.selectedPatient = null;
    this.patientInfoDisplay = "";
    this.defaultDeposit = "";
    this.formRegistration.reset();
    this.formEncounter.reset();
    this.formNextOfKin.reset();
    this.otherDetail.reset();
    this.countrySecondaryValue = null;
    this.stateSecondaryValue = null;
    this.citySecondaryValue = null;
    this.districtSeoncdaryValue = null;
    this.CountryCode = null;
    this.StateCode = null;
    this.CityCode = null;
    this.stateValue = null;
    this.cityValue = null;
    this.districtValue = null;
    this.secondaryCountryCode = null;
    this.secondaryStateCode = null;
    this.secondaryDistrictCode = null;
    this.encounterTypeValue = null;
    this.departmentValue = null;
    this.doctorValue = null;
    this.doctorValueappointment = null;
    this.countryEmploymentValue = null;
    this.stateEmploymentValue = null;
    this.cityEmploymentValue = null;
    this.raceValue = null;
    this.religionValue = null;
    this.patientImage = "";
    this.selectedPatient=null;
    this.fileSource = new MatTableDataSource();
    this.fileSourceReg = new MatTableDataSource();
    this.dataSourceNextOfKin = new MatTableDataSource<any>([]);
    this.dataSourceEncounters = new MatTableDataSource<any>([]);
    // let patientEncounterPayer = new PatientEncounterPayer();
    // patientEncounterPayer.isSelf = true;
    this.dataSourcePayers = new MatTableDataSource<any>([]);
    this.getPayerTypeList();
    // this.getPayerList();
    this.groupedItems=[];
   //this.getUnitData();
    this.fillDropDownLists();
    this.pdpaForm = false;
    this.isFromAppointment=false;
    this.isOtherDetailsShow = false;
    this.identificationList = new MatTableDataSource<Identification>([]);
    this.selectedPatientIdentificationList=[];
    this.addEmptyIdentificationEntry("P");
    this.tokenValue = "";
    this.cardReaderStatus = false;
    this.kinData = [];
    this.criticalHealthList = [];
    this.dataSourceCriticalHeailthActive.data = [];
    this.dataSourceCriticalHeailthInactive.data = [];
  }

  /**
   *remove payer
   *
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  removePayer(element) {
    let list = this.dataSourcePayers.data;
    const index: number = list.indexOf(element);
    list.splice(index, 1);
    this.dataSourcePayers = new MatTableDataSource<any>(list);
  }

  /**
   *change payer priority
   *
   * @param {boolean} moveUp
   * @param {number} index
   * @memberof PatientRegistrationComponent
   */
  changePayerPriority(moveUp: boolean, index: number) {
    let list = this.dataSourcePayers.data;
    var element = list[index];
    if (moveUp && index > 0) {
      list.splice(index, 1);
      list.splice(index - 1, 0, element);
    } else if (!moveUp && index != list.length - 1) {
      list.splice(index, 1);
      list.splice(index + 1, 0, element);
    }
    this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(list);
  }

  /**
   *address same check box
   *
   * @param {*} event
   * @memberof PatientRegistrationComponent
   */
  bothAddressSame(event) {
    if (event.checked) {
      this.isSameAddress = event.checked;
      this.formRegistration.patchValue({
        addressSecondary: this.formRegistration.controls["addressPrimary"].value,
        pincodeSecondary: this.formRegistration.controls["pincodePrimary"].value,
      });
      this.countrySecondaryValue =
        this.formRegistration.controls["countryPrimary"].value.code;
      this.getStateSecondaryList(this.countrySecondaryValue, true);
    } else {
      this.formRegistration.patchValue({
        addressSecondary: null,
        pincodeSecondary: null,
      });
      this.countrySecondaryValue = null;
      this.stateSecondaryValue = null;
      this.citySecondaryValue = null;
      this.districtSeoncdaryValue = null;
    }
  }

  /**
   *get patient data
   *
   * @param {*} patient
   * @memberof PatientRegistrationComponent
   */
  getPatientData(patient) {
    this.identificationList=new MatTableDataSource<Identification>([]);
    this.PatientData = patient;
    if (patient.id == "ExtendedPatient/Patient Not Registered") {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleaseresetencounter"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    } else {
      if (
        patient.ctos ||
        patient.blocked ||
        patient.deceased ||
         patient.merged && this.patientForm|| 
        patient.isInactive || 
        !patient.isVerified && !this.isFromAnotherScreen ||
        patient.haveConditionType
      ) {
        const reasons: string[] = [];
        if (patient.deceased) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>heart_broken</span></div><div>"+this.langService.get("EncounterPage.unabletoProceedDecease")+"</div></div>");
        }
        if (patient.merged) {
          reasons.push("<div class='div'>" +"<div><span class='material-icons blocked-icon'>call_merge</span></div>" + "<div>" + this.langService.get('RegistrationPage.mrn') + " " +
           patient.mrn + this.langService.get('EncounterPage.mergeMes') + patient.mergedPatient +this.langService.get('EncounterPage.mergeMes1') +"</div>" + "</div>");
        }

        if (patient.blocked) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>person_off</span> </div><div>"+this.langService.get("EncounterPage.selectPatientBlock")+"</div></div>");
        }

        if (patient.isInactive) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>pause_circle</span></div><div>"+this.langService.get("EncounterPage.selectPatientInactive")+"</div></div>");
        }

        if (!patient.isVerified && !this.isFromAnotherScreen) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>swap_horiz</span></div><div>"+this.langService.get("EncounterPage.migratedRecordMessage")+"</div></div>");
        }

        if (patient.ctos) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>receipt_long</span></div><div>"+this.langService.get("EncounterPage.info")+"</div></div>");
        }
        if (patient.haveConditionType) {
          reasons.push(
            "<div class='div'><div><span class='material-icons blocked-icon'>warning</span></div>" +
            "<div>"+this.langService.get("EncounterPage.criticalPatientMeg")+"</div></div>"
          );
        }

        if (!reasons.length) {
          return;
        }
        const formatReasons = (items: string[]) => {
          if (items.length === 1) return items[0];
          if (items.length === 2) return items.join(' <br>');
          return items.slice(0, -1).join(', <br>') + ' <br> '+items[items.length - 1];
        };

        const finalMessage =  formatReasons(reasons);

        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "30%",
          data: {
            display: this.langService.get("EncounterPage.info"),
            info:finalMessage,
            isVerified: patient.isVerified,
          },
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (
              result != undefined &&
              result.confirm &&
              result.confirm == "yes"
            ) {
              if (patient.haveConditionType && !this.patientForm) {
                setTimeout(() => {
                  this.tabGroup.selectedIndex = this.tabGroup._tabs.length - 1;
                });
              }
              this.isRegistered=patient.merged ? true : false;
              if(!patient.isVerified && !result.isClose){
                this.patientForm = true;
                this.isBackAllow=true;
              }
              if(!patient.blocked)
              {
              this.selectedPatient = patient;

              this.religionValue = this.selectedPatient
                ? this.selectedPatient.religion
                : "";

              this.raceValue = this.selectedPatient
                ? this.selectedPatient.race
                : "";
              this.getRace();
              this.genderValue = this.selectedPatient
                ? this.selectedPatient.gender
                : "";
                this.genderCode = this.genderList
                .find((e) => e.desc == this.genderValue);
                if(this.genderCode.code.toLowerCase() == "female"){                  
                  this.isOtherDetailsShow = true;
                }
                
               
              // this.primaryIdSearch = this.selectedPatient;
              // this.identifierTypeValue = this.selectedPatient
              //   ? this.selectedPatient.identifierType
              //   : "";
              this.countryCodeValue =
                this.selectedPatient && this.selectedPatient.countryCode
                  ? this.selectedPatient.countryCode
                  : "";
              this.titleValue = this.selectedPatient
                ? this.selectedPatient.title
                : "";
                this.selectedPrimaryId = this.selectedPatient
                ? this.selectedPatient.idNo
                : "";
              this.patientCategory = this.selectedPatient
                ? this.selectedPatient.patientCategory
                : "";
              this.countryValue = this.selectedPatient
                ? this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.country
                  : null
                : null;

              var dobFormatted = "";
              var patientAge = undefined;
              if (patient.dateOfBirth) {
                dobFormatted = this.datepipe.transform(
                  patient.dateOfBirth,
                  "dd/MM/yyyy"
                );
                let dobDate = new Date(patient.dateOfBirth);
                patientAge = this.utilsService.getAge(dobDate);
                patientAge =
                  patientAge > 1
                    ? "(" + patientAge + " Years)"
                    : "(" + patientAge + " Year)";
              }
              let mrn= patient.mrn ? patient.mrn : '-';
              this.patientInfoDisplay =
                mrn +
                " / " + (patient.title ? patient.title + " " : "") +
                (patient.patientNameLangBase || patient.fullName) +
                " / " +
                (patient.gender ? patient.gender : "Unknown") +
                " / " +
                (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");
              
              let photo=  patient.photo ? patient.photo : "";
              if( photo && photo.includes("doc-service")) photo=this.imageUrl+ photo;
            
              if(!this.patientImage) this.patientImage = photo;
              this.formRegistration.enable();
              this.patientId = patient.id;
              if (patient.patientNotes)
                this.formEncounter.controls["reportRemarks"].setValue(
                  patient.patientNotes
                );
              
              if (patient.identifierType === "Passport") {
                this.formRegistration.controls["expiryDate"].enable();
                this.isexpiryDate = true;
              } else {
                this.formRegistration.controls["expiryDate"].setValue("");
                this.formRegistration.controls["expiryDate"].disable();
                this.isexpiryDate = false;
              }
              
              let primaryIdValue = this.primaryIdFilteredList.find(e=>e.code==patient.identifierType);
            //  this.isEncounterAllow=primaryIdValue?true:false;
            setTimeout(() => {
              this.formRegistration.patchValue({
                primaryId: (primaryIdValue && primaryIdValue.code) ? primaryIdValue.code : "",
              });                 
            }, 700);
              this.mandatoryField.issuingCountry = primaryIdValue ? primaryIdValue.isCountryRequired : false;
              let secondaryIdType=this.identificationTypeList.find(e=>e.staticCode==patient.secondaryIdType);
              this.formRegistration.patchValue({
                aliasName: patient.aliasName ? patient.aliasName : "",
                fullName:patient.fullName ? patient.fullName : "",
                id: patient.id,
                active:patient.active,
                mrn: patient.mrn,
                primaryNumber: patient.idNo,
                // primaryId: (primaryIdValue && primaryIdValue.code) ? primaryIdValue.code : "",
                expiryDate: patient.expiryDate
                  ? new Date(patient.expiryDate)
                  : "",
                issuedCountryPrimary: patient.idIssueCountry
                  ? patient.idIssueCountry
                  : "",
                secondaryId:secondaryIdType
                  ?secondaryIdType.code
                  : "",
                secondaryNumber: patient.secondaryNo,
                issuedCountrySecondary: "",
                firstName: patient.firstName,
                middleName:patient.middleName,
                lastName:patient.lastName,
                firstNameTh:patient.firstNameTh?patient.firstNameTh:"",
                middleNameTh:patient.middleNameTh?patient.middleNameTh:"",
                lastNameTh : patient.lastNameTh?patient.lastNameTh:"",
                dateOfBirth: patient.dateOfBirth
                  ? new Date(patient.dateOfBirth)
                  : "",
                birthTime: patient.birthTime ? patient.birthTime : "",
                realdob: patient.real ? patient.real : false,
                birthplace: patient.birthlocation ? patient.birthlocation : "",
                tinNo:patient.tinNo ? patient.tinNo : "",
                motherName: patient.motherName ? patient.motherName : "",
                patientNotes: patient.patientNotes ? patient.patientNotes : "",
                addressPrimary: patient.extendedAddress
                  ? patient.extendedAddress.addressLine
                  : "",
                countryPrimary: patient.extendedAddress && patient.extendedAddress?.country
                  ? patient.extendedAddress?.country
                  : "",
                statePrimary: patient.extendedAddress && patient.extendedAddress.state
                  ? patient.extendedAddress.state
                  : "",
                cityPrimary:
                  patient.extendedAddress && patient.extendedAddress.city
                    ? patient.extendedAddress.city
                    : "",
                subDistrictPrimary:
                  patient.extendedAddress && patient.extendedAddress.area
                    ? patient.extendedAddress.area
                    : "",
                pincodePrimary: patient.extendedAddress
                  ? patient.extendedAddress.postCode
                  : "",
                emailId: patient.emailId,
                homeContact: patient.homeContactNo,
                mobileNumber: patient.mobileNumber,
                addressSecondary: patient.correspondingAddress
                  ? patient.correspondingAddress.addressLine
                  : "",

                pincodeSecondary: patient.correspondingAddress
                  ? patient.correspondingAddress.postCode
                  : "",
                workContact: patient.workContactNo,
                contactRelation: patient.relation ? patient.relation : "",
                isDeceased: patient.deceased ? patient.deceased : "",
                isRadioactiveImplant: patient.radioactiveImplant ? patient.radioactiveImplant.radioactiveImplant : false,
                isBlocked: patient.blocked ? patient.blocked : "",
                isVip: patient.vip ? patient.vip : false,
                vipRemarks: patient.vipRemark ? patient.vipRemark : "",
                isNewborn: patient.newBorn ? patient.newBorn : false,
                workFax: patient.workFax ? patient.workFax : "",
                personalFax: patient.personalFax ? patient.personalFax : "",
                secondaryExpirydate: patient.seondaryExpiryDate
                  ? new Date(patient.seondaryExpiryDate)
                  : "",
                employmentStatus: patient.employmentStatus
                  ? patient.employmentStatus
                  : "",
                employerName: patient.employerName ? patient.employerName : "",
                employerNameOthers: patient.employerNameOthers
                  ? patient.employerNameOthers
                  : "",
                patientCategory: patient.patientCategory ? patient.patientCategory:"",
                employmentNo: patient.employmentNo ? patient.employmentNo : "",
                workingFrom: patient.workingFrom ? patient.workingFrom : "",
                employmentContactNo: patient.employmentContactNo
                  ? patient.employmentContactNo
                  : "",
                employmentAddress: patient.employmentAddress
                  ? patient.employmentAddress
                  : "",
                employmentCountry: patient.employmentCountry
                  ? patient.employmentCountry
                  : "",
                employmentState: patient.employmentState
                  ? patient.employmentState
                  : "",
                employmentCity: patient.employmentCity
                  ? patient.employmentCity
                  : "",
                employmentPostCode: patient.employmentPostCode
                  ? patient.employmentPostCode
                  : "",
                needTranslator : patient.needTranslator ? patient.needTranslator : false,
                translatorLanguage: patient.translatorLanguage ? patient.translatorLanguage : ""
                
              });
              this.uhId=patient.uhId?patient.uhId:"";
               if ((patient.primaryIdentificationList && patient.primaryIdentificationList.length > 0) ||
               (patient.secondaryIdentificationList && patient.secondaryIdentificationList.length > 0)) {
                  const tempData: any[] = [];
                  // Handle Primary Identification
                  patient.primaryIdentificationList?.forEach((element) => {
                    const idTypeCode = this.getObjByCode(this.primaryIdFilteredList, element.code);
                    const data = {
                      identifierUUID: element.identifierUUID || '',
                      type: 'P',
                      idType: element.code,
                      idNumber: element.value ? element.value : "",
                      expDate: element.expiryDate,
                      primaryIdRegex: OPD_CONST.primaryIdRegix,
                      isExpiryRequired: idTypeCode.isExpireReq,
                      issuingCountry: element.issuingCountryCode || '',
                      isCopied: element.status === false,
                      isIdNumberValid: element.value?.length > 0 ? true : false,
                      isCountryRequired: false
                    };
                    this.uhId = patient.uhId ? patient.uhId : "";

                    if (element.status) {
                      this.identificationList.data.push(data);
                      const newIndex = this.identificationList.data.length - 1;
                      this.primaryIdentificationOnChange(idTypeCode, false, newIndex);
                    } else {
                      tempData.unshift(data);
                    }
                  });

                  // Handle Secondary Identification
                  patient.secondaryIdentificationList?.forEach((element) => {
                    if (element.status) {
                      const data = {
                        identifierUUID: element.identifierUUID || '',
                        type: 'S',
                        idType: element.code,
                        idNumber: element.value ? element.value : "",
                        expDate: element.expiryDate,
                        issuingCountry: element.issuingCountryCode || '',
                        primaryIdRegex: OPD_CONST.primaryIdRegix,
                        isExpiryRequired: false,
                        isIdNumberValid: element.value.length > 0 ? true : false,
                        isCountryRequired: false
                      };
                      this.identificationList.data.push(data);
                    }
                  });

                  const sorted = this.identificationList.data
                    .filter(d => !d.isCopied)
                    .concat(tempData);
                  this.identificationList.data = [...sorted];

                } else {
                  this.addEmptyIdentificationEntry("P");
                }

                this.selectedPatientIdentificationList = JSON.parse(JSON.stringify(this.identificationList.data));

              if (patient.healthTouristDetailsDTO) {
                this.healthTouristList = [];
                patient.healthTouristDetailsDTO.forEach((ele) => {
                  let startDateValue = this.epochToDateConverter(ele.startDate);
                  let endDateValue = this.epochToDateConverter(ele.endDate);
                  let currentDateValue = this.epochToDateConverter(
                    ele.currentDate
                  );

                  let obj = {
                    healthTouristId: ele.healthTouristId
                      ? ele.healthTouristId
                      : "",
                    code: ele.healthTouristCode ? ele.healthTouristCode : "",
                    identificationType: {
                      desc: ele.agentIdentificationType
                        ? ele.agentIdentificationType
                        : "",
                    },
                    identificationNumber: ele.agentIdentificationNo
                      ? ele.agentIdentificationNo
                      : "",
                    agentName: ele.agentName ? ele.agentName : "",
                    startDate: startDateValue,
                    endDate: endDateValue,
                    contactNo: ele.contactNo ? Number(ele.contactNo) : "",
                    emailId: ele.emailId ? ele.emailId : "",
                    currentDate: currentDateValue,
                  };
                  this.healthTouristList.push(obj);
                });
                this.healthTouristSource = new MatTableDataSource<any>(
                  this.healthTouristList
                );
              } else {
                this.healthTouristSource = new MatTableDataSource<any>();
              }
              // this.primaryIdentificationOnChange(primaryIdValue,false);
              if(this.raceValue)
              this.selectNationality(this.raceValue);
              this.countrySecondaryValue = patient.correspondingAddress.country;
              this.getStatePrimaryList(
                patient.correspondingAddress && patient.extendedAddress.country
                  ? patient.extendedAddress.country
                  : "",
                true
              );
              this.getStateSecondaryList(
                patient.correspondingAddress &&
                  patient.correspondingAddress.country
                  ? patient.correspondingAddress.country
                  : "",
                true
              );

              (this.countryEmploymentValue = patient.employmentCountry
                ? patient.employmentCountry
                : null),
                this.getStateEmploymentList(
                  patient.employmentCountry ? patient.employmentCountry : "",
                  true
                );

              if (
                patient.extendedAddress.addressLine ==
                  patient.correspondingAddress.addressLine &&
                patient.extendedAddress.postCode ==
                  patient.correspondingAddress.postCode
              ) {
                this.isBothAddressSame = true;
              }
              if (patient.isVerified && !patient.haveConditionType && !(patient.merged && this.patientForm)) {
              this.formRegistration.disable();
              this.formRegistration.get('isDeceased').enable();
              this.isEncounterAllow=true;
              }
            }else{
               this.isBackAllow=false;
               this.addEmptyIdentificationEntry("P");
            }
            }else {
              this.addEmptyIdentificationEntry("P");
            }
          })
        );
        this.patientCategory = patient.patientCategory;
        this.patientId=patient.id;
        this.getNOKList();
        
        this.getCriticalHealthList();
        setTimeout(() => {
          this.getDocuments(patient.mrn);
        }, 2000);
         this.getOustandAmount(patient.mrn);
      } else {
         if(!patient.isVerified){
                this.patientForm = true;
                this.isBackAllow=true;
              }
        this.selectedPatient = {};
        if(this.isPatientType == "Staff"){
          this.selectedPatient.patientCategory = this.MasterStaffCode;
         }else if(this.isPatientType == "Student"){
      this.selectedPatient.patientCategory = this.MasterStudentCode;
     }else{
      this.patientCategory =patient.patientCategory ? patient.patientCategory : "";
     }
        this.getOustandAmount(patient.mrn);
        // this.getAppointmentCheck(patient.mrn);
        // this.getPreviousPayerList(patient.mrn);
        this.selectedPatient = patient;
        this.genderValue = this.selectedPatient
          ? this.selectedPatient.gender
          : "";
          this.genderCode = this.genderList
          .find((e) => e.desc == this.genderValue);
          if(this.genderCode.code.toLowerCase() == "female"){
         
            this.isOtherDetailsShow = true;
          }
        this.raceValue = this.selectedPatient
          ? this.selectedPatient.race
          : "";
        this.getRace();
        this.religionValue = this.selectedPatient
          ? this.selectedPatient.religion
          : "";
        // this.primaryIdSearch = this.selectedPatient;
        // this.identifierTypeValue = this.selectedPatient
        //   ? this.selectedPatient.identifierType
        //   : "";
        this.countryCodeValue =
          this.selectedPatient && this.selectedPatient.countryCode
            ? this.selectedPatient.countryCode
            : "";
        this.titleValue = this.selectedPatient
          ? this.selectedPatient.title
          : "";
          this.selectedPrimaryId = this.selectedPatient
          ? this.selectedPatient.idNo
          : "";
        this.countryValue = this.selectedPatient
          ? this.selectedPatient.extendedAddress
            ? this.selectedPatient.extendedAddress.country
            : null
          : null;
        var dobFormatted = "";
        var patientAge = undefined;
        if (patient.dateOfBirth) {
          dobFormatted = patient.dateOfBirth ? this.language=="th"?this.enThConvertService.convertToThaiFullDateWithOutTime(patient.dateOfBirth) :this.datepipe.transform(patient.dateOfBirth, "dd/MM/yyyy"): "";
          
          // this.datepipe.transform(
          //   patient.dateOfBirth,
          //   "dd/MM/yyyy"
          // );
          let dobDate = new Date(patient.dateOfBirth);
          patientAge = this.utilsService.getAge(dobDate);
          patientAge =
            patientAge > 1
              ? "(" + patientAge + " Years)"
              : "(" + patientAge + " Year)";
        }
        let mrn= patient.mrn ? patient.mrn : '-';
        this.patientInfoDisplay =
        mrn +
        " / " + (this.showPatientPrefix && patient.displayTitle
          ? patient.displayTitle + " "
          : "") +
          (patient.patientNameLangBase || patient.fullName) +
          " / " +
          (patient.gender ? patient.gender : "Unknown") +
          " / " +
          (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");
         
        let photo=  patient.photo ? patient.photo : "";
        if( photo && photo.includes("doc-service"))
          photo=this.imageUrl+ photo;
        this.patientImage = photo;
        this.formRegistration.enable();
        this.patientId = patient.id;
        if (patient.patientNotes)
          this.formEncounter.controls["reportRemarks"].setValue(
            patient.patientNotes
          );
          
        //  if (patient.referralRemark)
        //   this.formEncounter.controls.referralRemarks.setValue(
        //     patient.referralRemarks
        //  );

        //  if (patient.remark)
        //   this.formEncounter.controls.remarks.setValue(
        //     patient.remarks
        //  );
        if (patient.identifierType === "Passport") {
          this.formRegistration.controls["expiryDate"].enable();
          this.isexpiryDate = true;
        } else {
          this.formRegistration.controls["expiryDate"].setValue("");
          this.formRegistration.controls["expiryDate"].disable();
          this.isexpiryDate = false;
        }
        

        let primaryIdValue = this.primaryIdFilteredList.find(e=>e.desc==patient.identifierType);
        setTimeout(() => {
          this.formRegistration.patchValue({
            primaryId: (primaryIdValue && primaryIdValue.code) ? primaryIdValue.code : "",
          });
        }, 700);
       // this.isEncounterAllow=primaryIdValue?true:false;
        this.mandatoryField.issuingCountry = primaryIdValue ? primaryIdValue.isCountryRequired : false; 
        let secondaryIdType=this.identificationTypeList.find(e=>e.staticCode==patient.secondaryIdType);
        this.formRegistration.patchValue({
          aliasName: patient.aliasName ? patient.aliasName : "",
          fullName:patient.fullName ? patient.fullName : "",
          id: patient.id,
          active:patient.active,
          mrn: patient.mrn,
          primaryNumber: patient.idNo,
          // primaryId: (primaryIdValue && primaryIdValue.code) ? primaryIdValue.code : "",
          expiryDate: patient.expiryDate ? new Date(patient.expiryDate) : "",
          issuedCountryPrimary: patient.idIssueCountry
            ? patient.idIssueCountry
            : "",
          secondaryId: secondaryIdType ? secondaryIdType.code : "",
          secondaryNumber: patient.secondaryNo,
          issuedCountrySecondary: "",
          firstName: patient.firstName,
          middleName:patient.middleName,
          lastName:patient.lastName,
          firstNameTh:patient.firstNameTh?patient.firstNameTh:"",
          middleNameTh:patient.middleNameTh?patient.middleNameTh:"",
          lastNameTh : patient.lastNameTh?patient.lastNameTh:"",
          dateOfBirth: patient.dateOfBirth ? new Date(patient.dateOfBirth) : "",
          birthTime: patient.birthTime ? patient.birthTime : "",
          realdob: patient.real ? patient.real : false,
          birthplace: patient.birthlocation ? patient.birthlocation : "",
          tinNo:patient.tinNo ? patient.tinNo : "",
          motherName: patient.motherName ? patient.motherName : "",
          patientNotes: patient.patientNotes ? patient.patientNotes : "",
          
          addressPrimary: patient.extendedAddress
            ? patient.extendedAddress.addressLine
            : "",
          countryPrimary: patient.extendedAddress && patient.extendedAddress?.country
              ? patient.extendedAddress?.country
              : "",
          statePrimary: patient.extendedAddress && patient.extendedAddress.state
              ? patient.extendedAddress.state
              : "",
          cityPrimary:
            patient.extendedAddress && patient.extendedAddress.city
              ? patient.extendedAddress.city
              : "",
          subDistrictPrimary:
            patient.extendedAddress && patient.extendedAddress.area
              ? patient.extendedAddress.area
              : "",
          pincodePrimary: patient.extendedAddress
            ? patient.extendedAddress.postCode
            : "",
          emailId: patient.emailId?patient.emailId:"",
          homeContact: patient.homeContactNo?patient.homeContactNo:"",
          mobileNumber: patient.mobileNumber? patient.mobileNumber:"",
          addressSecondary: patient.correspondingAddress
            ? patient.correspondingAddress.addressLine
            : "",

          pincodeSecondary: patient.correspondingAddress
            ? patient.correspondingAddress.postCode
            : "",
          workContact: patient.workContactNo? patient.workContactNo :"",
          contactRelation: patient.relation ? patient.relation : "",
          isDeceased: patient.deceased ? patient.deceased : "",
          isRadioactiveImplant: patient.radioactiveImplant ? patient.radioactiveImplant.radioactiveImplant : false,
          isBlocked: patient.blocked ? patient.blocked : "",
          isVip: patient.vip ? patient.vip : false,
          vipRemarks: patient.vipRemark ? patient.vipRemark : "",
          isNewborn: patient.newBorn ? patient.newBorn : false,
          workFax: patient.workFax ? patient.workFax : "",
          personalFax: patient.personalFax ? patient.personalFax : "",
          secondaryExpirydate: patient.seondaryExpiryDate
            ? new Date(patient.seondaryExpiryDate)
            : "",
          employmentStatus: patient.employmentStatus
            ? patient.employmentStatus
            : "",
          employerName: patient.employerName ? patient.employerName : "",
          employerNameOthers: patient.employerNameOthers
            ? patient.employerNameOthers
            : "",
          employmentNo: patient.employmentNo ? patient.employmentNo : "",
          workingFrom: patient.workingFrom ? patient.workingFrom : "",
          employmentContactNo: patient.employmentContactNo
            ? patient.employmentContactNo
            : "",
          employmentAddress: patient.employmentAddress
            ? patient.employmentAddress
            : "",
          employmentCountry: patient.employmentCountry
            ? patient.employmentCountry
            : "",
          employmentState: patient.employmentState
            ? patient.employmentState
            : "",
          employmentCity: patient.employmentCity ? patient.employmentCity : "",
          employmentPostCode: patient.employmentPostCode
            ? patient.employmentPostCode
            : "",
          needTranslator : patient.needTranslator ? patient.needTranslator : false,
          translatorLanguage: patient.translatorLanguage ? patient.translatorLanguage : ""
        });
        if ((patient.primaryIdentificationList && patient.primaryIdentificationList.length > 0) ||
        (patient.secondaryIdentificationList && patient.secondaryIdentificationList.length > 0)) {
          const tempData: any[] = [];
          // Handle Primary Identification
          patient.primaryIdentificationList?.forEach((element) => {
            const idTypeCode = this.getObjByCode(this.primaryIdFilteredList, element.code);
            const data = {
              identifierUUID: element.identifierUUID || '',
              type: 'P',
              idType: element.code,
              idNumber: element.value?element.value:"",
              expDate: element.expiryDate,
              primaryIdRegex: OPD_CONST.primaryIdRegix,
              isExpiryRequired: idTypeCode.isExpireReq,
              issuingCountry: element.issuingCountryCode || '',
              isCopied: element.status === false,
              isIdNumberValid:element.value?.length>0?true:false,
              isCountryRequired:false
            };
            this.uhId=patient.uhId?patient.uhId:"";
        
            if (element.status) {
              this.identificationList.data.push(data);
              const newIndex = this.identificationList.data.length - 1;
              this.primaryIdentificationOnChange(idTypeCode, false, newIndex);
            } else {
              tempData.unshift(data); 
            }
          });
        
          // Handle Secondary Identification
          patient.secondaryIdentificationList?.forEach((element) => {
            if (element.status) {
              const data = {
                identifierUUID: element.identifierUUID || '',
                type: 'S',
                idType: element.code,
                idNumber: element.value?element.value:"",
                expDate: element.expiryDate,
                issuingCountry: element.issuingCountryCode || '',
                primaryIdRegex: OPD_CONST.primaryIdRegix,
                isExpiryRequired: false,
                isIdNumberValid:element.value.length>0?true:false,
                isCountryRequired:false
              };
              this.identificationList.data.push(data);
            }
          });
        
          const sorted = this.identificationList.data
            .filter(d => !d.isCopied)
            .concat(tempData);
          this.identificationList.data = [...sorted];
        
        } else {
          this.addEmptyIdentificationEntry("P");
        }
        
        this.selectedPatientIdentificationList = JSON.parse(JSON.stringify(this.identificationList.data));

        if (patient.healthTouristDetailsDTO) {
          this.healthTouristList = [];
          patient.healthTouristDetailsDTO.forEach((ele) => {
            let startDateValue = this.epochToDateConverter(ele.startDate);
            let endDateValue = this.epochToDateConverter(ele.endDate);
            let currentDateValue = this.epochToDateConverter(ele.currentDate);

            let obj = {
              healthTouristId: ele.healthTouristId ? ele.healthTouristId : "",
              code: ele.healthTouristCode ? ele.healthTouristCode : "",
              identificationType: {
                desc: ele.agentIdentificationType.display
                  ? ele.agentIdentificationType.display
                  :ele.agentIdentificationType?ele.agentIdentificationType:"",
              },
              identificationNumber: ele.agentIdentificationNo
                ? ele.agentIdentificationNo
                : "",
              agentName: ele.agentName ? ele.agentName : "",
              startDate: startDateValue,
              endDate: endDateValue,
              contactNo: ele.contactNo ? Number(ele.contactNo) : "",
              emailId: ele.emailId ? ele.emailId : "",
              currentDate: currentDateValue,
            };
            this.healthTouristList.push(obj);
          });
          this.healthTouristSource = new MatTableDataSource<any>(
            this.healthTouristList
          );
        } else {
          this.healthTouristSource = new MatTableDataSource<any>();
        }
        if(patient.employeeDetailsDTO){
          var details=patient.employeeDetailsDTO;
          this.formRegistration.patchValue({
            employerName:details?.employerdetails?.employer?.[0]?.code ?? '',
            employerNameOthers:details?.other ?? '',
            employmentNo:details?.employmentNo ?? '',
            workingFrom: details.workingFrom?new Date(details.workingFrom * 1000):0,
            employmentContactNo: details?.contactNo ?? null,
            employmentAddress:details.employeeAdress?details.employeeAdress.addressLine: "",
            employmentState:details.employeeAdress?details.employeeAdress.state.code: "",
            employmentCountry:details.employeeAdress?details.employeeAdress.country.code: "",
            employmentCity: details.employeeAdress?details.employeeAdress.city.code: "",
            employmentPostCode:details.employeeAdress?details.employeeAdress.postCode: "",
          });         
        }
        if(this.raceValue)
        this.selectNationality(this.raceValue);
        this.countrySecondaryValue = patient.correspondingAddress.country;
        this.getStatePrimaryList(
          patient.correspondingAddress && patient.extendedAddress.country
            ? patient.extendedAddress.country
            : "",
          true
        );
        this.getStateSecondaryList(
          patient.correspondingAddress && patient.correspondingAddress.country
            ? patient.correspondingAddress.country
            : "",
          true
        );

        (this.countryEmploymentValue = patient.employmentCountry!==undefined
          ? patient.employmentCountry
          : (details?details.employeeAdress.country.code:null)),
          this.getStateEmploymentList(
            patient.employmentCountry ? patient.employmentCountry : (details?details.employeeAdress.country.code:''),
            true
          );

        if (
          patient.extendedAddress.addressLine ==
            patient.correspondingAddress.addressLine &&
          patient.extendedAddress.postCode ==
            patient.correspondingAddress.postCode
        ) {
          this.isBothAddressSame = true;
        }
        this.getNOKList();
        this.getCriticalHealthList();
        setTimeout(() => {
          this.getDocuments(patient.mrn);
        }, 2000);
      }
    }
    if (patient && patient.mrn) {
      this.getPreviousPayerList(patient.mrn);
      this.getAppointmentCheck(patient.mrn);
    }
    this.isVip = patient.vip;
  }
  isIdentificationTypeDisabled(element: any): boolean {
    const isNewborn = this.formRegistration.get('isNewborn')?.value;
    return !isNewborn && (element.isCopied || !!element.identifierUUID);
  }
  /**
   * To edit on patient click
   */
  editPatientClicked() {
    if (this.selectedPatient) {
      const formRegistration = this.formRegistration.controls;
      const IdTypeCode = formRegistration["IdTypeCode"]
        ? formRegistration["IdTypeCode"].value
        : "";

      if (IdTypeCode) {
        this.isexpiryDate = IdTypeCode.isExpireReq;

        if (!this.isexpiryDate) {
          formRegistration["expiryDate"].setValue("");
          formRegistration["expiryDate"].disable();
          this.isexpiryDate = true;
        } else {
          formRegistration["expiryDate"].enable();
          this.isexpiryDate = false;
        }
      }
      //this.getpatientbyId(this.selectedPatient.mrn);
      this.initSearchFilter();
    }
  }

  /**
   *validate kin form
   *
   * @return {*}  {boolean}
   * @memberof PatientRegistrationComponent
   */
  validateNextOfKinForm(): boolean {
    for (var i in this.formNextOfKin.controls) {
      this.formNextOfKin.controls[i].markAsTouched();
    }
    return this.formNextOfKin.valid;
  }

  /**
   *add next kin
   *
   * @memberof PatientRegistrationComponent
   */
    addNextOfKin(value: string) {
    if (value && value.trim() === 'add') {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Add Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            if (this.validateNextOfKinForm()) {
              let nextOfKin: PatientNextOfKin =
                this.patientRegService.getNextOfKinFormValues(this, this.formNextOfKin);
              nextOfKin.checked = true;
              if (nextOfKin) {
                let list = this.dataSourceNextOfKin.data;
                list.push(nextOfKin);
                this.dataSourceNextOfKin = new MatTableDataSource<any>(list);
                this.formNextOfKin.reset();
                this.getNokforSave(nextOfKin,nextOfKin);
              }
            } else {
              this.snackBar.open(
                "Please fill all required fields",
                "Validation",
                { duration: 2000 }
              );
            }
          }
        })
      );
    } else {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Update Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            let nextOfKin: any =
              this.patientRegService.getNextOfKinFormValues(this, this.formNextOfKin);
            var index = this.dataSourceNextOfKin.data.findIndex(
              kin => kin?.iid === this.nokIid || kin?.id?.toString() === this.nokId
            );
            this.dataSourceNextOfKin.data.forEach((kin) => {
              if (kin.iid?.toString() === this.nokId) {
                nextOfKin.iid = this.nokIid;
              } else if (kin.id?.toString() === this.nokId) {
                nextOfKin.id = this.nokId;
              }
            });

            if (index !== -1) {
              this.dataSourceNextOfKin.data[index] = nextOfKin;
            } else {
              this.snackBar.open('No matching record found to replace', 'Validartion', {
                duration: 2000
              });
            }
            this.dataSourceNextOfKin._updateChangeSubscription();
            this.isEditNok = false;
            this.formNextOfKin.reset();
            this.getNokforSave(nextOfKin,nextOfKin);
            this.saveNextOfKin();
          }
        })
      );
    }
     return this.formNextOfKin.controls["name"].valid;
  }

  /**
   *add payer
   *
   * @memberof PatientRegistrationComponent
   */
  addPayer() {
    if (this.dataSourcePayers.data.length > 0) {
      let list = this.dataSourcePayers.data;
      let patientEncounterPayer = new PatientEncounterPayer();
      patientEncounterPayer.priority = null;
      if(!this.isFirstPayerPriority){
        list.push(new PatientEncounterPayer());
      }else{
        list.unshift(new PatientEncounterPayer());
      }
      this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(
        list
      );
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleaseselectpatient"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
  }

  /**
   *fill dropdownlist
   *
   * @memberof PatientRegistrationComponent
   */
  fillDropDownLists() {
    this.getHealthPackgeList();
    // this.getPrimaryIdList();
    this.getRelationList();
    this.getCountryList();
     //this.getPayerList();
    this.getPayerTypeList();
    this.getEmployerList();
    this.getDocTypeyList();
    // this.getContractListData();
    this.getTariffmaster();
    this.getAssociatedCompanyList();
    this.getGLTypeList();
    this.getReportTypes();
    this.getPrefixList();
    this.getDocumentTypeList();
    this.getDoctorList(null,true);
    this.getdepartment();
    this.getDocTypeListForRegistration();
    this.getDocTypeListForEncounter();
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getDocumentTypeList() {
    this.appBaseService.setResourceURL(OPD_API_URL.DOC_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.DOCUMENTTYPEMASTER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        this.documentTypelist = res;
      });
  }

  /**
   *
   *
   * @param {*} referralTypeCode
   * @memberof PatientRegistrationComponent
   */
  getReferralList(referralTypeCode) {
    if (referralTypeCode) {
      this.referralTypeCode = {
        field: OPD_API_URL.M_REFFERALTYPE,
        value: referralTypeCode.id,
      };
      this.isOtherReferral = referralTypeCode.desc.trim() === 'Others';
    }
    else {
      this.isOtherReferral = false; 
    }
  }

  /**
   *It is the source of doctor data
   *
   * @param {*} departmentCode
   * @memberof PatientRegistrationComponent
   */
  getDoctorList(departmentCode, isappointment) {
    if (!isappointment) {
      this.formEncounter.patchValue({ appointmentSlots: "" });
      this.appointmentData = null;
    }
    //if (departmentCode) {
      if (this.mrdDepartment == departmentCode?.value?.code)  {
        if(this.mrdDepartment)
        this.medicalReport = true;
      } else {
        this.medicalReport = false;
        this.formEncounter.controls["reportResonMrd"].setErrors(null);
        this.formEncounter.controls["reportTypeMrd"].setErrors(null);
      }
      let payload = {
        limit: 0,
        unitCode: this.unitCode,
        departmentCode: isappointment ? departmentCode : departmentCode?.value?.code,
        typeCodeList: ["DR"],
      };
      this.masterApiService
        .postTypeMaster(OPD_API_URL.EMPLOYEE_LIST, payload)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          let list = [];
          let letmultilangdoclist = [];
          if (
            data &&
            data.payload &&
            data.payload.employeeResponseList &&
            data.payload.employeeResponseList.length > 0
          ) {
            data.payload.employeeResponseList.forEach((element) => {
              list.push({
                id: element.id,
                code: element.code,
                desc: element.desc,
              });
              letmultilangdoclist.push(element);
              if (this.previousEncounterList.length > 0)
                this.formEncounter.controls["doctor"].setValue(this.doctorValue);
            });
          }
          this.multiLangDoctorList = letmultilangdoclist;
          this.doctorFilteredList = list;
          this.docList = list;
          if (isappointment) {
            this.formEncounter.patchValue({
              doctor: this.doctorValueappointment,
            });
          }
        });
    //}
    const deptCode = isappointment ? departmentCode : departmentCode?.value?.code;
    if (deptCode) {
      this.getCabinForDepartment(deptCode);
    }
  }
  getDoctorDescription(doctorCode: string): string {
    return this.docList?.find((doctor) => doctor.code === doctorCode)?.desc || '';
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getReportTypes() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"MEDR",true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
       this.reportReasonList = res;
        this.reportReasonFilterdList = res;
      });
  }

  /**
   *
   *
   * @param {*} event
   * @memberof PatientRegistrationComponent
   */
  getSpeciality(event){
    let doctorCode = this.formEncounter.controls["doctor"].value;
    if(event.value){
      this.masterApiService
        .postTypeMaster(OPD_API_URL.GET_SPECIALITY_BY_DOCTOR+event.value, '')
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          if(data.payload){
            this.departmentFilterList =data.payload;
            this.departmentValue= data.payload[0];
            if(this.consultationChargesDuringvisit == "true" && this.formEncounter.value.encounterType.isConsultation){
              this.getConsultationCharges( this.departmentValue,doctorCode);
            }
          }
        })
    }
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getdepartment() {
    this.masterApiService
      .getTypeMaster(this.masterAPI.DEPT_GET_DEPT_BY_UNIT)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.departmentList = data.filter((dept: any) => dept.isClinicalSpeciality === true);
        this.departmentFilterList = this.departmentList;
      });
  }

  /**
   *get health package
   *
   * @memberof DialogAddAppointmentPatient
   */
  getHealthPackgeList() {
    let list = [];
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_PACKAGE)
        .subscribe((result: any) => {
          result.forEach((element) => {
            list.push({
              id: element.id,
              code: element.code,
              desc: element.desc,
              l1: element.l1,
              l2: element.l2,
            });
          });
          this.healthPackageList = list;
          this.checkRequestHasAppointment();
        })
    );
  }

  /**
   *
   *
   * @param {*} o1
   * @param {*} o2
   * @return {*} 
   * @memberof PatientRegistrationComponent
   */
  compareFn(o1: any, o2: any) {
    if (o1.code == o2.code) return true;
  }

  /**
   *
   *
   * @param {*} companyValue
   * @memberof DialogAddAppointmentPatient
   */
  pakageChecked(packageCode) {
    let packageValue = [];
    this.selectedOption = [];
    for (let i = 0; i < this.healthPackageList.length; i++) {
      let value = this.healthPackageList.find((s) => s.code == packageCode[i]);
      packageValue.push(value);
    }
    for (let i = 0; i < this.healthPackageList.length; i++) {
      if (packageValue.indexOf(this.healthPackageList[i]) != -1)
        this.selectedOption.push(this.healthPackageList[i].code);
    }
  }

  /**
   *It is the source of primaryId data
   *
   * @memberof PatientRegistrationComponent
   */
  getPrimaryIdList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.identificationTypeList = data;
        this.updateIdentificationLists();
      });
  }

  private updateIdentificationLists() {
    const identificationTypes = this.identificationTypeList || [];
    this.primaryIdList = this.showAllIdentificationTypes
      ? identificationTypes
      : identificationTypes.filter((i) => i.isPrimaryId);
    this.primaryIdFilteredList = this.primaryIdList;
    this.secondaryIdList = this.showAllIdentificationTypes
      ? identificationTypes
      : identificationTypes.filter((i) => !i.isPrimaryId);
    this.secondaryIdFilteredList = this.secondaryIdList;
    this.primaryIdListNOK = identificationTypes.filter((i) => i.isPrimaryId);
    this.primaryIdFilteredListNok = this.primaryIdListNOK;
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getRelationList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_RELATION,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.relationList = data;
      });
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getPrefixList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_PREFIX,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.prefixList = data;
      });
  }

  /**
   *It is the source of country data.
   *
   * @memberof PatientRegistrationComponent
   */
  getCountryList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_COUNTRY,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.countryPrimaryList = data;
        this.countrySecondaryList = data;
        this.countryEmploymentList = data;
      });
  }
  /**
   * Loading Employer Data
   *
   * @memberof PatientRegistrationComponent
   */
  getEmployerList() {
   
    this.employerList = [];
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_EMPLOYER)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        if (data) {
          this.employerList = data;
        }
      });
  }

  /**
   *Passing countryCode to get the stateList
   *
   * @param {*} countryCode
   * @memberof PatientRegistrationComponent
   */
  getNOKStateList(countryCode) {
    let result: any = "";
    if (countryCode && countryCode.id) {
       result = this.countryPrimaryList.find((i) => i.id == countryCode.id);
    }else{
       result = this.countryPrimaryList.find((i) => i.code == countryCode);
    }
    if(result){
     this.nokCountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
    
        if (this.isAddeassByPostCode == true) {
          this.stateDefaultValue = this.getStateValue.code;
          this.getNOKCityList(this.getStateValue);
        } 
      }
  }
  getStatePrimaryList(countryCode, isCode) {
    if(countryCode=='' && !isCode){
      countryCode = this.countryPrimaryList.find(
        (i) => i.code == this.defaultCountry
      );
    }
    if (countryCode) {
      let result: any = "";
      if (isCode){
        result = this.countryPrimaryList.find((i) => i.code == countryCode);}
      else{
        result = this.countryPrimaryList.find(
          (i) => i.code == countryCode.code
        );
        this.formRegistration.patchValue({
          statePrimary: "",
          cityPrimary: "",
          subDistrictPrimary: ""
        });
      }
      if(result){
      this.CountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
        };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.statePrimaryList = res;
           if (this.selectedPatient && this.selectedPatient.patientCategory != "") {
            const stateres = this.statePrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.state
                  : "")
            );
            if(this.selectedPatient.extendedAddress){
            
            this.stateValue = stateres ? stateres.code : null;
            if (!stateres) {
            this.formRegistration.patchValue({
              statePrimary:this.selectedPatient.extendedAddress?.state,
              cityPrimary: this.selectedPatient.extendedAddress?.city
            });
          }
           this.getCityPrimaryList(stateres);
        }
            if (this.isAddeassByPostCode == true) {
              let statevalue = this.statePrimaryList.find(
              (i) =>
                i.code == this.getStateValue.code
            );
              this.stateValue = statevalue.code;
              this.getCityPrimaryList(statevalue);
            } else {
               if (!stateres) {
                let statevalue = this.statePrimaryList.find(
              (i) =>
                i.code == this.stateValue
            );
                this.getCityPrimaryList(statevalue);}
                else{this.getCityPrimaryList(stateres);}
              
            }
          } else {
            const stateres = this.statePrimaryList.find(
              (i) => i.code == this.stateValue
            );
            this.stateValue = stateres ? stateres.code : null;
            const result = this.statePrimaryList.find(
              (i) => i.code == this.stateValue
            );

            if (result && result.id) {
              this.StateCode = {
                field: OPD_API_URL.M_STATEM,
                value: result.id,
              };
              if (this.isAddeassByPostCode == true) {
                this.getCityPrimaryList(this.getStateValue);
              } else {
                this.getCityPrimaryList(stateres);
              }
            }
          }
        });
    }
  }
  }

  /**
   *Passing stateCode to get the cityList
   *
   * @param {*} stateCode
   * @memberof PatientRegistrationComponent
   */

  getNOKCityList(stateCode) {  
    let result: any = "";
     if (stateCode && stateCode.id) {
       result = this.statePrimaryList.find(
        (i) => i.id == stateCode.id
      )}else{
         result = this.statePrimaryList.find(
          (i) => i.code == stateCode
      )};
      if(result){
        this.nokStateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };
    
    if (this.isAddeassByPostCode == true) {
      this.cityDefaultValue = this.getCityValue.code;
          this.getSubDistrictForNOK(this.getCityValue);
        }
      }  
  }
   getCityPrimaryList(stateCode) {
    if (stateCode && stateCode!=="null") {
      const result = this.statePrimaryList.find(
        (i) => i.code == stateCode.code
      );
      if(result){
      this.StateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.cityPrimaryList = res;
          // if (this.selectedPatient) {
          if (this.selectedPatient && this.selectedPatient.patientCategory != "") {
            const cityres = this.cityPrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.city
                  : "")
            );
            if(this.selectedPatient.extendedAddress){
            this.cityValue = cityres ? cityres.code : null;
            }
            if (this.isAddeassByPostCode == true) {
              this.cityValue = this.getCityValue.code;
              this.getSubDistrictPrimaryList(this.getCityValue);
            } else {
              if(!cityres){
               let cityValue = this.cityPrimaryList.find(
              (i) =>
                i.code == this.cityValue)
               this.getSubDistrictPrimaryList(cityValue);
              }else{
              this.getSubDistrictPrimaryList(cityres);}
            }
          } else {
            const cityres = this.cityPrimaryList.find(
              (i) => i.code == this.cityValue
            );
            this.cityValue = cityres ? cityres.code : null;
            if (this.isAddeassByPostCode == true) {
              this.cityValue = this.getCityValue.code;
              this.getSubDistrictPrimaryList(this.getCityValue);
            } else {
              this.getSubDistrictPrimaryList(cityres);
            }
          }
        });
     }else{
      if(stateCode=="null")
      this.formRegistration.patchValue({ cityPrimary:"null",});
    }
  }
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} cityCode
   * @memberof PatientRegistrationComponent
   */
  getSubDistrictForNOK(city) {
   let result: any = "";
    if (city && city.id) {
      result = this.cityPrimaryList.find((i) => i.id == city.id);}
      else{
       result = this.cityPrimaryList.find((i) => i.code == city);
      }
      if(result) {
       this.nokAreaCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };
       this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.subDistrictPrimaryList = res;
         if (this.isAddeassByPostCode){
         this.areaDefaultValue = this.subDistrictPrimaryList.length > 1 ? "": this.getDistrictValue.code;         
        }
        });
      }
  }
  getSubDistrictPrimaryList(cityCode) {
    if (cityCode) {
      const result = this.cityPrimaryList.find((i) => i.code == cityCode.code);

      if(result) {
        this.CityCode = {
          field: OPD_API_URL.M_CITY_VALUE,
          value: result.id,
        };
      

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.subDistrictPrimaryList = res;
          if (this.selectedPatient) {
            const distres = this.subDistrictPrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.area
                  : "")
            );
            this.districtValue = distres ? distres.code : null;
            this.postCodeValue = distres ? distres.postCode : "";
            if (this.isAddeassByPostCode)
              this.districtValue =this.subDistrictPrimaryList.length>1?"": this.getDistrictValue.code;          
            } else {
              const districres = this.subDistrictPrimaryList.find(
              (i) => i.code == this.districtValue
            );
            this.districtValue = districres ? districres.code : null;
            this.postCodeValue = districres ? districres.postCode : "";
            if (this.isAddeassByPostCode)
              this.districtValue =this.subDistrictPrimaryList.length>1?"": this.getDistrictValue.code;          
            }
        });
      }
    }
  }

  /**
   *Passing countryCode to get the stateSecondaryList
   *
   * @param {*} countryCode
   * @memberof PatientRegistrationComponent
   */
  getStateSecondaryList(countryCode, isCode) {
    if (countryCode) {
      if (this.isSameAddress) {
        this.stateSecondaryValue =
          this.formRegistration.controls["statePrimary"].value.code;
      } else if (this.selectedPatient) {
        this.stateSecondaryValue = this.selectedPatient.correspondingAddress
          ? this.selectedPatient.correspondingAddress.state
          : "";
      }
      let result: any = "";
      if (isCode)
        result = this.countrySecondaryList.find((i) => i.code == countryCode);
      else
        result = this.countrySecondaryList.find(
          (i) => i.code == countryCode.code
        );
      this.secondaryCountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.stateSecondaryList = res;
          const stateres = this.stateSecondaryList.find(
            (i) => i.code == this.stateSecondaryValue
          );

          this.getCitySecondaryList(stateres);
        });
    }
  }

  /**
   *Passing stateCode to get the citySeocndaryList
   *
   * @param {*} cityCode
   * @memberof PatientRegistrationComponent
   */
  getCitySecondaryList(stateCode) {
    if (stateCode) {
      if (this.isSameAddress) {
        this.citySecondaryValue =
          this.formRegistration.controls["cityPrimary"].value.code;
      } else if (this.selectedPatient) {
        this.citySecondaryValue = this.selectedPatient.correspondingAddress
          ? this.selectedPatient.correspondingAddress.city
          : "";
      }
      const result = this.stateSecondaryList.find(
        (i) => i.code == stateCode.code
      );
      this.secondaryStateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.citySecondaryList = res;
          const cityres = this.citySecondaryList.find(
            (i) => i.code == this.citySecondaryValue
          );

          this.getSubDistrictSecondaryList(cityres);
        });
    }
  }

  /**
   *Passing cityCode to get the subDistrictSecondaryList
   *
   * @param {*} cityCode
   * @memberof PatientRegistrationComponent
   */
  getSubDistrictSecondaryList(cityCode) {
    if (cityCode) {
      const result = this.citySecondaryList.find(
        (i) => i.code == cityCode.code
      );
      this.secondaryDistrictCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.subDistrictSecondaryList = res;
        });
    }
    if (this.isSameAddress)
      this.districtSeoncdaryValue = this.formRegistration.controls["subDistrictPrimary"].value
        ? this.formRegistration.controls["subDistrictPrimary"].value.code
        : "";
    else if (this.selectedPatient)
      this.districtSeoncdaryValue = this.selectedPatient.correspondingAddress
        ? this.selectedPatient.correspondingAddress.area
        : "";
  }

  // getSubDistrictForNOK(city) {
  //   if (city && city.id) {
  //     this.nokAreaCode = {
  //       field: OPD_API_URL.M_CITY_VALUE,
  //       value: city.id,
  //     };
  //   }
  // }

  /**
   *Passing countryCode to get the stateList
   *
   * @param {*} countryCode
   * @memberof PatientRegistrationComponent
   */
  getStateEmploymentList(countryCode, isCode) {
    if (countryCode) {
      let result: any = "";
      if (isCode)
        result = this.countryEmploymentList.find((i) => i.code == countryCode);
      else
        result = this.countryEmploymentList.find(
          (i) => i.code == countryCode.code
        );
      this.employmentCountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.stateEmploymentList = res;
          if (this.selectedPatient) {
            const stateres = this.stateEmploymentList.find(
              (i) =>
                i.code ==
                (this.formRegistration.controls["employmentState"].value
                  ? this.formRegistration.controls["employmentState"].value
                  : "")
            );
            this.stateEmploymentValue = stateres ? stateres.code : null;
            this.getCityEmploymentList(stateres);
          } else {
            const stateres = this.stateEmploymentList.find(
              (i) => i.code == this.stateEmploymentValue
            );
            this.stateEmploymentValue = stateres ? stateres.code : null;
            const result = this.stateEmploymentList.find(
              (i) => i.code == this.stateEmploymentValue
            );
            this.employmentStateCode = {
              field: OPD_API_URL.M_STATEM,
              value: result.id,
            };
            this.getCityEmploymentList(stateres);
          }
        });
    }
  }

  /**
   *Passing stateCode to get the cityList
   *
   * @param {*} stateCode
   * @memberof PatientRegistrationComponent
   */
  getCityEmploymentList(stateCode) {
    if (stateCode) {
      const result = this.stateEmploymentList.find(
        (i) => i.code == (stateCode.code ? stateCode.code : stateCode)
      );
      this.employmentStateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.cityEmploymentList = res;
          if (this.selectedPatient) {
            const cityres = this.cityEmploymentList.find(
              (i) =>
                i.code ==
                (this.formRegistration.controls["employmentCity"].value
                  ? this.formRegistration.controls["employmentCity"].value
                  : "")
            );
            this.cityEmploymentValue = cityres ? cityres.code : null;
          } else {
            const cityres = this.cityEmploymentList.find(
              (i) => i.code == this.cityEmploymentValue
            );
            this.cityEmploymentValue = cityres ? cityres.code : null;
          }
        });
    }
  }

  /**
   *Passing CountryCode to get the kinStateList
   *
   * @param {*} countryCode
   * @memberof PatientRegistrationComponent
   */
  // getNOKStateList(countryCode) {
  //   if (countryCode && countryCode.id) {
  //     this.nokCountryCode = {
  //       field: OPD_API_URL.M_COUNTRYM,
  //       value: countryCode.id,
  //     };
  //   }
  // }

  /**
   *Passing cityCode to get the kinCityList
   *
   * @param {*} cityCode
   * @memberof PatientRegistrationComponent
   */
  // getNOKCityList(cityCode) {
  //   if (cityCode && cityCode.id) {
  //     this.nokStateCode = {
  //       field: OPD_API_URL.M_STATEM,
  //       value: cityCode.id,
  //     };
  //   }
  // }

  /**
   *It is the source of payer data.
   *
   * @memberof PatientRegistrationComponent
   */
  getPayerList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_COMPANY)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.payerList = data;
        // this.payerFilteredList = data;
          this.dataSourcePayers.data[0].payerList = []
          this.dataSourcePayers.data[0].payerList = data;
          this.dataSourcePayers.data[0].payerFilteredList = data;
          
      });
  }

  /**
   *It is the source of payerType data.
   *
   * @memberof PatientRegistrationComponent
   */
  getPayerTypeList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_COMPANYTYPE)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.payerTypeList = data;
        this.payerTypeFilteredList = data;
        let res = this.payerTypeList.find((s) => s.isSelf == true);
        if(this.dataSourcePayers.data.length>0)
        this.dataSourcePayers.data[0].payerTypeCode = res.code;
      });
  }

  /**
   *It is the source of getDocTypeList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getDocTypeyList() {
    this.appBaseService.setResourceURL(MICROSERVICES.DOC_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.M_DOC_TYPE,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.docTypeList = data;
        this.docTypeFilteredList = data;
      });
  }

  /**
   *Passing payerCode and index to get the contractList
   *
   * @param {*} payerCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  getPayerListData(payerTypeCode, index) {
    let payerListByType = [];
    this.payerList.forEach((element) => {
      if (element.companyTypeMaster.code == payerTypeCode)
        payerListByType.push(element);
    });
    this.dataSourcePayers.data[index].payerList = payerListByType;
  }

  /**
   *
   *
   * @param {*} code
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  validatePayer(element, index) {
    let payerIndex = this.dataSourcePayers.data.findIndex((data, i) => {
      return data.payerCode == element.payerCode && i != index;
    });
    if (payerIndex >= 0) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.Payerisalready"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
      this.dataSourcePayers.data[index].payerCode = "";
    } else this.getGlDetailsByPayer(this.selectedPatient.mrn, element, index);
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  // getContractListData() {
  //   this.masterApiService
  //     .getTypeMaster(OPD_API_URL.M_CONTRACT)
  //     .pipe(takeUntil(this._onDestroy))
  //     .subscribe((data: any) => {
  //       this.contractList = data;
  //       this.contractCodeList = data;
  
  //       this.dataSourcePayers.data.forEach((payer, index) => {
  //         if (!payer) return;
  //         payer.contractList = [...data];
  //         payer.contractCodeList = [...data];
  //       });
  
   
  //       this.dataSourcePayers._updateChangeSubscription();
  //     });
  // }
  

  /**
   *It is the source of gradeList data.
   *
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  getGradeList(index) {
    let row = this.dataSourcePayers.data[index];
    let grades = row.contractList["configurationList"]
      ? row.contractList["configurationList"]
      : [];
    this.dataSourcePayers.data[index].gradeList = grades;
  }

  /**
   *It is get the tariffMaster Data
   *
   * @memberof PatientRegistrationComponent
   */
  // getTariffmaster() {
  //   this.masterApiService
  //     .getTypeMaster(OPD_API_URL.M_TARIFF)
  //     .pipe(takeUntil(this._onDestroy))
  //     .subscribe((res: any) => {
  //       this.tariffList = res;
  //       this.tariffFilteredList = res;
  //       this.dataSourcePayers.data[0].tariffList = [];
  //       this.dataSourcePayers.data[0].tariffList = res;
  //       this.dataSourcePayers.data[0].tariffFilteredList = res;
  //     });
  // }
  getTariffmaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_TARIFF)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        this.tariffList = res;
        this.tariffFilteredList = res;
  
        this.dataSourcePayers.data.forEach((payer, index) => {
          if (!payer) return;
          payer.tariffList = [...res];
          payer.tariffFilteredList = [...res];
  
          let defaultTariff = res.find((t) => t.isDefault);
          if (defaultTariff) {
            payer.tariffCode = defaultTariff.code;
            payer.isDisableTariff = true;
          }
        });
  
        // ✅ Refresh table data
        this.dataSourcePayers._updateChangeSubscription();
      });
  }

  /**
   *It is the source of tariffList data
   *
   * @param {string} patientCategoryCode
   * @memberof PatientRegistrationComponent
   */
  // getTariffList(i?) {
  //   if (this.isPatientCategory) {
  //     let payload = this.selectedPatient.patientCategory || null;
  //     this.masterApiService
  //       .getTypeMaster(OPD_API_URL.PATIENT_CATEGORY_MASTER + payload)
  //       .pipe(takeUntil(this._onDestroy))
  //       .subscribe((res: any) => {
  //         if(res.payload.patientCategoryDTOResponse && res.payload.patientCategoryDTOResponse.tariffResponseList){
  //         this.tariffList = res.payload.patientCategoryDTOResponse.tariffResponseList;
  //         this.tariffFilteredList=this.tariffList;
  //         }
  //         let defaultTariff = this.tariffList.find(i => i.isDefault === true);
  //         if (i === undefined) {
  //           if (this.dataSourcePayers.data.length > 0) {
  //             if (!this.dataSourcePayers.data[0].tariffCode) {
  //               this.dataSourcePayers.data[0].tariffCode = defaultTariff ? defaultTariff.code : null;
  //             }
  //           }
  //         } else {
  //           let contractTariff = this.tariffList.find(i => i.code === this.contractValue?.tariffMaster?.code);
  //           if (contractTariff) {
  //             this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //           }
  //         }
  //       });
  //   } else {
  //     let contractTariff = this.tariffList.find(i => i.code === this.contractValue?.tariffMaster?.code);
  //     if (contractTariff) {
  //       this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //     }
  //   }
  // }
 
  // getTariffListold(i?) {
  //   if (this.selectedPatient.patientCategory) {
  //     let payload = this.selectedPatient.patientCategory || null;
  //     this.masterApiService
  //       .getTypeMaster(OPD_API_URL.PATIENT_CATEGORY_MASTER + payload)
  //       .pipe(takeUntil(this._onDestroy))
  //       .subscribe((res: any) => {
  //         if (this.isPatientCategory) {
  //         if (res.payload.patientCategoryDTOResponse && res.payload.patientCategoryDTOResponse.tariffResponseList) {
  //           if(this.isCompany == true){
  //           this.dataSourcePayers.data[i].tariffList = this.tariffCompanyList;
  //           this.dataSourcePayers.data[i].tariffFilteredList =   this.dataSourcePayers.data[i].tariffList;
  //             this.defaultTariff =  this.dataSourcePayers.data[i].tariffList.find(i => i.isDefault === true);
  //            }  else{
  //             this.dataSourcePayers.data[0].tariffList = res.payload?.patientCategoryDTOResponse?.tariffResponseList;
  //             this.tariffFilteredList=this.tariffList;
  //              this.defaultTariff =  this.dataSourcePayers.data[0].tariffList.find(i => i.isDefault === true);
  //          }
  //         }
  //         if (i === undefined) {
  //           if (this.dataSourcePayers.data.length > 0 && this.isPatientCategory) {
  //             this.dataSourcePayers.data[0].tariffCode = this.defaultTariff ? this.defaultTariff.code : null;
  //           }
  //         } else {
  //           if(this.isContract == true){
  //             this.dataSourcePayers.data[i].tariffList = this.tariffList;
  //           let contractTariff = this.dataSourcePayers.data[i].tariffList.find(i => i.code === this.contractValue?.tariffMaster?.code);
  //           if (contractTariff) {
  //             this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //             this.dataSourcePayers.data[i].isDisableTariff = true;
  //           }else{
  //             this.dataSourcePayers.data[i].isDisableTariff = false;
  //           }
  //           }else{
  //             if(this.tariffCompanyList && this.tariffCompanyList.length > 0){
  //               this.dataSourcePayers.data[i].tariffList = this.isCompany  ? this.tariffCompanyList : res.payload?.patientCategoryDTOResponse?.tariffResponseList;
  //            }else{
  //             this.dataSourcePayers.data[i].tariffList = this.tariffList;
  //            }
  //           }
  //         }
  //       }else {
  //         if (res.payload.patientCategoryDTOResponse && res.payload.patientCategoryDTOResponse.tariffResponseList) {
  //           if(this.isCompany == true){
  //           this.dataSourcePayers.data[i].tariffList = this.isCompany  ? this.tariffCompanyList : res.payload.patientCategoryDTOResponse.tariffResponseList;
  //           this.dataSourcePayers.data[i].tariffFilteredList =   this.dataSourcePayers.data[i].tariffList;
  //           this.defaultTariff =  this.dataSourcePayers.data[0].tariffList.find(i => i.isDefault === true);
  //           } else{
  //             this.dataSourcePayers.data[0].tariffList = res.payload.patientCategoryDTOResponse.tariffResponseList;
  //           this.tariffFilteredList=this.tariffList;
  //           this.defaultTariff =  this.dataSourcePayers.data[0].tariffList.find(i => i.isDefault === true);
  //          }
  //         }
  
  //         if (i === undefined) {
  //           if (this.dataSourcePayers.data.length > 0 && !this.isPatientCategory) {
  //             this.dataSourcePayers.data[0].tariffCode = this.defaultTariff ? this.defaultTariff.code : null;
  //           }
  //         } else {
  //           if(this.isContract == true){
  //             this.dataSourcePayers.data[i].tariffList = this.tariffList;
  //           let contractTariff = this.dataSourcePayers.data[i].tariffList.find(i => i.code === this.contractValue?.tariffMaster?.code);
  //           if (contractTariff) {
  //             this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //             this.dataSourcePayers.data[i].isDisableTariff = true;
  //           }else{
  //             this.dataSourcePayers.data[i].isDisableTariff = false;
  //           }
  //           }else{
  //             if(this.tariffCompanyList && this.tariffCompanyList.length > 0){
  //               this.dataSourcePayers.data[i].tariffList = this.isCompany  ? this.tariffCompanyList : res.payload?.patientCategoryDTOResponse?.tariffResponseList;
  //               this.dataSourcePayers.data[i].tariffCode = this.dataSourcePayers.data[i].tariffList[0].code;
  //               this.dataSourcePayers.data[i].isDisableTariff = true;
  //              }else{
  //              this.dataSourcePayers.data[i].tariffList = this.tariffList;
  //             }
  //           }
  //         }
  //         }
  //       });
  //       }    else {
  //         let contractTariff = this.tariffList.find(i => i.code === this.contractValue?.tariffMaster?.code);
  //         if (contractTariff) {
  //           this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //         }
  //       }
  //    }

  getTariffList(i?,isDefaultTariff?) {
    this.dataSourcePayers.data.forEach((payer, index) => {
      if (i === index) {
        this.masterApiService
        .getTypeMaster(OPD_API_URL.GET_TARIFF_LIST+"patientCategoryCode="+this.patientCategory+"&companyCode="+payer.payerCode+"&isPatientCategory="+this.isPatientCategory )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res: any) => {
          if(res.payload && res.payload.length > 0){
            this.dataSourcePayers.data[i].tariffList = res.payload;
            this.dataSourcePayers.data[i].tariffFilteredList=res.payload;
            const defaultTariff = res.payload.find(tariff => tariff.isDefault);
           if (defaultTariff && isDefaultTariff) {
                this.dataSourcePayers.data[index].tariffCode = defaultTariff.code;
              }
          }else{
            this.dataSourcePayers.data[i].tariffList = [];
            this.dataSourcePayers.data[i].tariffFilteredList=[];
            this.dataSourcePayers.data[i].tariffCode =null;
          }
        })
      }
    });
  }
  updateExpiryValidation() {
    const patientCategory = this.formRegistration.get('patientCategory')?.value;
    const applyForeignerRule = this.isForeignerExpiryMandatory && patientCategory?.isIdentificationExpiryRequired === true;;
    this.identificationList.data.forEach(element => {
      const selectedId = this.identificationTypeList.find(
        x => x.code === element.idType
      );
      element.isExpiryDisplayed =
        (selectedId?.isExpireDisplayed ?? false) || applyForeignerRule;
      element.isExpiryRequired =
        element.isExpiryDisplayed &&
        ((selectedId?.isExpireReq ?? false) || applyForeignerRule);
    });
    this.identificationList.data = [...this.identificationList.data];
  }
  isExpiryHeaderRequired(): boolean {
    return this.identificationList.data.some(x => x.isExpiryRequired);
  }
    /**
   *
   *
   * @param {*} contractCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  
  getTariffContract(contractCode, index,contract) {
    if(contractCode){
    this.isContract = contract;
    this.contractValue = this.dataSourcePayers.data[index].contractList.find(i => i.code === contractCode);
    this.dataSourcePayers.data[index].tariffList = [];
    this.dataSourcePayers.data[index].tariffList.push(this.contractValue?.tariffMaster) ;
    this.dataSourcePayers.data[index].tariffCode=this.contractValue?.tariffMaster?.code;
  }else{
    this.isContract = false;
    this.getTariffList(index,true);
  }
  }

    /**
   *
   *
   * @param {*} contractCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  
  // getTariffContractPayer(payerCode, index , company) {
  //   if(payerCode){
  //   this.isCompany = company;
  //   this.isContract = false;
  //     this.masterApiService
  //       .getTypeMaster(OPD_API_URL.GET_COMPANY_TARIFF_BY_COMPANYCODE + payerCode)
  //       .pipe(takeUntil(this._onDestroy))
  //       .subscribe((res: any) => {
  //         if (res) {
  //           this.tariffCompanyList = res.companyMasterDTOResponse?.tariffResponseList;
  //           this.getTariffList(index);
  //         } 
  //       });
  // }else{
  //   this.isCompany = false;
  // }
  // }

  /**
   *It is the source of getGLTypeList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getGLTypeList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_GLTYPE)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.glTypeList = data;
      });
  }

  /**
   *It is the source of getAssociateList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getAssociatedCompanyList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_ASSOCIATECOMPANY)
        .subscribe((data: any) => {
          this.associatedCompanyList = data;
          this.associatedCompanyCodeList = data;
          this.dataSourcePayers.data.forEach((payer, index) => {
            if (!payer) return;
            payer.associatedCompanyList = [...data];
            payer.associatedCompanyCodeList = [...data];
          });
    
          // ✅ Refresh table data
          this.dataSourcePayers._updateChangeSubscription();
        })
    );
  }

  /**
   *Upload Image
   *
   * @memberof PatientRegistrationComponent
   */
  uploadImageDialog(): void {
    const dialogRef = this.dialog.open(CameraDialogComponent, {
      width: "650px",
      data: { name: "" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(async (result) => {
        try {
          if (result.res == "yes") {
            let isValid;
            if(this.isAiImageSearch){
              isValid = await this.patientExistChecking(result.picdata); // Wait for validation
            }
            else{
              isValid = true;
            }
            if(isValid)
            {
            this.patientImage = result.picdata;
            // this.patientImage;
            if(this.env.isImageCompress){
              this.sfileUploadService.compressBase64Image(this.patientImage, 0.5)
              .then((compressed) => {
                console.log('Compressed base64:', compressed);
                this.patientImage = compressed;
              })
              .catch((err) => {
                console.error('Image compression failed:', err);
              });
            }
          }
          else {
            this.patientImage = "";
          }
          } else {
            this.patientImage = "";
          }
        } catch (e) {}
      })
    );
  }

  patientExistChecking(picdata: any): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (!picdata) {
        resolve(true);
        return;
      }
      const base64Data = picdata.split(",") //picdata.replace("data:image/jpeg;base64,", '');
      const requestObject = {
        base64_image: base64Data[1],
        is_search:false
      };
      this.appBaseService.setResourceURL(OPD_API_URL.AI_SERVICE);
      this.appBaseService
        .postResource(OPD_API_URL.GET_AI_IMAGW, requestObject)
        .pipe(takeUntil(this._onDestroy))
        .subscribe({
          next: (res) => {
            if (res && res.data) {
              this.snackBar.open("Warning", "Patient already registered with MRN: " + res.data.mrn, {
                duration: 3000,
              });
              resolve(false); // Patient exists
            } else {
              resolve(true); // Patient does not exist
            }
          },
        
        });
    });
  }
  /**
   *
   *
   * @param {*} patientImage
   * @memberof PatientRegistrationComponent
   */
  uploadImageDialogForEdit(patientImage) {
    const dialogRef = this.dialog.open(CameraDialogComponent, {
      width: "650px",
      data: { name: patientImage },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        try {
          if (result.res == "yes") {
            this.patientImage = result.picdata;
            if(this.env.isImageCompress){
              this.sfileUploadService.compressBase64Image(this.patientImage, 0.5) // try different qualities like 0.4, 0.3
              .then((compressed) => {
                console.log('Compressed base64:', compressed);
                this.patientImage = compressed;
              })
              .catch((err) => {
                console.error('Image compression failed:', err);
              });
            }
          } else {
            this.patientImage = "";
          }
        } catch (e) {}
      })
    );
  }

  /**
   *onchanges chekcing multiple conditions
   *
   * @memberof PatientRegistrationComponent
   */
  onChanges() {
    this.clinicSearchCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCabin();
      });
    this.subscriptionList.add(
      this.formRegistration.controls["dateOfBirth"].valueChanges.subscribe(
        (val) => {
          this.patientAge = this.patientService.calculateAge(val,"formatted");
        }
      )
    );
    // this.subscriptionList.add(
    //   this.formRegistration.controls.secondaryId.valueChanges.subscribe(
    //     (val) => {
    //       this.secondartyIdentificationOnChange(val);
    //     }
    //   )
    // );
    this.subscriptionList.add(
      this.formEncounter.controls["visitToDepartment"].valueChanges.subscribe(
        (isVisitToDepartment) => {
          let doctorControl = this.formEncounter.controls["doctor"];
          this.formEncounter.controls["doctor"].setValue("");
          if (isVisitToDepartment) {
            doctorControl.clearValidators();
            doctorControl.disable();
            this.isDepartment = false;
          } else {
            doctorControl.enable();
            doctorControl.setValidators([Validators.required]);
            this.isDepartment = true;
          }
          doctorControl.updateValueAndValidity();
          // if(this.isGetClinicElement){
          //   if(isVisitToDepartment){
          //     this.isClinicReqired=false;
          //   }else{
          //     this.isClinicReqired=true;
          //   }
          // }
        }
      )
    );
    this.subscriptionList.add(
      this.doctorSearch.valueChanges.subscribe((value) => {
        const searchValue = (value || '').toString().toLowerCase();
        this.doctorFilteredList = this.docList.filter((i) =>
          i.desc.toString().toLowerCase().includes(searchValue) ||
          i.code.toString().toLowerCase().includes(searchValue)
        );
      })
    );
    this.subscriptionList.add(
      this.secondaryIdSearch.valueChanges.subscribe((value) => {
        this.secondaryIdFilteredList = this.secondaryIdList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.dipartmentSearch.valueChanges.subscribe((value) => {
        this.departmentFilterList = this.departmentList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.formRegistration.controls["secondaryExpirydate"];

    this.subscriptionList.add(
      this.primaryIdSearch.valueChanges.subscribe((value) => {
        this.primaryIdFilteredList = this.primaryIdList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.countrySearch.valueChanges.subscribe((value) => {
        this.countryPrimaryList = this.countrySecondaryList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.raceMasterSearch.valueChanges.subscribe((value) => {
        this.raceFilterList = this.nationalityWiseRace.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );

    this.subscriptionList.add(
      this.reportResonMrdSearch.valueChanges.subscribe((value) => {
        this.reportReasonFilterdList = this.reportReasonList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );

    this.subscriptionList.add(
      this.payerTypeSearch.valueChanges.subscribe((value) => {
        this.payerTypeList = this.payerTypeFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.payerSearch.valueChanges.subscribe((value) => {
        this.dataSourcePayers.data.forEach((element, index) => {
        element.payerList = element.payerFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    })
    );
    this.subscriptionList.add(
      this.contractCodeSearch.valueChanges.subscribe((value) => {
        this.dataSourcePayers.data.forEach((element, index) => {
          element.contractList = element.contractCodeList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        });
      })
    );
    this.subscriptionList.add(
      this.associatedCompanySearch.valueChanges.subscribe((value) => {
        this.associatedCompanyList = this.associatedCompanyCodeList.filter(
          (i) => i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.tariffSearch.valueChanges.subscribe((value) => {
        this.tariffList = this.tariffFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.formNextOfKin.controls["state"].valueChanges.subscribe((val) => {
        this.getNOKCityList(val);
      })
    );
    this.subscriptionList.add(
      this.formNextOfKin.controls["country"].valueChanges.subscribe((val) => {
        this.getNOKStateList(val);
      })
    );
       this.subscriptionList.add(
      this.formNextOfKin.controls["city"].valueChanges.subscribe((val) => {
        this.getSubDistrictForNOK(val);
      })
    );

    this.subscriptionList.add(
      this.formRegistration.controls["employerName"].valueChanges.subscribe(
        (res) => {
          if (res == "Others") {
            this.employer = true;
          } else {
            this.employer = false;
          }
        }
      )
    );
    if(this.isNationDependant){
      this.formRegistration.controls["nation"].valueChanges.subscribe(value => {
        value === undefined ? this.nationalityWiseRace = [] : null;
      });
    }
     this.subscriptionList.add(
      this.primaryIdSearchNok.valueChanges.subscribe((value) => {
        this.primaryIdFilteredListNok = this.primaryIdListNOK.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.formRegistration.get('isVip')?.valueChanges.subscribe(isVip => {
      const ctrl = this.formRegistration.get('vipRemarks');
      isVip ? ctrl?.setValidators(Validators.required) : ctrl?.clearValidators();
      ctrl?.updateValueAndValidity();
    });
    this.formRegistration.get('prefix')?.valueChanges.subscribe(prefixValue => {
      if (prefixValue ===  "null") {
        this.formRegistration.controls["prefix"].setValue(null);
        this.formRegistration.controls["gender"].enable();
        this.formRegistration.controls["gender"].setValue(null);
        this.genderValue = null;
      }
    });
  }

  /**
   *secondaryIdentification onchange check multiple conditions
   *
   * @param {string} secIdTypeCode
   * @memberof PatientRegistrationComponent
   */
  secondartyIdentificationOnChange(secIdTypeCode: any) {
    let formRegistration = this.formRegistration.controls;
    if (secIdTypeCode) {
      let secondaryIdCode = this.secondaryIdFilteredList.find(
        (s) => s.code == secIdTypeCode.value
      );
      // let secondaryIdCode = formRegistration.secondaryId.value;
      if (secondaryIdCode) {
        if (secondaryIdCode.isMyKad == true) {
          formRegistration["nation"].setValue("MALAYSIAN");
          this.secondaryIdeRegex = "^[0-9 -]+$";
        } else {
          this.secondaryIdeRegex = secondaryIdCode.validation
            ? secondaryIdCode.validation
            : "";
        }
      }
      if (!this.selectedPatient) {
        if (secondaryIdCode.isExpireReq) {
          formRegistration["secondaryExpirydate"].enable();
          this.isSeondaryExpiryDate = true;
        } else {
          formRegistration["secondaryExpirydate"].setValue("");
          formRegistration["secondaryExpirydate"].disable();
          this.isSeondaryExpiryDate = false;
        }

        this.secondaryNumberOnKeyUp(formRegistration["secondaryNumber"].value);
      }
    }
  }

  /**
   *primaryIdentification onchange check multiple conditions
   * @param idTypeCode
   */

   primaryIdentificationOnChange(idTypeCode: any, isPrimaryNoRemove:boolean,index?) {    
    var formRegistration = this.formRegistration.controls;
    if(isPrimaryNoRemove){
    this.identificationList.data[index].idType=idTypeCode.value;
    this.identificationList.data[index].idNumber="";
    this.identificationList.data[index].expDate="";
    this.identificationList.data[index].issuingCountry="";
     if(this.identificationList.data[index].type=='P'){
      this.mandatoryField.identificationType=true;
      this.mandatoryField.identificationNo=true;
     }
    }
    if(this.identificationList.data[index]?.type=='P'){
    if (idTypeCode?.value) {
      this.primaryIdCode = this.primaryIdFilteredList.find(
        (s) => s.code == idTypeCode.value
      );
    }else{
        this.primaryIdCode = this.primaryIdFilteredList.find(
          (s) => s.code == idTypeCode.code
        );
      }
    }else{
      if (idTypeCode?.value) {
        this.primaryIdCode = this.secondaryIdFilteredList.find(
          (s) => s.code == idTypeCode.value
        );
      }else{
          this.primaryIdCode = this.secondaryIdFilteredList.find(
            (s) => s.code == idTypeCode.code
          );
        }
    }
      // let primaryIdCode = formRegistration.primaryId.value;
      if (this.primaryIdCode) {        
        this.primaryIdNewValue=this.primaryIdCode.code?this.primaryIdCode.code:"";
        if (this.primaryIdCode.isMyKad == true) {
          formRegistration["nation"].setValue("MALAYSIAN");
          this.identificationList.data[index].primaryIdRegex = "^[0-9 -]+$";
        } else {
          this.identificationList.data[index].primaryIdRegex = this.primaryIdCode.validation
            ? this.primaryIdCode.validation
            : "";
        }
      }
    if (this.primaryIdCode) {
      const applyForeignerRule = this.isForeignerExpiryMandatory &&  this.formRegistration.get('patientCategory')?.value?.isIdentificationExpiryRequired === true;

      this.identificationList.data[index].isExpiryDisplayed =
        (this.primaryIdCode?.isExpireDisplayed || false) || applyForeignerRule;

      this.identificationList.data[index].isExpiryRequired =
        this.identificationList.data[index].isExpiryDisplayed &&
        ((this.primaryIdCode?.isExpireReq || false) || applyForeignerRule);

    // Clear date if hidden
       if (!this.identificationList.data[index].isExpiryDisplayed) {
       this.identificationList.data[index].expDate = "";
       }

    // ===========================
    // Expiry max date
    // ===========================

       if (this.primaryIdCode.expiryDuration) {

        const currentDate = new Date().getFullYear();

        const maxExpiryDurationDate = new Date();

        maxExpiryDurationDate.setFullYear(
          currentDate + this.primaryIdCode.expiryDuration
        );

        this.maxExpiry = maxExpiryDurationDate;

       } else {

         this.maxExpiry = new Date(
          this.year + 20,
          this.month,
          this.day
        );
      }
     }

        // if (this.primaryIdCode.isExpireReq) {
        //   this.identificationList.data[index].isExpiryRequired = true;
        // } else {
        //   this.identificationList.data[index].expDate="";
        //   this.identificationList.data[index].isExpiryRequired = false;
        // }
        this.primaryNumberOnKeyUp(this.identificationList.data[index].idNumber,index,false);
      // }
      if (this.primaryIdCode.expiryDuration) {
        const currentDate = new Date().getFullYear();
        const maxExpiryDurationDate = new Date();
        maxExpiryDurationDate.setFullYear(currentDate + this.primaryIdCode.expiryDuration);

        this.maxExpiry = maxExpiryDurationDate;
      }
      else{
        this.maxExpiry= new Date(this.year + 20, this.month, this.day);
      }
     if (this.primaryIdCode.validation) {
      this.identificationList.data[index].primaryIdRegex = this.primaryIdCode.validation;
       const match = this.identificationList.data[index].primaryIdRegex.match(/\{(\d+),(\d+)\}/);
       this.identificationList.data[index].minIdentificationLength = match ? parseInt(match[1], 10) : null;
       this.identificationList.data[index].maxIdentificationLength = match ? parseInt(match[2], 10) : null;
       const matchClass = this.primaryIdCode.validation.match(/\[(.*?)\]/);
       this.identificationList.data[index].allowedChars = matchClass[1]?matchClass[1]:"";
     }else{
      this.identificationList.data[index].maxIdentificationLength=25;
      this.identificationList.data[index].minIdentificationLength=0;
      this.identificationList.data[index].primaryIdRegex=OPD_CONST.primaryIdRegix;
     }
     this.formRegistration.controls["primaryNumber"].updateValueAndValidity();
     if(!this.identificationList.data[index].issuingCountry)
     this.identificationList.data[index].isCountryRequired = this.primaryIdCode ? this.primaryIdCode.isCountryRequired : false;
    
    this.primaryIdSelect(idTypeCode.value);
  }
  /**
   * primaryNumber onchange check multiple conditions
   * @param value
   */
  primaryNumberOnKeyUp(value: string,index?,isGenderChange?:boolean) {
    this.identificationList.data[index].idNumber=value;
    try {
      let formRegistration = this.formRegistration.controls;
      let primaryIdCode = this.identificationList.data[index].idType

      value = value.replace(/-/g, "");
      this.identificationList.data[index].idNumber=value;
      if (primaryIdCode) {
        let primaryIdentify = this.primaryIdList.find(
          (i) => i.code == primaryIdCode
        );
        if (primaryIdentify) {
          if (primaryIdentify.isMyKad) {
            value = value.replace(/[^\d*]/g, '');
            this.identificationList.data[index].maxIdentificationLength=14;
            this.identificationList.data[index].minIdentificationLength=0;
            var r = /[^0-9*]+/g,
              npa = "",
              nxx = "",
              last4 = "";
            value = value.replace(r, "");
            var c: string = value;
            npa = value.substr(0, 6);
            nxx = value.substr(6, 2);
            last4 = value.substr(8, 4);
            value = npa + "-" + nxx + "-" + last4;
            this.identificationList.data[index].idNumber=value ? value : "";
            this.identificationList.data[index].primaryIdRegex = "^[0-9 -]+$";
          } else if (primaryIdentify.isMyKad == false) {
            this.identificationList.data[index].primaryIdRegex = "[A-Za-z0-9]*";
            this.identificationList.data[index].idNumber=value ? value : "";
          }

          if (value.length >= 12 && primaryIdentify.isMyKad) {
            const array = Array.from(c);
            const yearSuffix = parseInt(array[0] + array[1], 10);
            const cal_month = parseInt(array[2] + array[3], 10);
            const cal_day = parseInt(array[4] + array[5], 10);
            const contry = array[6] + array[7];
            const gen_val = array[11];
  
            BirthPlaceList.forEach(element => {
              if (element.birthPlaceNumber == contry) {
                this.formRegistration.patchValue({
                  birthplace: element.birthPlaceName
                });
              }
            });

            const lastDigit = Number(gen_val);
            let genderVal = lastDigit % 2 == 0 ? STATICCODESERVICE.GENDER_MASTER_FEMALE : STATICCODESERVICE.GENDER_MASTER_MALE;
            this.genderValue = (this.selectedPatient?.gender && isGenderChange==false) ? this.selectedPatient.gender : this.patientRegService.getCodeByStaticCode(this.genderList, genderVal);
  
            var currentYear = new Date().getFullYear();
            var currentYearSuffix = currentYear % 100;
  
            let yr;
            if (yearSuffix > currentYearSuffix) {
              yr = 1900 + yearSuffix;
            } else {
              yr = 2000 + yearSuffix;
            }
  
            var birthDate = new Date(yr, cal_month - 1, cal_day);
            var today = new Date();
  
            if (birthDate > today && !this.isSameDate(birthDate, today)) {
              yr -= 100;
              birthDate = new Date(yr, cal_month - 1, cal_day);
            }
            
            if (this.isValidDate(yr, cal_month, cal_day)) {
              formRegistration["dateOfBirth"].setValue(birthDate);
              formRegistration["realdob"].setValue(true);
            } else {
              this.snackBar.open(
                this.langService.get("CommonAppoinment.InvalidNRIC"),
                this.langService.get("CommonAppoinment.validation"),
                { duration: 1000 }
              );
              this.identificationList.data[index].idNumber="";
              formRegistration["birthplace"].setValue(null);
              this.genderValue = "";
              formRegistration["dateOfBirth"].setValue(null);
              formRegistration["realdob"].setValue(false);
            }
          }
        }
      }
    } catch (ex) {}
  }
  
  /**
   *
   *
   * @param {*} date1
   * @param {*} date2
   * @return {*} 
   * @memberof PatientRegistrationComponent
   */
  isSameDate(date1, date2) {
    return date1.getFullYear() == date2.getFullYear() &&
           date1.getMonth() == date2.getMonth() &&
           date1.getDate() == date2.getDate();
  }

  /**
   *
   *
   * @param {*} year
   * @return {*} 
   * @memberof PatientRegistrationComponent
   */
  isLeapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0);
  }
  
  /**
   *
   *
   * @param {*} year
   * @param {*} month
   * @param {*} day
   * @return {*} 
   * @memberof PatientRegistrationComponent
   */
  isValidDate(year, month, day) {
    if (month < 1 || month > 12) {
      return false;
    }
  
    let daysInMonth;
    if (month == 2) {
      daysInMonth = this.isLeapYear(year) ? 29 : 28;
    } else if ([4, 6, 9, 11].includes(month)) {
      daysInMonth = 30;
    } else {
      daysInMonth = 31;
    }
    return day > 0 && day <= daysInMonth;
  }

  /**
   *
   *
   * @param {string} value
   * @memberof PatientRegistrationComponent
   */
  secondaryNumberOnKeyUp(value: string) {
    try {
      let formRegistration = this.formRegistration.controls;
      let secondaryIdCode = formRegistration["secondaryId"].value;
      value = value.replace(/\s/g, '');
      formRegistration["secondaryNumber"].setValue(value);
      if (secondaryIdCode) {
        if (secondaryIdCode.isMyKad) {
        }

        let secondaryIdentify = this.secondaryIdList.find(
          (i) => i.code == secondaryIdCode
        );
        if (secondaryIdentify) {
          if (secondaryIdentify.isMyKad == true) {
            var r = /(\D+)/g,
              npa = "",
              nxx = "",
              last4 = "";
            value = value.replace(r, "");
            var c: string = value;
            npa = value.substr(0, 6);
            nxx = value.substr(6, 2);
            last4 = value.substr(8, 4);
            value = npa + "-" + nxx + "-" + last4;
            formRegistration["secondaryNumber"].setValue(value ? value : "");
            this.secondaryIdeRegex = "^[0-9 -]+$";
          } else if (secondaryIdentify.isMyKad == false) {
            this.secondaryIdeRegex = "[A-Za-z0-9]*";
            formRegistration["secondaryNumber"].setValue(value ? value : "");
          }
        }
      }else{
        this.secondaryIdeRegex = "([a-zA-Z0-9,'\-._/!@#$%^&*\s]+)";
      }
    } catch (ex) {}
  }

  /**
   *set gender value
   *
   * @param {*} prefixvalue
   * @memberof PatientRegistrationComponent
   */
  getGender(prefixvalue) {
    let formRegistration = this.formRegistration.controls;
    let res =
      prefixvalue && prefixvalue.genderMaster
        ? prefixvalue.genderMaster.code
        : "";
    if (res) {
      this.genderValue = res;
      formRegistration["gender"].disable();
    } else {
      if (this.defaultGender) {
        this.genderValue = this.defaultGender.code;
      }
      formRegistration["gender"].enable();
    }
  }

  /**
   * It will be triggered on value set to primary id
   * @param event selected value
   * @memberof PatientRegistrationComponent
   */
  checkforExpiry(event) {
    let formRegistration = this.formRegistration.controls;
    if (event.code && event.code.isExpireReq) {
      formRegistration["expiryDate"].enable();
      this.isexpiryDate = true;
    } else {
      formRegistration["expiryDate"].setValue("");
      formRegistration["expiryDate"].disable();
      this.isexpiryDate = false;
    }
  }

  /**
   *validation primary number
   *
   * @param {string} value
   * @memberof PatientRegistrationComponent
   */
  onFocusOutEvent(value: any , index: number) {
    // if(!this.isNewBorn && value.type=="P"){
    //   this.validationOnPrimarynumber(this.identificationList.data[index]?.idNumber ,index);
    // }
    if (value.identifierUUID && this.patientId) {
      value.identifierOverride = true;
      value.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
    }
    let primaryIdCode = this.getObjByCode(
      this.identificationList.data[index]?.type === 'P' ? this.primaryIdFilteredList : this.secondaryIdFilteredList,
      this.identificationList.data[index]?.idType
    );
     if (primaryIdCode) {
      if (primaryIdCode.isMyKad && this.identificationList.data[index]?.idNumber.length < 14){
        this.identificationList.data[index].isIdNumberValid=false;
      } else{
        if( this.identificationList.data[index]?.idNumber.length < this.identificationList.data[index]?.minIdentificationLength){
          this.identificationList.data[index].isIdNumberValid=false;
        } else if( this.identificationList.data[index]?.idNumber.length > this.identificationList.data[index]?.maxIdentificationLength){
          this.identificationList.data[index].isIdNumberValid=false;
        } else{
          this.identificationList.data[index].isIdNumberValid=true;
        }
    }
    }
  }

  
  onFocusOutEventOnKey(value: string ,MRN?:string) {
    let mrn =MRN?MRN: this.selectedPatient ? this.selectedPatient.mrn : "";
    let tokenNo = value ? value : "";
    if (mrn == "" && tokenNo == "") return false;
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.PATIENT_INTEGRATION_SERVICE,
        "tokenNo=" + tokenNo + "&mrnNo=" + mrn
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res.message !== "") {
          this.snackBar.open("Info", res.message, {
            duration: 3000,
          });
          this.isToken = false;
          this.tokenNoValue = "";
        } else {
          this.isToken = true;
        }
      });
  }

  /**
   *patient notes
   *
   * @param {string} value
   * @memberof PatientRegistrationComponent
   */
  onFocusOutEventUpdate(value: string) {
    if (this.patientId) {
      if (this.selectedPatient.id && value == "")
        this.secondaryIdentifierListModified = true;
      else this.patientNotesUpdated = true;
    }
  }

  /**
   *validation primary number
   *
   * @param {string} value
   * @memberof PatientRegistrationComponent
   */
  validationOnPrimarynumber(value: string , index:number) {
      let primaryIdCode = this.identificationList.data[index].idType;
      if(this.selectedPatient){
      var idNumber = this.selectedPatientIdentificationList[index].idNumber;
      }else{
         idNumber = "";
      }
      if(value!==idNumber)  {
      if (primaryIdCode && value.replace(/-/g, '')) {
        this.generalApiService
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE + primaryIdCode + "&value=" + value.replace(/-/g, '')
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((response:any) => {
            if(response && response.status==409){
              this.identificationList.data[index].idNumber="";
            }else{
              this.identificationList.data[index].idNumber=value;
            }
          });
      }
    }
  }

  /**
   *calculate DOB
   *
   * @param {string} age
   * @param {string} month
   * @memberof PatientRegistrationComponent
   */
   calculateDob(age: string, month: string, day: string) {
    let formRegistration = this.formRegistration.controls;

    let agecalc;
    let monthcalc;
    let daycalc;

    if (age != "0") {
      agecalc = age.split("Y", 1);
    } else {
      agecalc = 0;
    }
    if (month != "0") {
      monthcalc = month.split("M", 1);
    } else {
      monthcalc = 0;
    }
     if (day != "0") {
       daycalc = day.split("D", 1);
     } else {
       daycalc = 0;
     }
     var todayDate = new Date();
     var todayDate = new Date();
     var dob = new Date(todayDate);

     dob.setFullYear(dob.getFullYear() - Number(agecalc));
     dob.setMonth(dob.getMonth() - Number(monthcalc));
     dob.setDate(dob.getDate() - Number(daycalc));

     formRegistration["dateOfBirth"].setValue(dob);
  }


  /**
   *delete kin details
   *
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  deleteNextOfKin(element) {
    if (element.id) {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Delete Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            // if (element.id) {
            let id = element.id ? element.id : "";
            this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
            this.subscriptionList.add(
              this.appBaseService
                .deleteResource(OPD_API_URL.DELETE_NEXT_OF_KIN + id)
                .subscribe((res) => {
                  this.snackBar.open("Next of Kin Deleted", "Success", {
                    duration: 2000,
                  });
                  const index: number = this.nokList.indexOf(element);

                  if (index != -1) {
                    this.nokList.splice(index, 1);
                    this.dataSourceNextOfKin = new MatTableDataSource(this.nokList);
                  }
                })
            );

          }
        })
      );
    } else {
      const index: number = this.dataSourceNextOfKin.data.indexOf(element);

      let list = this.dataSourceNextOfKin.data;
      list.splice(index, 1);
      this.dataSourceNextOfKin = new MatTableDataSource<any>(list);
    }
  }

  /**
   *mobile format
   *
   * @param {string} value
   * @param {string} name
   * @memberof PatientRegistrationComponent
   */
  mobileFormat(value: string, name: string) {
    var r = /(\D+)/g,
      npa = "",
      last4 = "";
    value = value.replace(r, "");
    npa = value.substr(0, 3);
    last4 = value.substr(3, 10);
    value = last4 ? npa + "-" + last4 : npa;
    if (value.replace("-", "").trim() == "") value = "";
    if (name == "mobile") {
      this.formRegistration.controls["mobileNumber"].setValue(value);
    } else if (name == "home") {
      this.formRegistration.controls["homeContact"].setValue(value);
    } else if (name == "work") {
      this.formRegistration.controls["workContact"].setValue(value);
    }
  }

  mobileDelete(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const caretPosition = input.selectionStart;
    const selectionEnd = input.selectionEnd;

    if (caretPosition === null || selectionEnd !== caretPosition) return;

    let deletePosition = caretPosition;
    if (deletePosition >= input.value.length) deletePosition--;
    if (input.value.charAt(deletePosition) === "-") deletePosition--;
    if (deletePosition < 0) return;

    event.preventDefault();
    const value =
      input.value.slice(0, deletePosition) + input.value.slice(deletePosition + 1);
    this.mobileFormat(value, "home");

    const formattedValue = this.formRegistration.controls["homeContact"].value;
    input.setSelectionRange(
      Math.min(deletePosition, formattedValue.length),
      Math.min(deletePosition, formattedValue.length)
    );
  }

  /**
   * To load passcode on district select
   *
   * @param {object} event
   */
  primaryDistrictSelected(event) {
    if (event.postCode)
      this.formRegistration.patchValue({
        pincodePrimary: event.postCode,
      });
  }

  /**
   * To load passcode on district select
   *
   * @param {object} event
   */
  secondaryDistrictSelected(event) {
    if (event.postCode)
      this.formRegistration.patchValue({
        pincodeSecondary: event.postCode,
      });
  }

  secondaryDistrictAreaSelected(event) {
    if (event.postCode)
      this.formNextOfKin.patchValue({
        postcode: event.postCode,
      });
  }

  /**
   * To reset registeration form
   */
  resetRegisterationForm() {
    this.patientForm = !this.patientForm;
    this.formRegistration.reset();
    this.patientImage = "";
    this.genderValue = null;
    this.raceValue = null;
    this.religionValue = null;
    this.countryValue = null;
    this.stateValue = null;
    this.cityValue = null;
    this.countrySecondaryValue = null;
    this.stateSecondaryValue = null;
    this.citySecondaryValue = null;
    this.districtSeoncdaryValue = null;
    this.initSearchFilter();
    this.tokenValue = "";
    this.cardReaderStatus = false;
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} city as object
   * @memberof PatientRegistrationComponent
   */
  // getSubDistrictForNOK(city) {
  //   if (city) {
  //     this.nokCityCode = {
  //       field: OPD_API_URL.M_CITY_VALUE,
  //       value: city.id,
  //     };
  //   }
  // }

  /**
   * To load pincode based on district
   * @param district as object
   * @memberof PatientRegistrationComponent
   */
  NOKDistrictSelected(district) {
    this.formNextOfKin.patchValue({
      postcode: district.postCode,
    });
  }

  /**
   *Validation of Add Health Tourist tab
   *
   * @return {*}
   * @memberof PatientRegistrationComponent
   */
  addItemValidate() {
    var isvalid = true;

    this.formHealthTourist.controls["identificationNumber"].markAsTouched();
    this.formHealthTourist.controls["agentName"].markAsTouched();
    this.formHealthTourist.controls["startDate"].markAsTouched();
    this.formHealthTourist.controls["endDate"].markAsTouched();
    this.formHealthTourist.controls["identificationNumber"].markAsTouched();
    this.formHealthTourist.controls["contactNo"].markAsTouched();

    if (!this.formHealthTourist.valid) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleasefillallmandatory"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
      isvalid = false;
    }
    if (!this.formHealthTourist.controls["emailId"].valid) {
      this.snackBar.open(this.langService.get("CommonAppoinment.PleaseEnterValid"),  this.langService.get("CommonAppoinment.validation"), {
        duration: 2000,
      });
      isvalid = false;
    }
    return isvalid;
  }

  /**
   *get nok list after search
   *
   * @memberof PatientRegistrationComponent
   */
getNOKList() {
  this.nokList = [];
  this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
  this.subscriptionList.add(
    this.appBaseService
      .getResource(OPD_API_URL.GET_NOK_LIST + "patientId=" + this.patientId)
      .subscribe((res) => {
        const observables: Observable<PatientNextOfKin>[] = [];

        if (res) {
          res.forEach((element) => {
            if (element.active === true) {

              const nextOfKin: PatientNextOfKin =
                this.patientRegService.getNextOfKinValues(this, element);

              if (nextOfKin.country?.code) {
                const updatedKin$ = this.getNOKStateListForGet(nextOfKin.country.code, nextOfKin.state.code).pipe(
                  switchMap((matchedState) => {
                    if (matchedState) {
                      nextOfKin.state.code = matchedState;
                      return this.getNOKCityListForGet(matchedState, nextOfKin.city.code);
                    } else {
                      return of(null);
                    }
                  }),
                  switchMap((matchedCity) => {
                    if (matchedCity) {
                      nextOfKin.city.code = matchedCity;
                      return this.getNOKAreaListForGet(matchedCity, nextOfKin.area.code);
                    } else {
                      return of(null);
                    }
                  }),
                  map((matchedArea) => {
                    if (matchedArea) {
                      nextOfKin.area.code = matchedArea;
                    }
                    return nextOfKin;
                  })
                );
                observables.push(updatedKin$);
              } else {
                observables.push(of(nextOfKin));
              }
            }
          });

          if (observables.length > 0) {
            forkJoin(observables).subscribe((finalList: PatientNextOfKin[]) => {
              finalList.forEach(item => {
                item.checked = true;
                this.getNokforSave({ checked: true }, item);
              });
              this.nokList = finalList;
              this.dataSourceNextOfKin = new MatTableDataSource<any>(this.nokList);
            });
          } else {
            this.nokList = [];
            this.dataSourceNextOfKin = new MatTableDataSource<any>([]);
          }
        }
      })
  );
}
getNOKStateListForGet(countryCode: any, statecode): Observable<any> {
  if (countryCode && countryCode.id) {
    const url = OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + countryCode.id;
    return this.masterApiService.getTypeMaster(url).pipe(
      takeUntil(this._onDestroy),
      map((res: any[]) => {
        if (statecode && statecode.code) {
            return res.find(item => item.code === statecode.code);
          } else {
            return null;
          }
      })
    );
  } else {
    return of(null);
  }
}

getNOKCityListForGet(stateCode: any, cityCode): Observable<any> {
  if (stateCode && stateCode.id) {
    const url = OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + stateCode.id;
    return this.masterApiService.getTypeMaster(url).pipe(
      takeUntil(this._onDestroy),
      map((res: any[]) => {
        if (cityCode) {
            return res.find(item => item.code === cityCode);
          } else {
            return null;
          }
      })
    );
  } else {
    return of(null);
  }
}

getNOKAreaListForGet(cityCode: any, areaCode): Observable<any> {
  if (cityCode && cityCode.id) {
    const url = OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + cityCode.id;
    return this.masterApiService.getTypeMaster(url).pipe(
      takeUntil(this._onDestroy),
      map((res: any[]) => {
        if (areaCode) {
            return res.find(item => item.code === areaCode);
        } else {
          return null;
        }
      })
    );
  } else {
    return of(null);
  }
}



  /**
   *
   *
   * @param {*} event
   * @param {*} value
   * @memberof PatientRegistrationComponent
   */
  getNokforSave(event, value) {
    if (event.checked) {
      value.active = true;
      this.kinData.push(value);
    } else {
      value.active = false;
      const indexToRemove = this.kinData.findIndex((nok) => nok.name === value.name);
      if (indexToRemove !== -1) {
        this.kinData.splice(indexToRemove, 1);
      }
    } 
    
    // const existingIndex = this.dataSourceNextOfKin.data.findIndex((nok) => nok.id === value.id);
    const existingIndex = this.dataSourceNextOfKin.data.findIndex((nok) => {
      if (value.id !== undefined && value.id !== null) {
        return nok.id === value.id;
      } else {
        return nok.iid === value.iid;
      }
    });
    if (existingIndex !== -1) {
      this.dataSourceNextOfKin.data[existingIndex] = value;
    } else {
      this.dataSourceNextOfKin.data.push(value);
    }
  }
  
  /**
   *
   *
   * @param {*} element
   * @memberof PatientRegistrationComponent
   */
  // setGuarantorValue(element) {
  //   if(element.checked)
  //   element.isGuarantor=true;
  //      else {
  //       this.snackBar.open(this.langService.get("CommonAppoinment.PleaseSelectGuarenter"), this.langService.get("CommonAppoinment.validation"), {
  //         duration: 2000,
  //       });
  //     }
  // }
  setGuarantorValue(selectedElement: any,event) {
     if (this.isKinGuarantorRequired) {
    if (event.checked) {
      selectedElement.isGuarantor = true;
    }else {
      selectedElement.isGuarantor = false;
    }
    if(!selectedElement.isGuarantor) {
      const guarantorCount = this.kinData.filter(item => item.isGuarantor).length;
      if(guarantorCount < 1) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.PleaseSelectGuarenter"),
          this.langService.get("CommonAppoinment.validation"),
          { duration: 2000 }
        );
      }
    }
  }
  } 

  /**
   *Add Values In Health Tourist Tab
   *
   * @param {*} value
   * @memberof PatientRegistrationComponent
   */
  addHealthTourist(value) {
    if (this.addItemValidate()) {
      if (value) {
        const currentDate = new Date();
        const formattedCurrentDate = currentDate.toLocaleString();
        value.currentDate = formattedCurrentDate;
        this.healthTouristList.push(value);
        this.healthTouristSource = new MatTableDataSource<any>(
          this.healthTouristList
        );
        this.formHealthTourist.reset();
      }
    }
    return this.formHealthTourist.valid;
  }

  /**
   *
   *
   * @param {*} value
   * @memberof PatientRegistrationComponent
   */
  deleteHealthTourist(value) {
    if (this.patientId) {
      this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
      this.subscriptionList.add(
        this.appBaseService
          .deleteResource(
            OPD_API_URL.DELETE_HEALTH_TOURIST +
              "healthTouristId=" +
              value.healthTouristId +
              "&id=" +
              this.patientId
          )
          .subscribe((res) => {
            this.snackBar.open(
              res.message,
              this.langService.get("CommonAppoinment.success"),
              {
                duration: 1000,
              }
            );
            const index: number = this.healthTouristList.indexOf(value);

            if (index != -1) {
              this.healthTouristList.splice(index, 1);
              this.healthTouristSource = new MatTableDataSource(
                this.healthTouristList
              );
            }
          })
      );
    } else {
      const index: number = this.healthTouristList.indexOf(value);

      if (index != -1) {
        this.healthTouristList.splice(index, 1);
        this.healthTouristSource = new MatTableDataSource(
          this.healthTouristList
        );
      }
    }
  }

  /**
   *
   *
   * @param {number} epoch
   * @return {*}  {string}
   * @memberof PatientRegistrationComponent
   */
  epochToDateConverter(epoch: number): string {
    try {
      const epochString = epoch.toString().replace(/\D/g, "");
      const length = epochString.length;
      if (length == 10) {
        var d = new Date(0);
        d.setUTCSeconds(epoch);
      } else {
        var d = new Date(0);
        d.setUTCMilliseconds(epoch);
      }
      const datePipe = new DatePipe("en-US");
      const formattedDate = datePipe.transform(
        d,
        "EEE, LLLL dd, yyyy , hh:mm a"
      );
      return formattedDate;
    } catch (ex) {
      return "";
    }
  }

  /**
   *
   *
   * @param {*} value
   * @memberof PatientRegistrationComponent
   */
  selectNationality(value) {
    if(value && value.code) {
    this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
    this.appBaseService
      .getResource(MASTERSSERVICES.NATIONALITY_WISE_RACE_MASTER + value.code)
      .subscribe((res) => {
        this.nationalityWiseRace = res;
      });
      if(this.raceValue)
      {
      this.formRegistration.patchValue({
        race: this.raceValue
      });
    }
  }
  }

  /**
   *
   *
   * @param {*} event
   * @memberof PatientRegistrationComponent
   */
  searchByPostCode(event) {
    if (event.checked) {
      this.isGetAddress = event.checked;
    } else {
      this.isGetAddress = false;
    }
  }

  /**
   *get Addess By PostCode
   *
   * @param {*} value
   * @memberof PatientRegistrationComponent
   */
  getAddressByPostCode(value) {
    let stringValue = value.toString();
    if (stringValue.length >= 4 && this.isGetAddress) {
      let postCode = value ? value : 0;
      this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
      this.appBaseService
        .getResource(OPD_API_URL.GET_ADDRESS_BY_POSTCODE + postCode)
        .subscribe((res) => {
          if (res.payload != null) {
            this.isAddeassByPostCode = true;
            this.getCountryValue = res.payload.country
              ? res.payload.country.code
              : "";
            this.countryValue = this.getCountryValue;
            this.countryDefaultValue = this.getCountryValue;
            this.getStateValue = res.payload.state ? res.payload.state : "";
            this.stateValue = this.getStateValue.code;
            this.stateDefaultValue = this.getStateValue.code;
            this.getCityValue = res.payload.city ? res.payload.city : "";
            this.getDistrictValue = res.payload.area ? res.payload.area : "";

            this.getStatePrimaryList(this.getCountryValue, true);
            this.getNOKStateList(this.getCountryValue);
          } else {
          //   if(this.formRegistration.controls["statePrimary"].value ||
          //     this.formRegistration.controls["cityPrimary"].value) && 
          //   this.checkAddressRemove();
          // else
          //   this.snackBar.open("Postcode Not Found.", "Error", { duration: 1000 });
          // }
          let isRegistrationFilled =
              this.formRegistration.controls["statePrimary"].value ||
              this.formRegistration.controls["cityPrimary"].value;

            let isNOKFilled =
              this.formNextOfKin.controls["state"].value ||
              this.formNextOfKin.controls["city"].value;

            if (isRegistrationFilled) {
              this.checkAddressRemove();
            }

            if (isNOKFilled) {
              this.checkNOKAddressRemove(); 
            }

            if (!isRegistrationFilled && !isNOKFilled) {
             this.snackBar.open("Postcode Not Found.", "Error", { duration: 1000 });
            }
          }
        });
    }
  }
  checkAddressRemove(){
    const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "15%",
      data: { displayText: "Postcode not found. Do you want to clear the address field state, city and area?"},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          this.countryValue = 0;
          this.stateValue = null;
          this.cityValue = null;
          this.districtValue = null;
          this.formRegistration.controls["statePrimary"].reset();
          this.formRegistration.controls["cityPrimary"].reset();
          this.formRegistration.controls["subDistrictPrimary"].reset();
        }
      })
    );
  }

  /**
   * Check and remove address fields if postcode is not found
   */
  checkNOKAddressRemove(){
    const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "15%",
      data: { displayText: "Postcode not found. Do you want to clear the address field state, city and area?"},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          this.countryValue = 0;
          this.stateDefaultValue = null;
          this.cityDefaultValue = null;
          this.areaDefaultValue = null;
          this.formNextOfKin.controls["state"].reset();
          this.formNextOfKin.controls["city"].reset();
          this.formNextOfKin.controls["area"].reset();
        }
      })
    );
  }
  /**
   *
   *
   * @param {*} mrn
   * @memberof PatientRegistrationComponent
   */
  getPreviousPayerList(mrn) {
    this.existingPayerList = [];
    let glattachmentList = [];
   
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.OPD_PAYER_ALL_DETAILS + mrn+"&visitType="+"OP")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        this.existingPayerList = [];
        if (res.length > 0) {
          res.forEach((ele) => {
            let referralNoList = [];
            glattachmentList = ele.glAttachmentList
              ? ele.glAttachmentList
              : null;
            if (glattachmentList && glattachmentList.length > 0) {
              glattachmentList.forEach((element) => {
                let list = {
                  glrefno: element.glAttachmentNo ? element.glAttachmentNo : "",
                  glbalance: element.availableBal ? element.availableBal : 0,
                  effectiveDate: element.effectiveDate
                    ? new Date(element.effectiveDate)
                    : "",
                  expiryDate: element.expiryDate ? new Date(element.expiryDate) : "",
                
                  glTypeCode: element.glType ? element.glType.code : "",
                  polictyNo: element.glReferenceNo ? element.glReferenceNo : "",
                };
                referralNoList.push(list);
              });
            }
            let obj = {
              payerTypeCode: ele.payerType ? ele.payerType.code : "",
              payerCode: ele.payer ? ele.payer.code : "",
              tariffCode: ele.tariff ? ele.tariff.code : "",
              glTypeCode: referralNoList && referralNoList.length > 0 ?
              referralNoList[0].glTypeCode
              : (ele.company && ele.company.isAutoApproval
                  ? statisGlApprovalType.AG
                  : statisGlApprovalType.PG),
              effectiveDate:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].effectiveDate
                  : "",
              expiryDate:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].expiryDate
                  : "",
              isexpirypayerDate:true,
              glAmount:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].glbalance
                  : "",
              glReferenceNo:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].glrefno
                  : "",
              policyNumber:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].polictyNo
                  : "",
              contractCode: ele.contract ? ele.contract.code : "",
              associatedCompanyCode: ele.associatedCompany
                ? ele.associatedCompany.code
                : "",
              isSelf: ele.payerType.code === "SELF" ? true : false,
              referralNoList: referralNoList,
              priority:ele.priority
            };
            this.existingPayerList.push(obj);
          });
          this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(
            this.existingPayerList
          );
          // this.getContractListData();
          this.getPayerList();
          this.getTariffmaster();
          this.existingPayerList.forEach((element ,i)=> {
          this.getPayerTypePayer(element.payerTypeCode,i);
          });
        }
      });
  }

  /**
   *
   *
   * @param {*} glReferenceNo
   * @param {*} index
   * @param {*} refrenceList
   * @param {*} isFromGlchange
   * @memberof PatientRegistrationComponent
   */
  glDetails(glReferenceNo, index, refrenceList,isFromGlchange) {
    if (glReferenceNo) {
      let data =
        refrenceList && refrenceList.length > 0
          ? refrenceList.find((s) => s.glrefno == glReferenceNo)
          : null;
      this.dataSourcePayers.data[index].referralNoList = refrenceList;
      this.dataSourcePayers.data[index].glTypeCode =
        data && data.glTypeCode ? data.glTypeCode : "";
      this.dataSourcePayers.data[index].effectiveDate =
        data && data.effectiveDate ? data.effectiveDate : null;
      this.dataSourcePayers.data[index].expiryDate =
        data && data.expiryDate ? data.expiryDate : null;
      this.dataSourcePayers.data[index].glAmount =
        data && data.glbalance ? data.glbalance : 0;
      this.dataSourcePayers.data[index].policyNumber =
        data && data.polictyNo ? data.polictyNo : "";
        if(!isFromGlchange)
        this.dataSourcePayers.data[index].glReferenceNo=
        refrenceList && refrenceList.length > 0
          ? refrenceList[0].glrefno
          : ""
    } else {
      this.dataSourcePayers.data[index].glTypeCode = statisGlApprovalType.PG;
      this.dataSourcePayers.data[index].effectiveDate = null;
      this.dataSourcePayers.data[index].expiryDate = null;
      this.dataSourcePayers.data[index].glAmount = 0;
      this.dataSourcePayers.data[index].policyNumber = "";
    }
  }

  /**
   *
   *
   * @param {*} mrn
   * @param {*} payerCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  getGlDetailsByPayer(mrn, element, index) {
    let glattachmentList = [];
    let referralNoList = [];
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(
        OPD_API_URL.OPD_PAYER_ALL_DETAILS_PAYERCODE +
          mrn +
          "&payerCode=" +
          element.payerCode+"&visitType="+"OP"
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res.length > 0) {
          res.forEach((ele) => {
            glattachmentList = ele.glAttachmentList
              ? ele.glAttachmentList
              : null;
            if (glattachmentList && glattachmentList.length > 0) {
              glattachmentList.forEach((element) => {
                let list = {
                  glrefno: element.glAttachmentNo ? element.glAttachmentNo : "",
                  glbalance: element.availableBal ? element.availableBal : 0,
                  effectiveDate: element.effectiveDate
                    ? element.effectiveDate
                    : "",
                  expiryDate: element.expiryDate ? element.expiryDate : "",
                  glTypeCode: element.glType ? element.glType.code : "",
                  polictyNo: element.glReferenceNo ? element.glReferenceNo : "",
                };
                referralNoList.push(list);
              });
              this.glDetails(referralNoList[0].glrefno, index, referralNoList,false);
            } else {
              let selectedPayer=element.payerList.find(e => e.code == element.payerCode );
              this.dataSourcePayers.data[index].glTypeCode = selectedPayer?.isAutoApproval ? statisGlApprovalType.AG :statisGlApprovalType.PG;
              this.dataSourcePayers.data[index].effectiveDate = null;
              this.dataSourcePayers.data[index].expiryDate = null;
              this.dataSourcePayers.data[index].glAmount = 0;
              this.dataSourcePayers.data[index].policyNumber = "";
              this.dataSourcePayers.data[index].referralNoList = [];
            }
          });
        }
      });
  }

  /**
   *
   *
   * @param {*} payerCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  getContractPayer(payerCode,index){
    this.dataSourcePayers.data[index].contractList = [];
    this.dataSourcePayers.data[index].contractCodeList = [];
    let payerId =  this.dataSourcePayers.data[index].payerList.find(i=> i.code ==payerCode);
    this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
    this.appBaseService
      .getResource(
        OPD_API_URL.GET_PAYERTYPE_TYPE  +
        "payerId="+payerId.id+"&visitTypeCode=OP"
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        let data = res;
        this.dataSourcePayers.data[index].contractList = data;
        this.dataSourcePayers.data[index].contractCodeList = data;
      })
  }

  /**
   *
   *
   * @param {*} payerCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  getPayerTypePayer(payerCode,index){
    this.dataSourcePayers.data[index].payerList = []
    this.dataSourcePayers.data[index].payerFilteredList = []
    let payerTypeId = this.payerTypeList.find(i=>i.code == payerCode);
   
    this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
    this.appBaseService
      .getResource(
        OPD_API_URL.GET_CONTRACT_PAYER  +
        payerTypeId.id
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        let data = res;
        this.dataSourcePayers.data[index].payerList = data;
        this.dataSourcePayers.data[index].payerFilteredList = data;
        this.getContractPayer(this.dataSourcePayers.data[index].payerCode,index);
      })
  }

  /**
   *
   *
   * @param {*} event
   * @memberof PatientRegistrationComponent
   */
  setPatternToMobileNumber(event){
    if (event.regex) {
      const regexPattern = event.regex.replace(/^\/|\/$/g, '');
      this.formRegistration.controls["mobileNumber"].setValidators([
        Validators.required,
        Validators.pattern(new RegExp(regexPattern))
      ]);
      const matches = event.regex.toString().match(/\{(\d+),(\d+)\}/);
      if (matches && matches.length > 1) {
        this.mobileNoMax = Number(matches[2]);
        this.mobileNoMin = Number(matches[1]);
      }else{
      this.formRegistration.controls["mobileNumber"].clearValidators();
      }
    } else {
      this.formRegistration.controls["mobileNumber"].clearValidators();
      this.formRegistration.controls["mobileNumber"].setValidators([
        Validators.required,
      ]);
    }
    this.formRegistration.controls["mobileNumber"].updateValueAndValidity();
  }

  // checkNumberValid(){
  //   if(!this.formRegistration.controls.mobileNumber.valid){
  //     this.snackBar.open("Please enter valid mobile number","validation",{duration:1000});
  //   }
  // }
  
  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  checkValidEmployee(){
    if(this.isStaffActive){
      let employyeType=this.formRegistration.controls["secondaryId"].value
      let employeeNumber=this.formRegistration.controls["secondaryNumber"].value;

      if(employyeType == secondIdType.Staff || employyeType == secondIdType.Doctor){
        if (employyeType && employeeNumber) {
          this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
          this.appBaseService
            .getResource(OPD_API_URL.CHECK_EMPLOYEE_VALID+"type="+employyeType+"&employeeNo="+employeeNumber)
            .pipe(takeUntil(this._onDestroy))
            .subscribe((res) => {
            if(!res.payload){
              this.snackBar.open(res.message,"Error",{duration: 2000,});
              this.isEncounterAllow=true; 
              document.getElementById("validate").style.border=" 1px solid red";
              document.getElementById("validate").style.borderRadius="5px";
            }else{
              this.isEncounterAllow=false;
              document.getElementById("validate").style.border="";
              this.formRegistration.controls["active"].setValue('true');
            }
          });
        } else{
          this.isEncounterAllow=false;
          this.formRegistration.controls["active"].setValue('true');
          document.getElementById("validate").style.border="";
          this.formRegistration.controls["secondaryId"].setValue('');
          this.formRegistration.controls["secondaryNumber"].setValue('');
        }
      } else{
        this.isEncounterAllow=false;
        document.getElementById("validate").style.border="";
        this.formRegistration.controls["active"].setValue('true');
      }
    }
  }
  
  /**
   *
   *
   * @param {*} value
   * @param {*} isCountryId
   * @memberof PatientRegistrationComponent
   */
  getCountryCode(value,isCountryId){
    let id;
    if(isCountryId == true){
      id=value.id;
    }else{
    let selectedCountry= this.countryPrimaryList.find(x=>x.code==value)
    id=selectedCountry.id;
    }
    if(id){
    this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.GET_COUNTRY_CODE+id)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if(res && res.length>0){
          this.countryCodeValue=res[0].code;
          this.setPatternToMobileNumber(res[0])
        }else{
          this.countryCodeValue="";
        }
      });
    }
  }
  
  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getPatientAuditTrails(){
    if(this.PatientData?.length != 0){
    this.admissionReqload = this.PatientData;
    localStorage.setItem(
      OPD_CONST.PatientAudit,
      JSON.stringify(this.PatientData)
    );
    this.router.navigate([opdNavigation.PATIENT_AUDIT]);
  }else{
       this.snackBar.open(
        this.langService.get("EncounterPage.pleaseSelectPatient"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
  }
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getDocTypeListForRegistration(){
    this.appBaseService.setResourceURL(MICROSERVICES.DOC_SERVICE);
    this.appBaseService
      .getResource(APPLICATIONSERVICE.DOCUMENT_TYPE_CATEGORY_PAT,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        this.docListRegistration = res;
      });
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getDocTypeListForEncounter(){
    this.appBaseService.setResourceURL(MICROSERVICES.DOC_SERVICE);
    this.appBaseService
      .getResource(APPLICATIONSERVICE.DOCUMENT_TYPE_CATEGORY_VIS,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        this.docListEncounter = res;
      });
  }

  /**
   *
   *
   * @param {*} element
   * @memberof PatientRegistrationComponent
   */
  viewFile(element){
    const fileExtension = element.fileName.split('.').pop();
    if(fileExtension ==="xlsx" || fileExtension ==="doc"){
      this.downloadFile(element)
    }else{
      const dialogRef =this.dialog.open(ViewDocumentComponent, {
        height: "80vh",
        width: "50%",
        data:{value:element.id}
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe(() => {})
      );
    }
  }

  /**
   *
   *
   * @param {*} event
   * @memberof PatientRegistrationComponent
   */
 deceasedRemove(event: any): void {
  if (!event.checked && this.selectedPatient && !this.isAllowToDecease) {
    this.formRegistration.controls['isDeceased'].setValue(true);
    this.snackBar.open('You are not authorized to update the deceased status.', 'Validation', { duration: 2000 });
    return;
  }
   if(!event.checked){
      this.isEncounterAllow=event.checked;
    }
}
 clickRadioactiveImplant(event){
  if (!event.checked) {
    this.formRegistration.controls['isRadioactiveImplant'].setValue(true);
  }
}

  /**
   *
   *
   * @param {MatTabChangeEvent} e
   * @memberof PatientRegistrationComponent
   */
  onTabChange(e: MatTabChangeEvent){
    if(e.index == 0){
      this.showDefaultDeposit = true;
    }
    else{
      this.showDefaultDeposit = false;
    }
  }
  primaryIdSelect(value){
    this.isPrimaryNoEditable=value?true:false;
  }
  toUpperCase(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }
  toUpperCaseAddress(event: any) {
  const value = event.target.value.toUpperCase();
  this.formRegistration.get('addressPrimary')?.setValue(value, { emitEvent: false });
}

  onNewbornChange(isChecked: boolean) {
    this.isNewBorn=isChecked;
    if(isChecked && this.babyOfPrefixCode){
      this.titleValue=this.babyOfPrefixCode;
      this.mandatoryField.identificationType=false;
      this.mandatoryField.identificationNo=false;
    }else{
      this.formRegistration.controls["prefix"].setValue("");
      this.titleValue="";
      this.mandatoryField.identificationType=true;
      this.mandatoryField.identificationNo=true;
    }
    if(!isChecked){
      let primaryNo=this.formRegistration.controls["primaryNumber"]?.value;
      let primaryIdCode = this.formRegistration.controls["primaryId"]?.value;
      if (primaryIdCode && primaryNo) {
        this.generalApiService
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE + primaryIdCode + "&value=" + primaryNo.replace(/-/g, '')
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((response:any) => {
            if(response && response.status==409){
              this.formRegistration.controls["primaryNumber"].setValue(null);
            }else{
              this.formRegistration.controls["primaryNumber"].setValue(primaryNo);
            }
          });
      }
    }
  }
  
  getCounsultationchrgeOnEncounterType(event){
    let departmentCode = this.formEncounter.controls["department"]?.value;
    let doctorCode = this.formEncounter.controls["doctor"]?.value;
    if( event.isConsultation){
      this.getConsultationCharges(departmentCode,doctorCode);
    }else{
      this.formEncounter.controls["newVisitConsultationCharge"].setValue(null);
    }
   }
  addIdentification(element): void {
  const { idType, idNumber, expDate, issuingCountry, type, isIdNumberValid } = element;

  if (!idType || !idNumber.replace(/-/g, '')) {
    this.snackBar.open("Please enter identification details", "validation", { duration: 2000 });
    return;
  }

  if (!isIdNumberValid) {
    this.snackBar.open("Please enter valid identification Number", "validation", { duration: 2000 });
    return;
  }

  const idTypeCode = this.getObjByCode(
    type === 'P' ? this.primaryIdFilteredList : this.secondaryIdFilteredList,
    idType
  );

  if (idTypeCode.isExpireReq && !expDate) {
    this.snackBar.open("Please enter expiry date", "validation", { duration: 2000 });
    return;
  }

  if (idTypeCode.isCountryRequired && !issuingCountry) {
    this.snackBar.open("Please enter issuing country", "validation", { duration: 2000 });
    return;
  }

  const hasEmptyEntry = this.identificationList.data.some(
    item => !item.idType && !item.idNumber
  );

  if (hasEmptyEntry) {
    this.snackBar.open("Blank identification entry already exists", "validation", { duration: 2000 });
    return;
  }
   const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "Do you want to Add another identification entry?" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          this.addEmptyIdentificationEntry("S");
          this.secondaryIdentifierListModified = true;
        }
      })
    );
}

  
  hasPrimarySelected(): boolean {
    return this.identificationList.data.some(item => item.type === 'P');
  }
  isIdTypeSelected(code: string, currentIndex: number): boolean {
    if(this.identificationList.data[currentIndex].type=="S"){
    return this.identificationList.data
      .some((item, index) => index !== currentIndex && item.idType === code);
    }
  }
  onTypeChange(element: string, index: number): void {
    this.identificationList.data[index].type=element;
    if (element === 'P') {
      this.identificationList.data.forEach((item, i) => {
        if (i !== index && item.type === 'P') {
          item.type = 'S';
        }
      });
    }
    this.identificationList.data[index].idType="";
    this.identificationList.data[index].idNumber="";
    this.identificationList.data[index].expDate="";
    this.identificationList.data[index].issuingCountry="";
    this.identificationList.data = [...this.identificationList.data]; 
  }
  setCountryValue(event: any, index: number, element: any): void {
    this.identificationList.data[index].issuingCountry = event;

    if (element.identifierUUID && this.patientId) {
      element.identifierOverride = true;
      element.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
    }
  }
  onExpiryDateChange(selectedDate: Date, element: any): void {
    element.expDate = selectedDate;
    if (element.identifierUUID && this.patientId) {
      element.identifierOverride = true;
      element.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
    }
  }
  deleteIdentification(index: number,element): void {
    if(this.selectedPatientIdentificationList && element.identifierUUID){
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "deleteConfirm" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result != undefined && result.confirm && result.confirm == "yes") {
            this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
            this.appBaseService
              .deleteResource(OPD_API_URL.DELETE_IDENTIFICATION+this.patientId+"&identifierUUID="+element.identifierUUID)
              .subscribe((res) => {
                if(res.statusCode="200"){
                  this.snackBar.open(res.message,"Success",{duration:2000});
                if (index !== 0) {
                  const data = this.identificationList.data;
                  data.splice(index, 1);
                  this.identificationList.data = [...data];
                }
              }
              });
          }
        })
      );
    }else{
    if (index !== 0) {
      const data = this.identificationList.data;
      data.splice(index, 1);
      this.identificationList.data = [...data];
    }
  }
  }
  copyPrimaryId(element: any, index: number): void {
     const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "Do you want to copy the primary identification?" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
         
    if(element.idType && element.idNumber){
    const original = this.selectedPatientIdentificationList.find(
      (item) => item.type === 'P' && !item.isCopied 
    );
  
    if (original) {
      const copiedElement = { ...original };
      copiedElement.isCopied = true;
      copiedElement.status = false;
      this.selectedPatientIdentificationList.push(copiedElement);
      original.idType = '';
      original.idNumber = '';
      original.expDate = '';
      original.issuingCountry = '';
      original.identifierUUID=undefined;
      original.isExpiryRequired=false;
      original.isCountryRequired=false;
      original.isCopied=false;
      this.primaryIdentifierListModified = true;
      this.identificationList.data = this.selectedPatientIdentificationList;
    }
    }
        }
      })
    );
  }
  addEmptyIdentificationEntry(type: 'P' | 'S'): void {
    this.identificationList.data.push({
      type: type,
      idType: '',
      idNumber: '',
      expDate: '',
      issuingCountry: '',
      maxIdentificationLength: 25,
      minIdentificationLength: 0,
      primaryIdRegex: OPD_CONST.primaryIdRegix,
      isIdNumberValid:true
    });
  
    this.identificationList.data = [...this.identificationList.data];
  }
 
  checkDuplicatePatient(from, idDetails?) {
    if (from !== dupicatePatient.identificationNo) {
      return;
    } // Temporary: Restrict duplicate check to Identification Number only.Remove this when duplicate checks for DOB/Mobile/Email are needed again.
    if (this.duplicateCheckCalled[from]) return;
    if(idDetails && idDetails.idType && idDetails.idNumber){
    if(idDetails.identifierUUID && idDetails.identifierUUID.length>0){return;}
    }
    let request: any = {};

    if (from === dupicatePatient.identificationNo) {
      request = {
        identificationId: idDetails.idNumber.includes("-") ? idDetails.idNumber.split("-").join("") : idDetails.idNumber,
        identificationType: idDetails.idType
      };
      if (!idDetails.idNumber.replace(/-/g, '') || !idDetails.idType) return;
    } else if (from === dupicatePatient.dateOfBirth) {
      const firstName = this.formRegistration.controls['firstName']?.value?.trim();
      const lastName = this.formRegistration.controls['lastName']?.value?.trim();
      const firstNameTh = this.formRegistration.controls['firstNameTh']?.value?.trim();
      const lastNameTh = this.formRegistration.controls['lastNameTh']?.value?.trim();
      const fullName= this.formRegistration.controls['fullName']?.value?.trim();
    
      let name = '';
    
      if (firstName || lastName) {
        name = `${firstName ?? ''} ${lastName ?? ''}`.trim();
      } else if (firstNameTh || lastNameTh) {
        name = `${firstNameTh ?? ''} ${lastNameTh ?? ''}`.trim();
      }else if(fullName){
        name=fullName;
      } 
           const gender = this.formRegistration.controls['gender']?.value?.code;
      const birthDate = this.datepipe.transform(this.formRegistration.controls['dateOfBirth']?.value, "yyyy-MM-dd");

      if (!name || !gender || !birthDate) return;
      request = { name, gender, birthDate };
    } else if (from === dupicatePatient.mobileNumber) {
      const birthDate = this.datepipe.transform(this.formRegistration.controls['dateOfBirth']?.value, "yyyy-MM-dd");
      const mobile = this.formRegistration.controls['mobileNumber']?.value?.replace(/-/g, '');

      if (!mobile || !birthDate) return;
      request = { mobile, birthDate };
    }else if (from === dupicatePatient.emailId){
      const birthDate = this.datepipe.transform(this.formRegistration.controls['dateOfBirth']?.value, "yyyy-MM-dd");
      const email = this.formRegistration.controls['emailId']?.value?.trim();
      if (!email || !birthDate) return;
      request = { email, birthDate };
    }
    let isNewBorn = this.formRegistration.controls['isNewborn']?.value==true?true:false;

    this.dupicatePatientService.checkForDuplicatePatients(request, from, isNewBorn,this.isUnitWisePatientSearch, this.selectedPatient).subscribe((response: any) => {
      const markAllChecked = () => {
        this.duplicateCheckCalled = {
          identificationNo: true,
          dateOfBirth: true,
          mobileNumber: true,
          emailId:true
        };  
      };
this.duplicateCheckCalled[from] = true;
      if (response === 'No') {
        markAllChecked();
      } else if (response?.id) {
        const patientData = this.patientDataService.displayList([response]);
        this.getPatientData(patientData[0]);
        this.uhId = response.uhId ?? null;
        this.isFromAnotherunit = response.isFromAnotherUnit ?? false;
        markAllChecked();
      }
      if (response === "DUPLICATE") {
        this.duplicateCheckCalled[from] = false; 
        let existingIdentification = this.selectedPatient.primaryIdentificationList;
        this.identificationList.data.forEach(element => {
          let existId = existingIdentification.find(i => i.display == element.idType && i.value == element.idNumber);
          if (existId && element.identifierUUID && !element.isCopied) {
            element.idNumber = "";
            this.snackBar.open("Duplicate Identification Number", "Validation", { duration: 2000 });
          } else if (existId && !element.identifierUUID) {
            element.idNumber = "";
            this.snackBar.open("Duplicate Identification Number", "Validation", { duration: 2000 });
          } else if (!existId && !element.identifierUUID) {
            element.idNumber = "";
            this.snackBar.open("Duplicate Identification Number", "Validation", { duration: 2000 });
          }
        });
      }
    });
  }

displayAddressDetails(element){
  const address = element.address || '';
  const country = element.country?.code?.desc || element.country?.code?.desc || '';
  const state = element.state?.code?.desc || element.state?.code?.desc || '';
  const city = element.city?.code?.desc || element.city?.code?.desc || '';
  const postcode = element.postcode || '';
  const area = element.area?.desc || '';


  const fullAddress = [address, country, state, city,area, postcode]
    .filter(val => val)
    .join(', ');
   this.dialog.open(InfoDialogComponent, {
          width: "30%",
          data: {
            display: "Address Details",
            info: fullAddress 
          }
        });
}
editNOK(element) {
  this.isEditNok=true;
  this.nokId = element.id ? element.id : '';
    this.nokIid = element.iid ? element.iid : '';

    this.titleDefaultValue = element.prefix?.code?.code || "";
    this.relationDefaultValue = element.relation?.code?.code || "";
    this.countryDefaultValue = element.country?.code?.code || "";
    this.stateDefaultValue = element.state?.code?.code || "";
    this.areaDefaultValue = element.area?.code?.code || "";
    this.cityDefaultValue = element.city?.code?.code || "";

    this.formNextOfKin.patchValue({
      prefix: element.prefix.code || "",
      name: element.name || "",
      identificationType: element.identificationType.code || "",
      identificationNumber: element.idNumber || "",
      relation: element.relation.code || "",
      phoneNumber: element.phoneNumber || "",
      isGuarantor: element.isGuarantor || false,
      address: element.address || "",
      country: element.country.code || "",
      state: element.state.code || "",
      city: element.city.code || "",
      // area: element.area.code || "",
      district: [""],
      postcode: element.postcode || "",
    });
}
saveNextOfKin() {
    if (this.dataSourceNextOfKin.data.length > 0) {
      this.dataSourceNextOfKin.data.forEach(item => {
        item.active = true;
      });
      const listWithId = this.dataSourceNextOfKin.data.filter(item => !!item.id);

      let nextOfKin: any =
        this.patientRegService.getNextOfKinList(listWithId);

      let payload = {
        patientId: this.patientId,
        encounterId: this.encounterid,
        kinDetailsDTOList: nextOfKin
      };
      this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
      this.appBaseService
        .postResource(OPD_API_URL.NOK_SAVE_AND_UPDATE, payload)
        .subscribe((res) => {
          if (res.message) {
            this.snackBar.open(res.message, "Success", {
              duration: 2000
            });
            this.formNextOfKin.reset();
            this.isEditNok = false;
          }
        });

    } 
  }
   onTokenEnter(value) {
    this.tokenValue=value;
    let payload = {
      tokenNo: value
    }
    this.appBaseService.setResourceURL(MICROSERVICES.PATIENTINTEGRATION_SERVICE);
    this.appBaseService
      .postResource(OPD_API_URL.PATIENT_SEARCH_ON_QM_TOKEN, payload)
      .subscribe((res) => {
        this.qmsPatientDetails=res;
        this.qmsPatientDetails.tokenNo = value;
        if(res.mrn){
        this.patientForm = false;
        this.getpatientbyId(res.mrn);
        this.tokenNoValue=value;
        this.onFocusOutEventOnKey(this.tokenValue, res.mrn);
        }else if(res.trn){
         this.getpatientbyId("",res.icNo);

        }else{
          this.snackBar.open("Patient record not found for the scanned token. Do you want to proceed with registration?",
            "Validation",{duration:2000});
        }
      })
  }
dobValidation(event: any): void {
  const parsedDate = this.encryptionService.validateDOBOnManualyEnter(event.target?.value, this.minDate, this.maxDate);

  if (parsedDate) {
    this.formRegistration.controls['dateOfBirth'].setValue(parsedDate);
    this.formRegistration.controls['dateOfBirth'].setErrors(null);
  } else {
    this.formRegistration.controls['dateOfBirth'].setErrors({ invalidDate: true });
  }
}
updateNameValidators(): void {
  const controls = this.formRegistration.controls;

  if (this.isFullName) {
    controls['fullName']?.setValidators([Validators.required]);
    controls['fullName']?.updateValueAndValidity();

    ['firstName', 'lastName'].forEach(name => {
      controls[name]?.clearValidators();
      controls[name]?.updateValueAndValidity();
    });

  } else if (this.ispatientNameLtwo) {
    controls['fullName']?.clearValidators();
    controls['fullName']?.updateValueAndValidity();

    ['firstNameTh', 'lastNameTh'].forEach(name => {
      controls[name]?.setValidators([Validators.required]);
      controls[name]?.updateValueAndValidity();
    });

  } else {
    controls['fullName']?.clearValidators();
    controls['fullName']?.updateValueAndValidity();

    ['firstName', 'lastName'].forEach(name => {
      controls[name]?.setValidators([Validators.required]);
      controls[name]?.updateValueAndValidity();
    });
  }
}
restrictToAllowedChars(event: any, element: any) {
  if(element.allowedChars){
  const allowedPattern = element.allowedChars; 
  const regex = new RegExp(`[^${allowedPattern}]`, 'g');
  event.target.value = event.target.value.replace(regex, '');
  element.idNumber = event.target.value; 
  }
}
printSlip(){
  if(this.patientId){
   let reqPayload = {
      transactionId: this.patientId,
      type: OPD_REPORT_TYPE.pdf,
      reportName: OPD_REPORT_NAME.patient_Card,
      isReports: false,
    };
    localStorage.setItem(OPD_CONST.reportPayload, JSON.stringify(reqPayload));
    window.open(opdNavigation.REPORT_NAVIGATE);
  }else{
    this.snackBar.open("Please select patient to print patient card","Validation",{duration:2000});
  }
  
}
addCriticalInfo(){
  if(this.patientId){
  const dialogRef = this.dialog.open(CriticalHeilthInfoComponent, {
      height: "auto",
      width: "50%",
      data: { patientId: this.patientId ,isUpdate:false },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((res) => {
        if(res && res=="yes"){
          this.getCriticalHealthList();
        }
      }))
  }else{
    this.snackBar.open("Please select patient to add critical health information","Validation",{duration:2000});
  }
}
editCriticalHealth(element, isViewOnly){
  if(this.patientId){ 
  const dialogRef = this.dialog.open(CriticalHeilthInfoComponent, {
      height: "auto",
      width: "50%",
      data: { patientId: this.patientId ,rowData:element ,isUpdate:true, isViewOnly:isViewOnly },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res && res == "yes") {
          this.getCriticalHealthList();
        }
      }))
  }else{
    this.snackBar.open("Please select patient to edit critical health information","Validation",{duration:2000});
  }
}
getCriticalHealthList(){ {
  this.criticalHealthList = [];
  this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
  this.subscriptionList.add(
    this.appBaseService
      .getResource(OPD_API_URL.GET_CRITICAL_HEALTH_LIST +this.patientId)
      .subscribe((res: CriticalHealth[]) => {
        this.criticalHealthList = res;
        const inactiveList = this.criticalHealthList.filter(item => item.status === false);
        const activeList = this.criticalHealthList.filter(item => item.status === true);
        this.dataSourceCriticalHeailthInactive.data = inactiveList;
        this.dataSourceCriticalHeailthActive.data = activeList;
      })
  );
}
}
deleteCriticalHealth(ele){
    const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
        width: "300px",
        height: "auto",
        data: { dialogName: "Cancel Admission",
          pageName:"deleteMRDO" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result.action == 'yes') {

            let payload = {
              id: ele.id,
              conditionType: null,
              createdOn: 0,
              criticalHealthDetails: null,
              status: false,
              reason: {
                system: "EN",
                code: result.reason[0].code,
                display: result.reason[0].desc,
              },
              patientId: this.patientId
            }
            this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
            this.subscriptionList.add(
              this.appBaseService
                .putResource(OPD_API_URL.DELETE_CRITICAL_HEALTGH,payload )
                .subscribe((res) => {
                  if(res.message){
                  this.snackBar.open(res.message, "Success", {duration: 2000});
                  this.getCriticalHealthList();
                }
                 }))
          }

        }))
}
  getCabinForDepartment(deptCode: string) {
    if(this.isDepartmentWiseCabin){
    this.masterApiService
      .getTypeMaster(`cabinMaster/getCabinForDept?deptCode=${deptCode}`)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.departmentCabinList = data || [];
        this.filteredCabinList.next(this.departmentCabinList.slice());
      this.clinicSearchCtrl.setValue('', { emitEvent: false });
      const clinicControl = this.formEncounter.get('clinic');
        if (this.departmentCabinList.length === 1) {
          clinicControl?.setValue(this.departmentCabinList[0]);
        }
      });
    }else{
      this.masterApiService
      .getTypeMaster(this.masterAPI.CABIN_MASTER) 
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.departmentCabinList = data || [];
        this.filteredCabinList.next(this.departmentCabinList.slice());
      });
    }
  }
  filterCabin() {
    if (!this.departmentCabinList) {
      return;
    }
    let search = this.clinicSearchCtrl.value;
    if (!search) {
      this.filteredCabinList.next(this.departmentCabinList.slice());
      return;
    }
    search = search.toLowerCase();
    this.filteredCabinList.next(
      this.departmentCabinList.filter(
        x => x.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  formatContactNumber(value: string): string {
    if (!value) {
      return "";
    }
    value = value.replace(/\D+/g, "");
    const npa = value.substr(0, 3);
    const last4 = value.substr(3, 10);
    return npa + "-" + last4;
  }
}

// async function generateReports(reportList, encounterid) {
//   try {
//     let promises = reportList.map(async (element) => {
//       let reqPayload = {
//         transactionId: encounterid,
//         type: OPD_REPORT_TYPE.pdf,
//         reportName: element.code,
//         isReports: false,
//       };

//       await setLocalStorageItem(element.desc, reqPayload);
//       window.open(opdNavigation.REPORT_NAVIGATE);
//     });

//     // Wait for all promises to be resolved
//     await Promise.all(promises);
//   } catch (error) {
//     console.error("Error generating reports:", error);
//   }
// }

// const setLocalStorageItem = (key: string, value: any) => {
//   return new Promise<void>((resolve) => {
//     localStorage.setItem(key, JSON.stringify(value));
//     resolve();
//   });
// };

interface Website {
  value: string;
  viewValue: string;
}
